/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import { connect } from "react-redux";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Icon from "@mui/material/Icon";
import BusApiCall from "../../../helper/axios";
import actionTypes from "../../../store/actions";
import classes from "./createPackage.module.css";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import moment from "moment";
import Chip from "@mui/material/Chip";

//icons
import Info from "@mui/icons-material/Info";

//Classes
import BasicDetails from "./basicDetails";
import Loader from "../../../component/loader";
import AssociatedBucket from "./associatedBucket";
import Button from "../../../component/button";
import Grid from "@mui/material/Grid";

import Breadcrumb from "../../../component/breadcrumb";
import UnsavedChangesWarning from "../../../helper/unsavedChangesWarning";
// import DefaultProductIcon from '../../../asset/images/defaultProductIcon.svg';

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ManageCustomersHierarchy from "../../sales/manageCustomers/manageCustomersHierarchy";
import { Divider, Tooltip } from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { DefaultProductIcon } from "../../../helper/setFallbackImages";

import OfferingComponents from "./OfferingComponents";
import TreeView from "./treeView";
import StepperNew from "../../../component/stepper/stepperNew";
import OrderActionDialog from "../../../pages/sales/order/orderActionDialog";
import { DiagramIcon } from "../../../component/icons/icons";

import Drawer from "@mui/material/Drawer";
import { ChevronLeft } from "@mui/icons-material";
import { Card } from "@mui/material";
// import MenuIcon from '@mui/icons-material/Menu';
import { MenuIcon } from "../../../component/icons/icons";
import Input from "../../../component/inputpm";
import InputLabel from "@mui/material/InputLabel";
import Prompt from "../../../helper/usePrompt";
import { withNavigation } from "../../../helper/withNavigation";
import { draftRawToHTML, tiptapHTMLToDraftRaw } from "../../../component/richTextEditor/draftTiptapConverter";

import Split from "react-split";

// Create package main class
class CreatePackage extends Component {
  // Declare property values that belongs to the component
  state = {
    page: 0,
    perPage: 10,
    totalProductCountInOffering: 0,
    showOfferingSummary: false,
    tabValue: 0,
    subTabValue: 0,
    subTabValue2: 0,
    bucket: [],
    bucketName: "",
    basicDetail: {},
    bucketList: [],
    components: [],
    loading: true,
    isLastBucket: false,
    displayBuckets: false,
    renderBasicDetail: true,
    renderAssociatedConst: false,
    hierarchy: [],

    isMaster: false,
    addToCatalog: false,
    packageMode: "CREATE",
    selectionType: {},
    selectionTypeMinLimit: {},
    selectionTypeMaxLimit: {},
    addLimit: {},
    bread: [],

    // topLevel Margin
    topLevelMargin: 0,

    componentTypesData: [],
    productData: {},
    editPackagedId: "",

    expiryDate: "",
    releaseDate: "",

    // new configuration keys
    orderApproval: false,
    billingTriggerPhase: "DEFAULT",
    selectedBucket: "",
    billingTriggerProdId: "",

    termsText: "",
    termsUrl: "",
    termCondToEdit: null,
    packageId: "",
    promoName: "",
    unsavedData: {},
    tempNewValue: {},
    openUnsavedChangesModal: false,
    currentBucketItems: [],
    currentBucketItemsCount: 0,
    renderBread: false,
    routing: {
      name: "",
      description: "",
      routingTasks: [],
    },
    tabsWrapperWidth: 0,

    comment: "",
    approvedForSale: false,
    submittedForReview: false,
    showSolutionStatus: false,
    packagedSolutionStatus: false,
    preQuals: [],
    psTemplate: "",
    categoryList: [],
    originalBucketsData: [],
    channelList: [],
    globalProducts: [],
    parentTabValue: 0,
    auxiliaryTabValue: 0,
    auxBucketsList: [],
    productBucketList: [],
    isPackageBucket: false,
    isPublishBucket: false,
    renderView: false,
    customerData: [],
    showCustomerDialog: false,
    openConfirmCustomer: false,

    productTermsLocale: "en_US",
    productTerms:
      '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    // productTermsState: EditorState.createEmpty(),
    productTermsTemplate: "",
    localisedProductTerms: [
      {
        locale: "en_US",
        text: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
      },
    ],
    localisedProductTermsTemplate: [
      {
        locale: "en_US",
        text: "",
      },
    ],
    importOffering: false,
    isAddToCatalog: false,
    showCustomAttributes: false,
    error: {},

    termTenure: "",
    termTenureUOM: "",
    termNoticePeriod: "",
    termNoticePeriodUOM: "",
    promoMarkdown: "",
    isBlocking: false,
    warningMessage:
      "Are you sure you want to leave? You may have unsaved changes.",

    leafNodes: [],
    activeTabId: 0,
    steps: [],

    status: "",
    statusDisplayName: "In Draft",
    productHistoryDetails: [],
    isMobile: false,
    showCategory: false,

    readOnly: false,
    unsavedOfferingData: false,
    showBucketsOnLeft: false,
    saveAsOfferingDialog: false,
    showOfferingQty: true,
  };

  constructor(props) {
    super(props);
    this.associatedBucketRef = React.createRef();
    this.tabsWrapper = React.createRef();
  }

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    localStorage.setItem("unsavedOfferingData", false);
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
    this.getCategoriesList();
    this.getChannelsList();
    // BusApiCall("GET",`${constants.busInternalUrl}/passthru/GET_EXPORTABLE_CONFIGURATION/endpoint`, {}).then((res) => {
    //     let displayCustomAttributes = res.data["display.tab.custom_attributes"] === 'show' ? true : false;
    //     this.setState({
    //         showCustomAttributes: displayCustomAttributes
    //     })
    //   });
    //get search params

    let search = new URLSearchParams(this.props.router.location.search);
    let promoId = search.get("promoId");
    let packageId = search.get("packageId");
    let packageMode = search.get("packageMode")
      ? search.get("packageMode")
      : this.state.packageMode;
    let isMaster = search.get("isMaster")
      ? search.get("isMaster")
      : this.state.isMaster;
    let addToCatalog = search.get("addToCatalog")
      ? search.get("addToCatalog")
      : this.state.addToCatalog;
    let promoName = search.get("promoName") ? search.get("promoName") : "";
    var psTemplate = search.get("template");
    if (psTemplate && psTemplate === "QA") {
      this.setState(
        {
          renderBasicDetail: false,
        },
        () => {
          this.setState({
            psTemplate,
            renderBasicDetail: true,
          });
        },
      );
    }
    this.setState({
      editPackagedId: packageId,
      // parentTabValue: packageMode === 'promo' ? 1 : 0,
      promoName,
    });
    // let bread = [
    //     { title: "Solutions", url: "/product" },
    //     { title: `${productData.basicDetail.productName}`, url: `/product/${id}` }
    // ]
    if (packageMode === "promo") {
      this.setState({
        isBlocking: false,
      });
    }
    const showBucketsOnLeft = localStorage.getItem("showBucketsOnLeft");
    this.setState(
      {
        showBucketsOnLeft: showBucketsOnLeft === "false" ? false : true,
        isMaster: isMaster,
        addToCatalog: addToCatalog,
        packageMode: packageMode,
        isAddToCatalog: addToCatalog,
        packageId,
      },
      () => {
        //get API for the packaged solution
        if (packageMode === "edit" || packageMode === "promo") {
          this.setState({ renderBasicDetail: false });
          let getURL = `${constants.busInternalUrl}/packagedSolutions/products/${packageId}?packageMode=${packageMode}&promoId=${promoId}`;
          if (addToCatalog === "true") {
            //getURL = `${constants.busInternalUrl}/solutionProviderPackages/products/${packageId}?packageMode=${packageMode}&promoId=${promoId}&isMaster=${this.state.isMaster}`;
            //TODO: BAD CHECK - ONLY FOR MASTER/CHILD demo HARD CODED for dema
            getURL = `${constants.busInternalUrl}/solutionProviderPackages/products/${packageId}?packageMode=${packageMode}&promoId=${promoId}&isMaster=${isMaster}`;
          }
          this.setState(
            {
              loading: true,
            },
            () => {
              BusApiCall("GET", getURL)
                .then((editData) => {
                  let componentTypes = [];
                  if (addToCatalog === "true") {
                    componentTypes = JSON.parse(editData.data.componentTypes); //fetched when importing solution provider PS to sales
                    editData.data = JSON.parse(editData.data.jsonResponse);
                    this.setState({
                      originalProviderId:
                        editData.data.basicDetail.originalProviderId,
                      originalProviderName:
                        editData.data.basicDetail.originalProviderName,
                      originalProviderType:
                        editData.data.basicDetail.originalProviderType,
                    });
                  }

                  this.setState({
                    showOfferingQty: editData.data.basicDetail.showOfferingQty === false ? false : true,
                  })

                  let expiryDate = this.dateValidator(editData.data.expiryDate);
                  let releaseDate = this.dateValidator(
                    editData.data.releaseDate,
                  );

                  // Keep copy of original starting price
                  let stPrice = JSON.parse(
                    editData.data.basicDetail.startingPrice,
                  ).toFixed(2);
                  editData.data.basicDetail.startingPrice = stPrice;
                  editData.data.basicDetail.originalStartingPrice = stPrice;
                  console.log("check edit data", editData.data);
                  // return;
                  if (editData.data.basicDetail.productTerms) {
                    this.setState({
                      termTenure: editData.data.termTenure
                        ? editData.data.termTenure
                        : "",
                      termTenureUOM: editData.data.termTenureUOM
                        ? editData.data.termTenureUOM
                        : "",
                      termNoticePeriod: editData.data.termNoticePeriod
                        ? editData.data.termNoticePeriod
                        : "",
                      termNoticePeriodUOM: editData.data.termNoticePeriodUOM
                        ? editData.data.termNoticePeriodUOM
                        : "",
                      productTerms: editData.data.basicDetail.productTerms,
                      // productTermsState: EditorState.createWithContent(
                      //   convertFromRaw(
                      //     JSON.parse(editData.data.basicDetail.productTerms),
                      //   ),
                      // ),
                      productTermsTemplate:
                        editData.data.basicDetail.productTermsTemplate,
                      localisedProductTerms:
                        editData.data.basicDetail.localisedProductTerms,
                      localisedProductTermsTemplate:
                        editData.data.basicDetail.localisedProductTermsTemplate,
                    });
                  }

                  // get customer data if any
                  // let jsonData = {};
                  // let pageOptions = {
                  //     batchSize: 10,
                  //     startRecord: 1,
                  // };
                  // if (editData.data.customer && editData.data.customer.length > 0) {
                  //     BusApiCall('GET', `${constants.busV4Url}/parties/${this.props.providerType === 'SOLUTION_PROVIDER' ? this.state.tenant : partyId}/hierarchy?name=${this.state.name}&ban=${ban}&level=${level}`, jsonData, pageOptions).then(res => {

                  //     })
                  // } else {
                  //     this.setState({
                  //         customerData: []
                  //     })
                  // }

                  if (editData.data.basicDetail.localisedOverview == null) {
                    editData.data.basicDetail.localisedOverview = [];
                  }
                  if (editData.data.basicDetail.localisedTechSpecs == null) {
                    editData.data.basicDetail.localisedTechSpecs = [];
                  }
                  if (
                    editData.data.basicDetail.localisedWhatsIncluded == null
                  ) {
                    editData.data.basicDetail.localisedWhatsIncluded = [];
                  }

                  //get main image
                  if (editData.data.basicDetail.productMainImage) {
                    var imageUrl =
                      constants.imageUrl +
                      editData.data.basicDetail.productMainImage;
                    if (editData.data.basicDetail.productMainImageSource) {
                    } else {
                      this.toDataUrl(imageUrl).then((img) => {
                        var image = new Image();
                        image.src = img;
                        image.onload = function () {
                          if (image.height === 0 || image.width === 0) {
                            editData.data.basicDetail.productMainImage = "";
                            editData.data.basicDetail.productMainImageSource =
                              "";
                          }
                          editData.data.basicDetail.productMainImageSource =
                            img;
                        };
                        image.onerror = () => {
                          editData.data.basicDetail.productMainImage = "";
                          editData.data.basicDetail.productMainImageSource = "";
                        };
                      });
                    }
                  }

                  //get aditional images
                  if (editData.data.basicDetail.productAdditionalImage1) {
                    var imageUrl =
                      constants.imageUrl +
                      editData.data.basicDetail.productAdditionalImage1;
                    this.toDataUrl(imageUrl).then((img) => {
                      var image = new Image();
                      image.src = img;
                      image.onload = function () {
                        if (image.height === 0 || image.width === 0) {
                          editData.data.basicDetail.productAdditionalImage1 =
                            "";
                          editData.data.basicDetail.productAdditionalImage1Src =
                            "";
                        }
                        editData.data.basicDetail.productAdditionalImage1Src =
                          img;
                      };
                      image.onerror = () => {
                        editData.data.basicDetail.productAdditionalImage1 = "";
                        editData.data.basicDetail.productAdditionalImage1Src =
                          "";
                      };
                    });
                  }

                  if (editData.data.basicDetail.productAdditionalImage2) {
                    var imageUrl =
                      constants.imageUrl +
                      editData.data.basicDetail.productAdditionalImage2;
                    this.toDataUrl(imageUrl).then((img) => {
                      var image = new Image();
                      image.src = img;
                      image.onload = function () {
                        if (image.height === 0 || image.width === 0) {
                          editData.data.basicDetail.productAdditionalImage2 =
                            "";
                          editData.data.basicDetail.productAdditionalImage2Src =
                            "";
                        }
                        editData.data.basicDetail.productAdditionalImage2Src =
                          img;
                      };
                      image.onerror = () => {
                        editData.data.basicDetail.productAdditionalImage2 = "";
                        editData.data.basicDetail.productAdditionalImage2Src =
                          "";
                      };
                    });
                  }

                  if (editData.data.basicDetail.productAdditionalImage3) {
                    var imageUrl =
                      constants.imageUrl +
                      editData.data.basicDetail.productAdditionalImage3;
                    this.toDataUrl(imageUrl).then((img) => {
                      var image = new Image();
                      image.src = img;
                      image.onload = function () {
                        if (image.height === 0 || image.width === 0) {
                          editData.data.basicDetail.productAdditionalImage3 =
                            "";
                          editData.data.basicDetail.productAdditionalImage3Src =
                            "";
                        }
                        editData.data.basicDetail.productAdditionalImage3Src =
                          img;
                      };
                      image.onerror = () => {
                        editData.data.basicDetail.productAdditionalImage3 = "";
                        editData.data.basicDetail.productAdditionalImage3Src =
                          "";
                      };
                    });
                  }

                  if (editData.data.basicDetail.productAdditionalImage4) {
                    var imageUrl =
                      constants.imageUrl +
                      editData.data.basicDetail.productAdditionalImage4;
                    this.toDataUrl(imageUrl).then((img) => {
                      var image = new Image();
                      image.src = img;
                      image.onload = function () {
                        if (image.height === 0 || image.width === 0) {
                          editData.data.basicDetail.productAdditionalImage4 =
                            "";
                          editData.data.basicDetail.productAdditionalImage4Src =
                            "";
                        }
                        editData.data.basicDetail.productAdditionalImage4Src =
                          img;
                      };
                      image.onerror = () => {
                        editData.data.basicDetail.productAdditionalImage4 = "";
                        editData.data.basicDetail.productAdditionalImage4Src =
                          "";
                      };
                    });
                  }
                  if (editData.data.basicDetail.categoryId) {
                  } else {
                    editData.data.basicDetail.categoryId = "";
                  }
                  //this.getComponentTypesAndDetails()
                  // get the mapped component types. Else,
                  //when the Sales Channel is importing a solution provider PS (addToCatalog == true)
                  //Get the component types from the response of the PS. Not from getComponentTypesAndDetails
                  this.buildHierarchy(componentTypes);
                  this.sortSubCategories(this.state.hierarchy);
                  if (!addToCatalog || addToCatalog === "false") {
                    // this.getComponentTypesAndDetails();
                  } else {
                    if (packageMode !== "promo") {
                      var auxBuckets = [];
                      var productBucketList = [];
                      // for (var i = 0; i < componentTypes.length; i++) {
                      //     if (componentTypes[i].auxiliary) {
                      //         auxBuckets.push(componentTypes[i]);
                      //     } else {
                      //         productBucketList.push(componentTypes[i]);
                      //     }
                      // }
                      for (
                        var i = this.state.hierarchy.length - 1;
                        i >= 0;
                        i--
                      ) {
                        if (this.state.hierarchy[i].auxiliary) {
                          auxBuckets.push(this.state.hierarchy[i]);
                        } else {
                          productBucketList.push(this.state.hierarchy[i]);
                        }
                      }
                      productBucketList = productBucketList.reverse();
                      auxBuckets = auxBuckets.sort((a, b) =>
                        a && b ? a.sequenceNum - b.sequenceNum : 0,
                      );
                      // productBucketList = productBucketList.sort((a, b) => (a && b ? a.sequenceNum - b.sequenceNum : 0));
                      if (
                        this.props.userPerms.includes("CATALOG_ADMIN") ||
                        this.props.userPerms.includes("CATALOG_UPDATE")
                      ) {
                        componentTypes.push({
                          id: "PROD_COMP_PUBLISH",
                          name: "Publish",
                          displayNamePlural: "Publish",
                          iconName: "publish",
                          sequenceNum: 999,
                        });
                        this.setState({
                          isPublishBucket: true,
                        });
                      }
                    }
                    this.setState(
                      {
                        bucketList: componentTypes,
                        productBucketList,
                        auxBucketsList: auxBuckets,
                      },
                      () => {
                        //set the dynamic bucket in the state
                        this.state.bucketList.map((bucket) => {
                          this.setState(
                            {
                              displayBuckets: true,
                            },
                            () => { },
                          );
                        });
                        this.setBreadCrumbText();
                      },
                    );
                  }
                  var tempComponentsList = [];
                  //set the data in chipDate array for the UI
                  editData.data.components &&
                    editData.data.components.filter((component, i) => {
                      component.chipData = [];
                      component.promoApplied = false;
                      component.expandVariants = false;
                      component.expandOtherPrices = false;
                      // if (addToCatalog === 'true') {
                      // if (this.props.tenantRoles.includes('CHILD_PROVIDER') && component.margin) {
                      // } else {
                      //     component.margin = {
                      //         "marginValue": 0,
                      //         "minimumMarginValue": 0,
                      //         "marginType": "PERCENTAGE"
                      //     }
                      // }
                      // if (component.margin && component.margin.marginValue) {
                      //     component.margin.groupMarginValue = component.margin.marginValue;
                      // }
                      // if (component.margin && component.margin.minimumMarginValue) {
                      //     component.margin.minimumGroupMarginValue = component.margin.minimumMarginValue;
                      // }

                      try {
                        if (!component.margin) {
                          // Create margin object only if it doesn't exist
                          component.margin = {
                            marginValue: 0,
                            minimumMarginValue: 0,
                            marginType: "PERCENTAGE",
                          };
                        }

                        if (
                          component.margin &&
                          component.margin.marginValue !== undefined
                        ) {
                          component.margin.groupMarginValue =
                            component.margin.marginValue;
                        }
                        if (
                          component.margin &&
                          component.margin.minimumMarginValue !== undefined
                        ) {
                          component.margin.minimumGroupMarginValue =
                            component.margin.minimumMarginValue;
                        }
                      } catch (err) {
                        console.warn(
                          "Error processing margin for component:",
                          component.id,
                        );
                        // Ensure we have a valid margin object even if something goes wrong
                        component.margin = {
                          marginValue: 0,
                          minimumMarginValue: 0,
                          marginType: "PERCENTAGE",
                          groupMarginValue: 0,
                          minimumGroupMarginValue: 0,
                        };
                      }
                      // }
                      component.displaySequence = component.displaySequence
                        ? component.displaySequence
                        : "";
                      if (component.sourcePrices) {
                        if (component.sourcePrices.price) {
                          component.originalPrice =
                            component.sourcePrices.price;
                        }
                        if (
                          component.otherPrices &&
                          component.otherPrices.length > 0
                        ) {
                          for (
                            var m = 0;
                            m < component.otherPrices.length;
                            m++
                          ) {
                            if (
                              component.otherPrices[m].priceType in
                              component.sourcePrices
                            ) {
                              component.otherPrices[m].originalPrice =
                                component.sourcePrices[
                                component.otherPrices[m].priceType
                                ];
                            }
                          }
                        }
                      }
                      if (component.variants && component.variants.length > 0) {
                        component.variants.filter((v) => {
                          if (
                            v.sourcePrices &&
                            Object.keys(v.sourcePrices).length > 0
                          ) {
                            if (v.sourcePrices.price) {
                              v.originalPrice = v.sourcePrices.price;
                            }
                            if (v.otherPrices && v.otherPrices.length > 0) {
                              v.otherPrices.filter((om) => {
                                if (om.priceType in v.sourcePrices) {
                                  om.originalPrice =
                                    v.sourcePrices[om.priceType];
                                }
                              });
                            }
                          }
                        });
                      }
                      if (
                        component.originalPrice &&
                        component.originalPrice !== null
                      ) {
                        component.originalPrice = component.originalPrice;
                      } else if (
                        component.partnerPrice &&
                        component.partnerPrice !== null
                      ) {
                        component.originalPrice = component.partnerPrice;
                      } else {
                        component.originalPrice = component.price;
                      }
                      if (component.variants && component.variants.length > 0) {
                        component.variants.filter((v) => {
                          if (v.originalPrice && v.originalPrice !== null) {
                            v.originalPrice = v.originalPrice;
                          } else if (
                            v.partnerPrice &&
                            v.partnerPrice !== null
                          ) {
                            v.originalPrice = v.partnerPrice;
                          } else {
                            v.originalPrice = v.price;
                          }
                          v.promoApplied = false;
                          if (v.minimumPrice) {
                            if (addToCatalog === "true") {
                              v.minimumPrice = (
                                Math.round(
                                  Number(
                                    Number(v.originalPrice) +
                                    (Number(v.originalPrice) *
                                      component.margin.minimumMarginValue) /
                                    100,
                                  ) *
                                  (1 + Number.EPSILON) *
                                  100,
                                ) / 100
                              ).toFixed(2);
                            } else {
                              v.minimumPrice = (
                                Math.round(
                                  Number(v.minimumPrice) *
                                  (1 + Number.EPSILON) *
                                  100,
                                ) / 100
                              ).toFixed(2);
                            }
                          } else {
                            if (addToCatalog === "true") {
                              v.minimumPrice = (
                                Math.round(
                                  Number(
                                    Number(v.originalPrice) +
                                    (Number(v.originalPrice) *
                                      component.margin.minimumMarginValue) /
                                    100,
                                  ) *
                                  (1 + Number.EPSILON) *
                                  100,
                                ) / 100
                              ).toFixed(2);
                            } else {
                              v.minimumPrice = (
                                Math.round(
                                  Number(v.price) * (1 + Number.EPSILON) * 100,
                                ) / 100
                              ).toFixed(2);
                            }
                          }
                          if (addToCatalog === "true") {
                            v.price = (
                              Math.round(
                                Number(
                                  Number(v.originalPrice) +
                                  (Number(v.originalPrice) *
                                    component.margin.marginValue) /
                                  100,
                                ) *
                                (1 + Number.EPSILON) *
                                100,
                              ) / 100
                            ).toFixed(2);
                            v.groupPrice = (
                              Math.round(
                                Number(
                                  Number(v.originalPrice) +
                                  (Number(v.originalPrice) *
                                    component.margin.marginValue) /
                                  100,
                                ) *
                                (1 + Number.EPSILON) *
                                100,
                              ) / 100
                            ).toFixed(2);
                          } else {
                            v.price = (
                              Math.round(
                                Number(v.price) * (1 + Number.EPSILON) * 100,
                              ) / 100
                            ).toFixed(2);
                            v.groupPrice = (
                              Math.round(
                                Number(v.price) * (1 + Number.EPSILON) * 100,
                              ) / 100
                            ).toFixed(2);
                          }
                          v.promoPriceSource =
                            Math.round(
                              Number(v.price) * (1 + Number.EPSILON) * 100,
                            ) / 100;
                          if (v.otherPrices && v.otherPrices.length > 0) {
                            v.otherPrices.filter((o) => {
                              if (o.originalPrice && o.originalPrice !== null) {
                                o.originalPrice = o.originalPrice;
                              } else if (
                                o.partnerPrice &&
                                o.partnerPrice !== null
                              ) {
                                o.originalPrice = o.partnerPrice;
                              } else {
                                o.originalPrice = o.price;
                              }
                              if (o.minimumPrice && o.minimumPrice !== null) {
                                o.minimumPrice =
                                  Math.round(
                                    Number(o.minimumPrice) *
                                    (1 + Number.EPSILON) *
                                    100,
                                  ) / 100;
                                if (addToCatalog === "true") {
                                  o.minimumPrice = (
                                    Math.round(
                                      Number(
                                        Number(o.originalPrice) +
                                        (Number(o.originalPrice) *
                                          component.margin
                                            .minimumMarginValue) /
                                        100,
                                      ) *
                                      (1 + Number.EPSILON) *
                                      100,
                                    ) / 100
                                  ).toFixed(2);
                                } else {
                                  o.minimumPrice = (
                                    Math.round(
                                      Number(o.minimumPrice) *
                                      (1 + Number.EPSILON) *
                                      100,
                                    ) / 100
                                  ).toFixed(2);
                                }
                              } else {
                                if (addToCatalog === "true") {
                                  o.minimumPrice = (
                                    Math.round(
                                      Number(
                                        Number(o.originalPrice) +
                                        (Number(o.originalPrice) *
                                          component.margin
                                            .minimumMarginValue) /
                                        100,
                                      ) *
                                      (1 + Number.EPSILON) *
                                      100,
                                    ) / 100
                                  ).toFixed(2);
                                } else {
                                  o.minimumPrice = (
                                    Math.round(
                                      Number(o.price) *
                                      (1 + Number.EPSILON) *
                                      100,
                                    ) / 100
                                  ).toFixed(2);
                                }
                              }
                              if (addToCatalog === "true") {
                                o.price = (
                                  Math.round(
                                    Number(
                                      Number(o.originalPrice) +
                                      (Number(o.originalPrice) *
                                        component.margin.marginValue) /
                                      100,
                                    ) *
                                    (1 + Number.EPSILON) *
                                    100,
                                  ) / 100
                                ).toFixed(2);
                                o.groupPrice = (
                                  Math.round(
                                    Number(
                                      Number(o.originalPrice) +
                                      (Number(o.originalPrice) *
                                        component.margin.marginValue) /
                                      100,
                                    ) *
                                    (1 + Number.EPSILON) *
                                    100,
                                  ) / 100
                                ).toFixed(2);
                              } else {
                                o.price = (
                                  Math.round(
                                    Number(o.price) *
                                    (1 + Number.EPSILON) *
                                    100,
                                  ) / 100
                                ).toFixed(2);
                                o.groupPrice = (
                                  Math.round(
                                    Number(o.price) *
                                    (1 + Number.EPSILON) *
                                    100,
                                  ) / 100
                                ).toFixed(2);
                              }
                              o.promoPriceSource = o.price;
                            });
                          }
                        });
                      }
                      if (
                        component.otherPrices &&
                        component.otherPrices.length > 0
                      ) {
                        for (var o = 0; o < component.otherPrices.length; o++) {
                          if (
                            component.otherPrices[o].originalPrice &&
                            component.otherPrices[o].originalPrice !== null
                          ) {
                            component.otherPrices[o].originalPrice =
                              component.otherPrices[o].originalPrice;
                          } else if (
                            component.otherPrices[o].partnerPrice &&
                            component.otherPrices[o].partnerPrice !== null
                          ) {
                            component.otherPrices[o].originalPrice =
                              component.otherPrices[o].partnerPrice;
                          } else {
                            component.otherPrices[o].originalPrice =
                              component.otherPrices[o].price;
                          }
                          if (component.otherPrices[o].minimumPrice) {
                            if (addToCatalog === "true") {
                              component.otherPrices[o].minimumPrice = (
                                Math.round(
                                  Number(
                                    Number(
                                      component.otherPrices[o].originalPrice,
                                    ) +
                                    (Number(
                                      component.otherPrices[o].originalPrice,
                                    ) *
                                      component.margin.minimumMarginValue) /
                                    100,
                                  ) *
                                  (1 + Number.EPSILON) *
                                  100,
                                ) / 100
                              ).toFixed(2);
                            } else {
                              component.otherPrices[o].minimumPrice = (
                                Math.round(
                                  Number(
                                    component.otherPrices[o].minimumPrice,
                                  ) *
                                  (1 + Number.EPSILON) *
                                  100,
                                ) / 100
                              ).toFixed(2);
                            }
                            component.otherPrices[o].originalMinimumPrice =
                              component.otherPrices[o].minimumPrice;
                          } else {
                            component.otherPrices[o].minimumPrice = (
                              Math.round(
                                Number(
                                  Number(
                                    component.otherPrices[o].originalPrice,
                                  ) +
                                  (Number(
                                    component.otherPrices[o].originalPrice,
                                  ) *
                                    component.margin.minimumMarginValue) /
                                  100,
                                ) *
                                (1 + Number.EPSILON) *
                                100,
                              ) / 100
                            ).toFixed(2);
                            component.otherPrices[o].originalMinimumPrice =
                              component.otherPrices[o].price;
                          }
                          if (addToCatalog === "true") {
                            component.otherPrices[o].groupPrice = (
                              Math.round(
                                Number(
                                  Number(
                                    component.otherPrices[o].originalPrice,
                                  ) +
                                  (Number(
                                    component.otherPrices[o].originalPrice,
                                  ) *
                                    component.margin.marginValue) /
                                  100,
                                ) *
                                (1 + Number.EPSILON) *
                                100,
                              ) / 100
                            ).toFixed(2);
                          } else {
                            component.otherPrices[o].groupPrice = (
                              Math.round(
                                Number(component.otherPrices[o].price) *
                                (1 + Number.EPSILON) *
                                100,
                              ) / 100
                            ).toFixed(2);
                          }
                          // component.otherPrices[o].price = Math.round((Number(component.otherPrices[o].price) * (1 + Number.EPSILON)) * 100) / 100;
                          if (addToCatalog === "true") {
                            component.otherPrices[o].price = (
                              Math.round(
                                Number(
                                  Number(
                                    component.otherPrices[o].originalPrice,
                                  ) +
                                  (Number(
                                    component.otherPrices[o].originalPrice,
                                  ) *
                                    component.margin.marginValue) /
                                  100,
                                ) *
                                (1 + Number.EPSILON) *
                                100,
                              ) / 100
                            ).toFixed(2);
                          } else {
                            component.otherPrices[o].price = (
                              Math.round(
                                Number(component.otherPrices[o].price) *
                                (1 + Number.EPSILON) *
                                100,
                              ) / 100
                            ).toFixed(2);
                          }
                          component.otherPrices[o].promoPriceSource =
                            component.otherPrices[o].price;
                        }
                      }
                      if (component && component.relationShips) {
                        component.chipData = component.relationShips.dependsOn;
                      }
                      if (component.priceType === "NTC") {
                        if (component.priceTenureUOM === "MONTH") {
                          component.priceTenureUOM = "TF_mon";
                        }
                      }

                      if (component.price != null) {
                        if (addToCatalog === "true") {
                          component.price = (
                            Math.round(
                              Number(
                                Number(component.originalPrice) +
                                (Number(component.originalPrice) *
                                  component.margin.marginValue) /
                                100,
                              ) *
                              (1 + Number.EPSILON) *
                              100,
                            ) / 100
                          ).toFixed(2);
                          component.groupPrice = (
                            Math.round(
                              Number(
                                Number(component.originalPrice) +
                                (Number(component.originalPrice) *
                                  component.margin.marginValue) /
                                100,
                              ) *
                              (1 + Number.EPSILON) *
                              100,
                            ) / 100
                          ).toFixed(2);
                        } else {
                          component.price = (
                            Math.round(
                              Number(component.price) *
                              (1 + Number.EPSILON) *
                              100,
                            ) / 100
                          ).toFixed(2);
                          component.groupPrice = (
                            Math.round(
                              Number(component.price) *
                              (1 + Number.EPSILON) *
                              100,
                            ) / 100
                          ).toFixed(2);
                        }
                        component.promoPriceSource =
                          Math.round(
                            Number(component.price) *
                            (1 + Number.EPSILON) *
                            100,
                          ) / 100;
                      }
                      if (component.minimumPrice != null) {
                        if (addToCatalog === "true") {
                          component.minimumPrice = (
                            Math.round(
                              Number(
                                Number(component.originalPrice) +
                                (Number(component.originalPrice) *
                                  component.margin.minimumMarginValue) /
                                100,
                              ) *
                              (1 + Number.EPSILON) *
                              100,
                            ) / 100
                          ).toFixed(2);
                        } else {
                          component.minimumPrice = (
                            Math.round(
                              Number(component.minimumPrice) *
                              (1 + Number.EPSILON) *
                              100,
                            ) / 100
                          ).toFixed(2);
                        }
                        component.originalMinimumPrice = component.minimumPrice;
                      } else {
                        component.originalMinimumPrice = component.price;
                        if (addToCatalog === "true") {
                          component.minimumPrice = (
                            Math.round(
                              Number(
                                Number(component.originalPrice) +
                                (Number(component.originalPrice) *
                                  component.margin.minimumMarginValue) /
                                100,
                              ) *
                              (1 + Number.EPSILON) *
                              100,
                            ) / 100
                          ).toFixed(2);
                        } else {
                          component.minimumPrice = (
                            Math.round(
                              Number(component.price) *
                              (1 + Number.EPSILON) *
                              100,
                            ) / 100
                          ).toFixed(2);
                        }
                      }
                      if (component.variants && component.variants.length > 0) {
                        component.originalMinimumPrice = "0.00";
                        component.minimumPrice = "0.00";
                        component.promoPriceSource = "0.00";
                        component.price = "0.00";
                      }
                      component.tempDependency = {
                        dependerBucketName: "",
                        depender: "",
                        dependerProviderType: "",
                        dependerName: "",
                        cardinality: {
                          type: "",
                          range: {
                            min: "",
                            max: "",
                          },
                        },
                        dependencyType: "Mandatory",
                      };
                      component.selectedBucketComponents = [];

                      component.expandEnrichment = false;
                      var oldEnrichmentConfig = component.enrichmentConfig
                        ? component.enrichmentConfig
                        : {};
                      var tempEnrichmentConfig = [];
                      if (
                        oldEnrichmentConfig &&
                        oldEnrichmentConfig.hasOwnProperty("purchaseable") &&
                        oldEnrichmentConfig.purchaseable
                      ) {
                        var purchaseableList =
                          oldEnrichmentConfig["purchaseable"].split(",");
                        var removeableList =
                          oldEnrichmentConfig["removeable"].split(",");
                        var rePurchaseableList =
                          oldEnrichmentConfig["rePurchaseable"].split(",");
                        var visibleList =
                          oldEnrichmentConfig["visible"].split(",");
                        // Set purchaseable data
                        for (var p = 0; p < purchaseableList.length; p++) {
                          if (tempEnrichmentConfig.length > 0) {
                            var ind = tempEnrichmentConfig.findIndex(
                              (x) => x.id === purchaseableList[p].split(":")[0],
                            );
                            if (ind > -1) {
                              tempEnrichmentConfig[ind].purchaseable =
                                JSON.parse(purchaseableList[p].split(":")[1]);
                            } else {
                              var obj = {
                                id: purchaseableList[p].split(":")[0],
                                purchaseable: JSON.parse(
                                  purchaseableList[p].split(":")[1],
                                ),
                              };
                              tempEnrichmentConfig.push(obj);
                            }
                          } else {
                            var obj = {
                              id: purchaseableList[p].split(":")[0],
                              purchaseable: JSON.parse(
                                purchaseableList[p].split(":")[1],
                              ),
                            };
                            tempEnrichmentConfig.push(obj);
                          }
                        }
                        // Set removeable data
                        for (var p = 0; p < removeableList.length; p++) {
                          if (tempEnrichmentConfig.length > 0) {
                            var ind = tempEnrichmentConfig.findIndex(
                              (x) => x.id === removeableList[p].split(":")[0],
                            );
                            if (ind > -1) {
                              tempEnrichmentConfig[ind].removeable = JSON.parse(
                                removeableList[p].split(":")[1],
                              );
                            } else {
                              var obj = {
                                id: removeableList[p].split(":")[0],
                                removeable: JSON.parse(
                                  removeableList[p].split(":")[1],
                                ),
                              };
                              tempEnrichmentConfig.push(obj);
                            }
                          } else {
                            var obj = {
                              id: removeableList[p].split(":")[0],
                              removeable: JSON.parse(
                                removeableList[p].split(":")[1],
                              ),
                            };
                            tempEnrichmentConfig.push(obj);
                          }
                        }
                        // Set rePurchaseable data
                        for (var p = 0; p < rePurchaseableList.length; p++) {
                          if (tempEnrichmentConfig.length > 0) {
                            var ind = tempEnrichmentConfig.findIndex(
                              (x) =>
                                x.id === rePurchaseableList[p].split(":")[0],
                            );
                            if (ind > -1) {
                              tempEnrichmentConfig[ind].rePurchaseable =
                                JSON.parse(rePurchaseableList[p].split(":")[1]);
                            } else {
                              var obj = {
                                id: rePurchaseableList[p].split(":")[0],
                                rePurchaseable: JSON.parse(
                                  rePurchaseableList[p].split(":")[1],
                                ),
                              };
                              tempEnrichmentConfig.push(obj);
                            }
                          } else {
                            var obj = {
                              id: rePurchaseableList[p].split(":")[0],
                              rePurchaseable: JSON.parse(
                                rePurchaseableList[p].split(":")[1],
                              ),
                            };
                            tempEnrichmentConfig.push(obj);
                          }
                        }
                        // Set visible data
                        for (var p = 0; p < visibleList.length; p++) {
                          if (tempEnrichmentConfig.length > 0) {
                            var ind = tempEnrichmentConfig.findIndex(
                              (x) => x.id === visibleList[p].split(":")[0],
                            );
                            if (ind > -1) {
                              tempEnrichmentConfig[ind].visible = JSON.parse(
                                visibleList[p].split(":")[1],
                              );
                            } else {
                              var obj = {
                                id: visibleList[p].split(":")[0],
                                visible: JSON.parse(
                                  visibleList[p].split(":")[1],
                                ),
                              };
                              tempEnrichmentConfig.push(obj);
                            }
                          } else {
                            var obj = {
                              id: visibleList[p].split(":")[0],
                              visible: JSON.parse(visibleList[p].split(":")[1]),
                            };
                            tempEnrichmentConfig.push(obj);
                          }
                        }
                      }
                      component.enrichmentConfig = tempEnrichmentConfig;
                      tempComponentsList.push(component);
                      if (editData.data.components.length === i + 1) {
                        this.setState({
                          components: tempComponentsList,
                        });
                      }
                    });
                  let selectionType = {};
                  let tempSelectionType = { ...editData.data.selectionType };
                  Object.keys(tempSelectionType).map(function (key, index) {
                    selectionType[key.replace("selectionType_", "")] =
                      tempSelectionType[key] ? tempSelectionType[key] : "";
                  });
                  // read min and max limit from selectionType
                  let selectionTypeMinLimit = {};
                  let tempSelectionTypeMinLimit = { ...editData.data.selectionTypeMinLimit };
                  if (Object.keys(tempSelectionTypeMinLimit).length > 0) {
                    Object.keys(tempSelectionTypeMinLimit).map(function (key, index) {
                      selectionTypeMinLimit[key.replace("minLimit_", "")] =
                        tempSelectionTypeMinLimit[key] ? tempSelectionTypeMinLimit[key] : "";
                    });
                  }
                  let selectionTypeMaxLimit = {};
                  let tempSelectionTypeMaxLimit = { ...editData.data.selectionTypeMaxLimit };
                  if (Object.keys(tempSelectionTypeMaxLimit).length > 0) {
                    Object.keys(tempSelectionTypeMaxLimit).map(function (key, index) {
                      selectionTypeMaxLimit[key.replace("maxLimit_", "")] =
                        tempSelectionTypeMaxLimit[key] ? tempSelectionTypeMaxLimit[key] : "";
                    });
                  }
                  // this.state.basicDetail.productName
                  // bread.push({
                  //     title: editData.data.basicDetail.productName, url: '/' + window.location.href
                  // })

                  // Set data into state
                  let selectedBucket = "";
                  if (editData.data.billingTriggerProdId) {
                    selectedBucket = editData.data.components.find(
                      (a) => a.id === editData.data.billingTriggerProdId,
                    ).componentType;
                  }
                  setTimeout(() => {
                    this.setState(
                      {
                        loading: true,
                        expiryDate: expiryDate,
                        releaseDate: releaseDate,
                        selectionType: selectionType,
                        selectionTypeMinLimit: selectionTypeMinLimit,
                        selectionTypeMaxLimit: selectionTypeMaxLimit,
                        // components: editData.data.components,
                        basicDetail: editData.data.basicDetail,
                        productData: editData.data,
                        orderApproval: editData.data.orderApproval,
                        comment: editData.data.comment,
                        showSolutionStatus: true,
                        approvedForSale: editData.data.approvedForSale,
                        submittedForReview: editData.data.submittedForReview,
                        customerData: editData.data.customer,

                        status: editData.data.status,
                        productHistoryDetails: editData.data.history,
                        statusDisplayName: editData.data.statusDisplayName,
                        bpmnProcessInstanceId:
                          editData.data.bpmnProcessInstanceId,

                        billingTriggerPhase: editData.data.billingTriggerPhase
                          ? editData.data.billingTriggerPhase
                          : "DEFAULT",
                        selectedBucket: selectedBucket,
                        billingTriggerProdId: editData.data.billingTriggerProdId
                          ? editData.data.billingTriggerProdId
                          : "",
                        routing: editData.data.routing
                          ? editData.data.routing
                          : {
                            name: "",
                            description: "",
                            routingTasks: [],
                          },
                        preQuals: editData.data.preQuals
                          ? editData.data.preQuals
                          : [],
                      },
                      () => {
                        let isEditable =
                          (this.props.userPerms.includes("CATALOG_ADMIN") ||
                            this.props.userPerms.includes(
                              "CATALOG_ADMIN_ALL",
                            ) ||
                            this.props.userPerms.includes("CATALOG_UPDATE") ||
                            this.props.userPerms.includes("CATALOG_CREATE")) &&
                          this.state.statusDisplayName !== "Published";
                        this.setState(
                          {
                            readOnly: !isEditable,
                          },
                          () => {
                            this.setBreadCrumbText();
                          },
                        );
                        if (this.state.addToCatalog === "true") {
                          // this.updateMargin(30);
                        }
                        if (packageMode === "promo") {
                          this.setState({
                            renderAssociatedConst: true,
                            loading: false,
                          });
                        } else {
                          this.setState({
                            renderBasicDetail: true,
                            loading: false,
                          });
                        }
                        this.setState({ packagedSolutionStatus: true });
                        if (!addToCatalog || addToCatalog === "false") {
                          this.getComponentTypesAndDetails();
                        } else {
                          this.setState({
                            renderView: true,
                          });
                        }
                      },
                    );
                  }, 2000);
                })
                .catch((err) => {
                  if (
                    err.response &&
                    err.response.data &&
                    err.response.data.message
                  ) {
                    this.props.setErrorMessage(
                      err.response.data.message,
                      false,
                    );
                  } else {
                    this.props.setErrorMessage(
                      this.props.t("DEFAULT_ERROR_MESSAGE"),
                      false,
                    );
                  }
                  this.setState({ loading: false });
                });
            },
          );
        } else {
          // get the mapped component types
          this.getComponentTypesAndDetails();
        }
        window.addEventListener("beforeunload", this.handleBeforeUnload);
      },
    );

    // this.unlisten = this.props.history.listen((location, action) => {
    //     this.setState({
    //         basicDetail: {},
    //         productData: '',
    //         dataLoadingComplate: true,
    //         //loading: false,
    //     })
    // });
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  }

  blockNavigation = () => {
    this.setState({
      isBlocking: true,
    });
  };

  changeShowOfferingQty = () => {
    this.setState({
      showOfferingQty: !this.state.showOfferingQty
    })
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }
  updateIsMobile = () => {
    const isMobile = window.matchMedia("(max-width: 960px)").matches;
    this.setState({ isMobile });
  };

  toggleShowCategory = (tabValue) => {
    this.setState((prevState) => ({
      showCategory: !prevState.showCategory,
    }));
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.packageMode !== this.state.packageMode ||
      prevState.productBucketList !== this.state.productBucketList ||
      prevState.auxBucketsList !== this.state.auxBucketsList ||
      prevState.isPackageBucket !== this.state.isPackageBucket ||
      prevState.isPublishBucket !== this.state.isPublishBucket
    ) {
      this.updateSteps();
    }
  }

  updateSteps = () => {
    const steps = [
      this.state.packageMode !== "promo"
        ? { label: this.props.t("BASIC_DETAILS"), value: 0 }
        : null,
      this.state.productBucketList && this.state.productBucketList.length > 0
        ? { label: this.props.t("PRODUCTS"), value: 1 }
        : null,
      this.state.auxBucketsList && this.state.auxBucketsList.length > 0
        ? { label: this.props.t("AUXILIARY"), value: 2 }
        : null,
      this.state.isPackageBucket
        ? { label: this.props.t("PACKAGE"), value: 3 }
        : null,
      this.state.isPublishBucket
        ? { label: this.props.t("PUBLISH"), value: 4 }
        : null,
    ].filter((step) => step !== null); // Remove null values

    this.setState({ steps });
  };
  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }
  handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue =
      "Are you sure you want to leave? You may have unsaved changes."; // Standard behavior for most browsers
  };
  changeLocale = (value) => {
    console.log("check locale value", value);
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  getCategoriesList = () => {
    BusApiCall(
      "GET",
      `${constants.busV4Url}/providers/${this.props.providerId}/menus`,
    ).then((res) => {
      const menuCategories = res.data.menuCategories;
      const hasPackageCategory = menuCategories.some((category) =>
        category.categoryId.includes("PKG"),
      );
      this.setState({
        categoryList: menuCategories,
        // isPackageBucket: hasPackageCategory
      });
    });
  };

  getChannelsList = () => {
    BusApiCall("GET", `${constants.busV44Url}/getChannels`)
      .then((res) => {
        this.setState({
          channelList: res.data.channelList,
        });
      })
      .catch((err) => { });
  };

  toDataUrl = (url) => {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = reject;
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    });
  };

  componentWillMount() { }

  getComponentTypesAndDetails = () => {
    this.setState({ loading: true });
    this.setBreadCrumbText();
    Promise.all([
      BusApiCall("GET", `${constants.busV4Url}/catalog/myComponentTypes`),
      BusApiCall("GET", `${constants.busV4Url}/catalog/allComponentTypes`),
    ])
      .then((res) => {
        let data = res[0].data;
        let cData = JSON.parse(data.jsonResponse);
        cData = cData.sort((a, b) =>
          a && b ? a.sequenceNum - b.sequenceNum : 0,
        );
        let globalProdData = JSON.parse(res[1].data.jsonResponse);
        //customAttributes toggle if customAttributes are defined
        if (globalProdData && globalProdData.unMappedTypes.length > 0) {
          for (var i = 0; i < globalProdData.unMappedTypes.length; i++) {
            if (globalProdData.unMappedTypes[i].id == "PROD_COMP_ALL") {
              var customAttributesList = JSON.parse(
                JSON.stringify(
                  globalProdData.unMappedTypes[i].customAttributes
                    ? globalProdData.unMappedTypes[i].customAttributes
                    : [],
                ),
              );
              if (customAttributesList && customAttributesList.length > 0) {
                this.setState({
                  showCustomAttributes: true,
                });
              }
            }
          }
        }
        cData.push(...globalProdData.globalProducts);
        this.buildHierarchy(cData);
        if (cData && cData.length > 0) {
          this.setState({
            originalBucketsData: JSON.parse(JSON.stringify(cData)),
            // originalBucketsData: this.state.hierarchy
          });
          let selectionType = { ...this.state.selectionType };
          for (var i = 0; i < cData.length; i++) {
            if (cData[i].id in selectionType) {
            } else {
              // selectionType[cData[i].id] = '';
              selectionType[cData[i].id] = i === 0 ? "SINGLE" : "";
            }
          }

          var auxBuckets = [];
          var productBucketList = [];
          for (var i = this.state.hierarchy.length - 1; i >= 0; i--) {
            if (this.state.hierarchy[i].auxiliary) {
              auxBuckets.push(this.state.hierarchy[i]);
            } else {
              productBucketList.push(this.state.hierarchy[i]);
            }
          }
          productBucketList = productBucketList.reverse();
          auxBuckets = auxBuckets.sort((a, b) =>
            a && b ? a.sequenceNum - b.sequenceNum : 0,
          );
          // productBucketList = productBucketList.sort((a, b) => (a && b ? a.sequenceNum - b.sequenceNum : 0));
          if (this.state.packageMode !== "promo") {
            // if (this.props.userPerms.includes("CUMULATOR-CATALOG_ADMIN21")) {

            this.state.hierarchy.push({
              id: "PROD_COMP_PACKAGE",
              name: "Package",
              displayNamePlural: "Package",
              iconName: "local_mall",
              sequenceNum: 9998,
            });

            this.state.hierarchy.push({
              id: "PROD_COMP_PUBLISH",
              name: "Publish",
              displayNamePlural: "Publish",
              iconName: "publish",
              sequenceNum: 9999,
            });

            this.setState({
              // isPackageBucket: true,
              isPublishBucket: true,
            });

            // }
          }

          this.setState(
            {
              globalProducts: globalProdData.globalProducts,
              bucketList: this.state.hierarchy,
              selectionType,
              auxBucketsList: auxBuckets,
              productBucketList,
              renderView: true,
            },
            () => {
              if (this.state.packageMode === "promo") {
                this.switchParentTab("", 1);
              }
              //set the dynamic bucket in the state
              this.state.bucketList.map((bucket) => {
                this.setState(
                  {
                    displayBuckets: true,
                  },
                  () => {
                    // if (this.state.packageMode === 'CREATE' || this.state.packageMode === 'edit') {
                    this.setState({ loading: false });
                    // }
                  },
                );
              });
            },
          );
        } else {
          this.setState({
            loading: false,
            bucketList: [],
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  sortSubCategories = (dataArray) => {
    dataArray.forEach((obj) => {
      if (obj.subCategories && obj.subCategories.length > 0) {
        obj.subCategories.sort((a, b) => (a.name > b.name ? -1 : 1));
      }
    });
  };

  getLeafSubcategory = (subcategories) => {
    if (!subcategories || subcategories.length === 0) {
      return null;
    }

    const subcategory = subcategories[0]; // Assuming the leaf node is always the first element
    if (!subcategory.subCategories || subcategory.subCategories.length === 0) {
      return {
        id: subcategory.id,
        name: subcategory.displayNamePlural || subcategory.name,
        sequenceNum: subcategory.sequenceNum,
      };
    }

    return this.getLeafSubcategory(subcategory.subCategories);
  };

  buildHierarchy = (cData2) => {
    for (let i = 0; i < cData2.length; i++) {
      const item = { ...cData2[i] };
      if (item.parentCategories) {
        delete item.parentCategories;
      }
      if (
        cData2[i].parentCategories &&
        cData2[i].parentCategories.length !== 0
      ) {
        const sub = { ...cData2[i].parentCategories[0], subCategories: [] };
        sub.subCategories.push(item);
        if (sub.parentCategories) {
          delete sub.parentCategories;
        }
        if (
          cData2[i].parentCategories[0].parentCategories &&
          cData2[i].parentCategories[0].parentCategories.length !== 0
        ) {
          const parent = {
            ...cData2[i].parentCategories[0].parentCategories[0],
            subCategories: [],
          };
          parent.subCategories.push(sub);
          if (parent.parentCategories) {
            delete parent.parentCategories;
          }
          this.createHierarchy(parent);
        } else {
          this.createHierarchy(sub);
        }
      } else {
        this.createHierarchy(item);
      }
    }
  };

  createHierarchy = (node) => {
    const { hierarchy } = this.state;
    // Find the parent node in the hierarchy
    const parentNodeIndex = hierarchy.findIndex((item) => item.id === node.id);

    if (parentNodeIndex !== -1) {
      // Parent node found
      const parentNode = hierarchy[parentNodeIndex];
      // Find the child node in the parent node's subCategories
      const childNodeIndex = parentNode.subCategories.findIndex(
        (item) => item.id === node.subCategories[0].id,
      );
      if (childNodeIndex !== -1) {
        // Child node found, push the new subCategory to its subCategories
        parentNode.subCategories[childNodeIndex].subCategories.push(
          ...node.subCategories[0].subCategories,
        );
      } else {
        // Child node not found, push the entire subCategories array to the parent node's subCategories
        parentNode.subCategories.push(...node.subCategories);
      }
    } else {
      // Parent node not found, push the entire node to the hierarchy
      hierarchy.push(node);
    }
    // Update the state with the new hierarchy
    this.setState({ hierarchy }, () => {
      this.sortSubCategories(this.state.hierarchy);
    });
  };

  setBreadCrumbText = () => {
    let bread = [];
    if (this.state.packageMode !== "promo") {
      if (this.state.addToCatalog === "true") {
        bread.push({
          title: this.props.t("IMPORT_PACKAGED_SOLUTION"),
          url: "/availableOfferings",
        });
      } else {
        if (this.state.packageMode === "edit") {
          if (
            this.props.userPerms.includes("CUMULATOR_PRODUCT_APPROVE") &&
            this.state.submittedForReview
          ) {
            bread.push({
              title: this.props.t("APPROVE_PACKAGED_SOLUTION"),
              url: "/myOfferings",
            });
          } else if (this.state.readOnly) {
            bread.push({
              title: this.props.t("VIEW_PACKAGED_SOLUTION"),
              url: "/myOfferings",
            });
          } else {
            bread.push({
              title: this.props.t("EDIT_PACKAGED_SOLUTION"),
              url: "/myOfferings",
            });
          }
        } else {
          bread.push({
            title: this.props.t("DEFINE_PACKAGED_SOLUTION"),
            url: "/createPackage",
          });
        }
      }
      // if (this.props.providerName) {
      //     bread.push({
      //         title: this.props.providerName, url: "/updatePackage"
      //     })
      // }
      if (this.state.basicDetail.productName) {
        bread.push({
          title: this.state.basicDetail.productName,
          url: "/updatePackage" + this.props.router.location.search,
        });
      }
    } else {
      bread.push({
        title: this.props.t("EDIT_SPECIAL_PRICING"),
        url: "myOfferings",
      });
      // bread.push({
      //     title: this.props.t('DEFINE_A_SPECIAL_PRICE'), url: "/updatePackage"
      // })
      // if (this.props.providerName) {
      //     bread.push({
      //         title: this.props.providerName, url: "/updatePackage"
      //     })
      // }
      if (this.state.basicDetail.productName) {
        bread.push({
          title: this.state.basicDetail.productName,
          url:
            this.props.router.location.pathname +
            this.props.router.location.search,
        });
      }
      if (this.state.promoName) {
        bread.push({
          title: this.state.promoName,
          url:
            this.props.router.location.pathname +
            this.props.router.location.search,
        });
      }
    }
    this.setState({ bread, renderBread: true });
  };

  // Go to previous step in packaged solution wizard
  handleBack = (tabValue, step, data) => { };
  //handle tab movement : End

  // Get packaged solution basic details
  getPackageBasicDetails = (bd, tab) => {
    let tempComponents = JSON.parse(JSON.stringify([...this.state.components]));
    this.setState({
      basicDetail: { ...bd },
      components: tempComponents,
    });
    if (tab) {
      // this.setState({ tabValue: 1, disableTabs: false })
      this.switchParentTab("", 1);
    }
  };

  updateTermsAncConditions = () => { };

  // Get bucket data
  getAssociatedBucket = (component) => {
    let componentItems = [...this.state.components];
    componentItems.push({
      ...component,
    });
    this.setState(
      {
        components: [...componentItems],
      },
      () => {
        this.setCurrentBucketItems();
      },
    );
  };

  setCurrentBucketItems = () => {
    let currentBucketItems = [];
    let currentBucketItemsCount = 0;
    // currentBucketItems = jp.query(this.state.components, '$..[?(@.componentType=="' + this.state.selectedBucketId + '")]');
    for (var i = 0; i < this.state.components.length; i++) {
      if (
        this.state.components[i].componentType === this.state.selectedBucketId
      ) {
        currentBucketItems.push(this.state.components[i]);
      }
    }
    currentBucketItems.sort((a, b) =>
      a && b ? a.displaySequence - b.displaySequence : 0,
    );
    for (var i = 0; i < currentBucketItems.length; i++) {
      if (!currentBucketItems[i].remove) {
        currentBucketItemsCount++;
        currentBucketItems[i].displaySequence = "" + currentBucketItemsCount;
      }
    }
    this.setState({
      currentBucketItems,
      currentBucketItemsCount,
    });
  };
  getAssociatedBucketDetailsBulk = (data) => {
    let componentItems = [...this.state.components];
    for (var i = 0; i < data.length; i++) {
      componentItems.push({
        ...data[i],
      });
      if (data.length === i + 1) {
        this.setState(
          {
            components: [...componentItems],
          },
          () => {
            this.setCurrentBucketItems();
          },
        );
      }
    }
  };

  setAssociatedBucket = (dependOnList, productId) => {
    let items = [...this.state.components];
    let tempIndex = items.findIndex((a) => a.id === productId);
    if (!items[tempIndex].add) {
      items[tempIndex].edit = true;
    }
    items[tempIndex].chipData.push({
      ...dependOnList,
    });
    if (items[tempIndex].dependsOn) {
      items[tempIndex].dependsOn.push({
        ...dependOnList,
      });
    }
    items[tempIndex].relationShips = {
      dependsOn: items[tempIndex].chipData,
    };
    this.setState({
      components: items,
    });
  };

  // Remove component from by=ucket
  removeItemFromBucket = (row) => {
    let components = [...this.state.components];
    // if component is added but not saved in packaged solution
    if (this.state.importOffering) {
      let tempIndex = components.findIndex(
        (a) => a.featureCode === row.featureCode,
      );
      components.splice(tempIndex, 1);
    } else {
      if (row.add) {
        let tempIndex = components.findIndex(
          (a) => a.featureCode === row.featureCode,
        );
        components.splice(tempIndex, 1);
      } else {
        // If packaged solution is already in packaged solution
        let tempIndex = components.findIndex(
          (a) => a.featureCode === row.featureCode,
        );
        components[tempIndex].remove = true;
        components[tempIndex]["expandEnrichment"] = false;
        components[tempIndex]["expandVariants"] = false;
        components[tempIndex]["expandOtherPrices"] = false;
      }
    }
    for (var i = 0; i < components.length; i++) {
      // Update display sequence after component removed
      if (
        components[i].componentType === row.componentType &&
        !components[i].remove
      ) {
        if (
          JSON.parse(components[i].displaySequence) >
          JSON.parse(row.displaySequence)
        ) {
          components[i].displaySequence = JSON.stringify(
            JSON.parse(components[i].displaySequence) - 1,
          );
          components[i].edit = true;
        }
      }

      // Remove dependencies on removed component (if any)
      if (components[i].chipData && components[i].chipData.length > 0) {
        let chips = components[i].chipData;
        for (var j = 0; j < chips.length; j++) {
          if (chips[j].featureCode === row.featureCode) {
            this.removeDependsOnChip(components[i].id, j);
          }
        }
      }
    }
    this.setState(
      {
        components,
      },
      () => {
        this.setCurrentBucketItems();
      },
    );
  };

  // Remove dependency chip from table chip action
  removeDependsOnChip = (id, chipIndex) => {
    let components = [...this.state.components];
    let tempIndex = components.findIndex((a) => a.id === id);
    components[tempIndex].chipData.splice(chipIndex, 1);
    components[tempIndex].relationShips = {
      dependsOn: components[tempIndex].chipData,
    };
    if (!components[tempIndex].add) {
      components[tempIndex].edit = true;
    }
    this.setState(
      {
        components,
      },
      () => {
        this.setCurrentBucketItems();
      },
    );
  };

  validatePackagedSolutionData = (val) => {
    if (val) {
      return;
    }
    let data = this.state.basicDetail;
    let search = new URLSearchParams(this.props.router.location.search);
    let packageMode = search.get("packageMode")
      ? search.get("packageMode")
      : this.state.packageMode;
    if (packageMode === "promo") {
    } else {
      if (!this.state.readOnly) {
        if (
          !data.productName ||
          !data.featureCode ||
          !data.productDescription ||
          !data.startingPrice ||
          !data.categoryId ||
          !data.productMainImage
        ) {
          this.props.setErrorMessage(
            this.props.t("BASIC_DETAILS_ERROR"),
            false,
          );
          return false;
        }
      }
    }
    // TODO: Disabled for now due to demo issues
    // Have to add astrick (*) on input too
    // for (var i = 0; i < this.state.components.length; i++) {
    //     if (!this.state.components[i].featureCode) {
    //         let componentData = this.state.components[i];
    //         this.props.setErrorMessage(this.props.t('PRODUCT_CODE_ERROR_PS', { componentData }), false)
    //         return false;
    //     }
    // }
    return true;
  };

  validateData = (val) => {
    const err = {};
    if (val.releaseDate && val.expiryDate) {
      if (val.releaseDate > val.expiryDate) {
        err.expiryDate = "Expiry Date cannot be before Release Date";
      }
    }
    this.setState({
      error: { ...err },
    });
    if (Object.keys(err).length === 0) {
      return true;
    }
  };

  /**
 * Validates patterns like:
 *
 * "anything".quantity="anything"
 * "anything".quantity="anything"+"anything"+"anything"
 * "anything".quantity="anything","anything".quantity="anything"+"anything" - removed for now
 */
  isValidQuantityPattern = (input) => {
    // the code below supports all three cases

    // if (!input || typeof input !== "string") return false;

    // // match anything inside double quotes except double quote itself
    // const quoted = `"[^"]+"`;

    // // single rule pattern
    // const singleRule =
    //   `${quoted}\\.quantity=${quoted}(\\+${quoted})*`;

    // // multiple rules separated by comma
    // const fullPattern =
    //   `^${singleRule}(,${singleRule})*$`;

    // const regex = new RegExp(fullPattern);

    // return regex.test(input.trim());

    // -----------------------------

    // the code below supports first two cases

    if (!input || typeof input !== "string") return false;

    // match anything inside double quotes except double quote itself
    const quoted = `"[^"]+"`;

    // only one valid rule
    const pattern = `^${quoted}\\.quantity=${quoted}(\\+${quoted})*$`;

    const regex = new RegExp(pattern);

    return regex.test(input.trim());
  };




  submitPackageJSON = (action, physical) => {
    this.setState({
      isBlocking: false,
    });
    let finalData = JSON.parse(JSON.stringify(this.state));
    if (this.validateData(finalData)) {
      finalData.basicDetail.productTerms = this.state.productTerms;
      finalData.basicDetail.productTermsTemplate =
        this.state.productTermsTemplate;
      finalData.basicDetail.localisedProductTerms =
        this.state.localisedProductTerms;
      finalData.basicDetail.localisedProductTermsTemplate =
        this.state.localisedProductTermsTemplate;

      if (this.state.addToCatalog || this.state.addToCatalog === "true") {
        finalData.basicDetail.originalProviderId =
          this.state.originalProviderId;
        finalData.basicDetail.originalProviderName =
          this.state.originalProviderName;
        finalData.basicDetail.originalProviderType =
          this.state.originalProviderType;
      }

      if (
        finalData.basicDetail.customAttributes &&
        finalData.basicDetail.customAttributes.length > 0
      ) {
        for (
          var i = 0;
          i < finalData.basicDetail.customAttributes.length;
          i++
        ) {
          if (
            finalData.basicDetail.customAttributes[i].valueType === "boolean"
          ) {
            if (finalData.basicDetail.customAttributes[i].attrValue === null) {
              finalData.basicDetail.customAttributes[i].attrValue = "false";
            } else {
              finalData.basicDetail.customAttributes[i].attrValue =
                "" + finalData.basicDetail.customAttributes[i].attrValue;
            }
          }
          if (
            finalData.basicDetail.customAttributes[i].required &&
            !finalData.basicDetail.customAttributes[i].attrValue
          ) {
            var error = finalData.basicDetail.customAttributes[i];
            this.props.setErrorMessage(
              this.props.t("REQUIRED_CUSTOM_ATTRIBUTE_ERROR", { error }),
              false,
            );
            return;
          } else if (!finalData.basicDetail.customAttributes[i].attrValue) {
            finalData.basicDetail.customAttributes.splice(i, 1);
          } else if (
            finalData.basicDetail.customAttributes[i].valueType === "collection"
          ) {
            if (
              finalData.basicDetail.customAttributes[i].required &&
              !finalData.basicDetail.customAttributes[i].attrValue
            ) {
              var error = finalData.basicDetail.customAttributes[i];
              this.props.setErrorMessage(
                this.props.t("REQUIRED_CUSTOM_ATTRIBUTE_ERROR", { error }),
                false,
              );
              return;
            }
            var index = finalData.basicDetail.customAttributes[
              i
            ].options.findIndex(
              (x) =>
                x.id === finalData.basicDetail.customAttributes[i].attrValue,
            );
            if (index > -1) {
              finalData.basicDetail.customAttributes[i].attrValue =
                JSON.stringify([
                  finalData.basicDetail.customAttributes[i].options[index],
                ]);
            }
          }
          if (finalData.basicDetail.customAttributes && finalData.basicDetail.customAttributes.length > 0 && finalData.basicDetail.customAttributes[i].attrName.includes("quantityValidation")) {
            if (!this.isValidQuantityPattern(finalData.basicDetail.customAttributes[i].attrValue)) {
              this.props.setErrorMessage(`Invalid pattern found for ${finalData.basicDetail.customAttributes[i].attrName} custom attribute. Example: "pseudo_product_code".quantity="addon1_product_code"+"addon2_product_code".`,
                false,
              );
              return;
            }
          }
        }
      }
      for (var j = 0; j < finalData.components.length; j++) {
        if (
          finalData.components[j].customAttributes &&
          finalData.components[j].customAttributes.length > 0
        ) {
          for (
            var k = 0;
            k < finalData.components[j].customAttributes.length;
            k++
          ) {
            if (
              finalData.components[j].customAttributes[k].valueType ===
              "boolean"
            ) {
              finalData.components[j].customAttributes[k].attrValue =
                "" + finalData.components[j].customAttributes[k].attrValue;
            }
          }
        }
        var componentEnrichmentConfig = JSON.parse(
          JSON.stringify(finalData.components[j].enrichmentConfig),
        );
        var tempEnrichmentConfig = {
          purchaseable: "",
          removeable: "",
          rePurchaseable: "",
          visible: "",
        };
        if (componentEnrichmentConfig && componentEnrichmentConfig.length > 0) {
          for (var i = 0; i < componentEnrichmentConfig.length; i++) {
            tempEnrichmentConfig.purchaseable +=
              (i > 0 ? "," : "") +
              componentEnrichmentConfig[i].id +
              ":" +
              (componentEnrichmentConfig[i].purchaseable
                ? componentEnrichmentConfig[i].purchaseable
                : false);
            tempEnrichmentConfig.removeable +=
              (i > 0 ? "," : "") +
              componentEnrichmentConfig[i].id +
              ":" +
              (componentEnrichmentConfig[i].removeable
                ? componentEnrichmentConfig[i].removeable
                : false);
            tempEnrichmentConfig.rePurchaseable +=
              (i > 0 ? "," : "") +
              componentEnrichmentConfig[i].id +
              ":" +
              (componentEnrichmentConfig[i].rePurchaseable
                ? componentEnrichmentConfig[i].rePurchaseable
                : false);
            tempEnrichmentConfig.visible +=
              (i > 0 ? "," : "") +
              componentEnrichmentConfig[i].id +
              ":" +
              (componentEnrichmentConfig[i].visible
                ? componentEnrichmentConfig[i].visible
                : false);
          }
        }
        finalData.components[j].enrichmentConfig = tempEnrichmentConfig;
      }
      if (!physical) {
        delete finalData.routing;
      } else {
        let checkTaskTitle = false;
        let routinTaskIndex = finalData.routing.routingTasks.length;
        while (routinTaskIndex--) {
          if (
            finalData.routing.routingTasks[routinTaskIndex].name === "" &&
            finalData.routing.routingTasks[routinTaskIndex].description ===
            "" &&
            finalData.routing.routingTasks[routinTaskIndex]
              .estimatedCompletionTimeInSeconds === ""
          ) {
            finalData.routing.routingTasks.splice(routinTaskIndex, 1);
          } else {
            if (
              finalData.routing.routingTasks[routinTaskIndex].name !== "" ||
              finalData.routing.routingTasks[routinTaskIndex].description !==
              "" ||
              finalData.routing.routingTasks[routinTaskIndex]
                .estimatedCompletionTimeInSeconds !== ""
            ) {
              checkTaskTitle = true;
              let obj = finalData.routing.routingTasks[routinTaskIndex];
              for (let item in obj) {
                if (!obj[item]) {
                  let errorObj = {
                    name:
                      item === "estimatedCompletionTimeInSeconds"
                        ? "time"
                        : item,
                    row: routinTaskIndex + 1,
                  };
                  this.props.setErrorMessage(
                    this.props.t("ROUTING_TASK_ERROR", { errorObj }),
                    false,
                  );
                  return;
                }
              }
            }
          }
        }
        if (checkTaskTitle) {
          if (!finalData.routing.name) {
            this.props.setErrorMessage(
              this.props.t("ROUTING_TITLE_ERROR"),
              false,
            );
            return;
          }
        }
      }

      finalData.basicDetail.showOfferingQty = this.state.showOfferingQty;

      // TODO: Remove this code block once cbiz branch 'standlone sellable' is merged
      // START
      if (finalData.inventoryItemAndDetail) {
        delete finalData.inventoryItemAndDetail;
      }
      for (var j = 0; j < finalData.components.length; j++) {
        if (finalData.components[j].inventoryItemAndDetail) {
          delete finalData.components[j].inventoryItemAndDetail;
        }
        if (
          finalData.components[j].bom &&
          finalData.components[j].bom.length > 0
        ) {
          finalData.components[j].bom.forEach(function iter(a) {
            if (a.inventoryItemAndDetail) {
              delete a.inventoryItemAndDetail;
            }
            Array.isArray(a.bom) && a.bom.forEach(iter);
          });
        }
        if (
          finalData.components[j].children &&
          finalData.components[j].children.length > 0
        ) {
          finalData.components[j].children.forEach(function iter(a) {
            if (a.inventoryItemAndDetail) {
              delete a.inventoryItemAndDetail;
            }
            Array.isArray(a.children) && a.children.forEach(iter);
          });
        }
      }
      // END

      if (finalData.inventoryDetails) {
        delete finalData.inventoryDetails;
      }
      // for (var j = 0; j < finalData.components.length; j++) {
      //     if (finalData.components[j].inventoryDetails) {
      //         delete finalData.components[j].inventoryDetails;
      //     }
      //     if (finalData.components[j].bom && finalData.components[j].bom.length > 0) {
      //         finalData.components[j].bom.forEach(function iter(a) {
      //             if (a.inventoryDetails) {
      //                 delete a.inventoryDetails;
      //             }
      //             Array.isArray(a.bom) && a.bom.forEach(iter);
      //         });
      //     }
      //     if (finalData.components[j].children && finalData.components[j].children.length > 0) {
      //         finalData.components[j].children.forEach(function iter(a) {
      //             if (a.inventoryDetails) {
      //                 delete a.inventoryDetails;
      //             }
      //             Array.isArray(a.children) && a.children.forEach(iter);
      //         });
      //     }
      // }
      for (var j = finalData.components.length - 1; j >= 0; j--) {
        if (finalData.components[j].inventoryDetails) {
          delete finalData.components[j].inventoryDetails;
        }
        if (
          finalData.components[j].bom &&
          finalData.components[j].bom.length > 0
        ) {
          finalData.components[j].bom.forEach(function iter(a) {
            if (a.inventoryDetails) {
              delete a.inventoryDetails;
            }
            Array.isArray(a.bom) && a.bom.forEach(iter);
          });
        }
        if (
          finalData.components[j].children &&
          finalData.components[j].children.length > 0
        ) {
          finalData.components[j].children.forEach(function iter(a) {
            if (a.inventoryDetails) {
              delete a.inventoryDetails;
            }
            Array.isArray(a.children) && a.children.forEach(iter);
          });
        }
        if (action === "NEW_SOLUTION") {
          if (finalData.components[j].remove) {
            finalData.components.splice(j, 1);
          }
        }
      }
      console.log("finalData", finalData);
      // return
      // add customer data
      finalData.customer = this.state.customerData;
      // if (this.state.customerData.length > 0) {
      //     finalData.customer.push(this.state.customerData[0].partyId);
      // }
      if (this.validatePackagedSolutionData()) {
        let search = new URLSearchParams(this.props.router.location.search);
        let packageId = search.get("packageId");
        if (
          this.state.billingTriggerPhase === "ACTIVATION" ||
          this.state.billingTriggerPhase === "PROVISIONING"
        ) {
          if (!this.state.billingTriggerProdId) {
            this.props.setErrorMessage(
              this.props.t("SELECT_BILLING_TRIGGER"),
              false,
            );
            return;
          }
        }

        this.setState(
          {
            loading: true,
            saveAs: action === "CREATE" ? false : true,
            isMaster: action === "IMPORT_TO_CATALOG" ? true : false,
            addToCatalog: action === "IMPORT_TO_CATALOG" ? true : false,
            editPackagedId: this.state.packageMode === "edit" ? packageId : "",
          },
          () => {
            finalData.saveAs = this.state.saveAs;
            finalData.addToCatalog = this.state.addToCatalog;
            finalData.editPackagedId = this.state.editPackagedId;
            if (
              action === "UPDATE" ||
              (action === "REVIEW" && this.state.packageMode == "edit")
            ) {
              finalData.releaseAction = action;
              BusApiCall(
                "PUT",
                `${constants.busInternalUrl}/packagedSolutions`,
                finalData,
              )
                .then((res) => {
                  this.props.router.navigate("/myOfferings");
                  this.props.setErrorMessage(
                    this.props.t("PACKAGED_SOLUTION_UPDATED_SUCCESSFULLY"),
                    true,
                  );
                  this.setState({
                    loading: false,
                  });
                })
                .catch((err) => {
                  if (
                    err.response &&
                    err.response.data &&
                    err.response.data.message
                  ) {
                    this.props.setErrorMessage(
                      err.response.data.message,
                      false,
                    );
                  } else {
                    this.props.setErrorMessage(
                      this.props.t("DEFAULT_ERROR_MESSAGE"),
                      false,
                    );
                  }
                  this.setState({ loading: false });
                });
            } else if (
              action === "PS_REVIEW" ||
              action === "PS_APPROVE" ||
              action === "PS_RESUBMITTED"
            ) {
              let finalData = { action: action };

              if (this.state.comment != null) {
                finalData.comment = this.state.comment;
              }
              // return; 
              BusApiCall(
                "PATCH",
                `${constants.busInternalUrl}/packagedSolutions/products/${this.state.editPackagedId}`,
                finalData,
              )
                .then((res) => {
                  this.setState({ loading: false });
                  if (action === "PS_REVIEW") {
                    this.props.router.navigate("/myOfferings");
                    this.props.setErrorMessage(
                      this.props.t("PS_DRAFT_MSG"),
                      true,
                    );
                  } else if (action === "PS_APPROVE") {
                    this.props.router.navigate("/product");
                    this.props.setErrorMessage(
                      this.props.t("PS_PUBLISHED_MSG"),
                      true,
                    );
                  } else if (action === "PS_RESUBMITTED") {
                    this.props.router.navigate("/myOfferings");
                    this.props.setErrorMessage(
                      this.props.t("PS_RESUBMITTED"),
                      true,
                    );
                  }
                })
                .catch((err) => {
                  this.props.setErrorMessage(err.response.data.message, false);
                  this.setState({ loading: false, isBlocking: true });
                });
            } else {
              // when action === CREATE || IMPORT_TO_CATALOG , create new packaged solution (Add, import, save as new a product)
              let tempComponentData = [...this.state.components];
              let sortedArray = tempComponentData.sort((a, b) => {
                return (
                  this.state.bucketList
                    .map((e) => {
                      return e.id;
                    })
                    .indexOf(a.componentType) -
                  this.state.bucketList
                    .map((e) => {
                      return e.id;
                    })
                    .indexOf(b.componentType)
                );
              });
              this.setState(
                {
                  components: sortedArray,
                },
                () => {
                  finalData.comment = "";
                  //console.log("=========finalData=======",finalData);
                  BusApiCall(
                    "POST",
                    `${constants.busInternalUrl}/packagedSolutions`,
                    finalData,
                  )
                    .then((res) => {
                      if (res.data.packagedSolutionId) {
                        this.setState({
                          loading: false,
                        });
                        this.props.router.navigate("/myOfferings");
                        if (action === "IMPORT_TO_CATALOG") {
                          this.props.setErrorMessage(
                            this.props.t(
                              "PACKAGED_SOLUTION_IMPORTED_SUCCESSFULLY",
                            ),
                            true,
                          );
                        } else {
                          this.props.setErrorMessage(
                            this.props.t(
                              "PACKAGED_SOLUTION_CREATED_SUCCESSFULLY",
                            ),
                            true,
                          );
                        }
                      } else {
                        this.setState({ loading: false });
                      }
                    })
                    .catch((err) => {
                      if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                      ) {
                        this.props.setErrorMessage(
                          err.response.data.message,
                          false,
                        );
                      } else {
                        this.props.setErrorMessage(
                          this.props.t("DEFAULT_ERROR_MESSAGE"),
                          false,
                        );
                      }
                      this.setState({ loading: false, isBlocking: true });
                    });

                  // BusApiCall('GET', `${constants.busInternalUrl}/packaged-solutions/products/${UriEncode(this.state.basicDetail.productName)}`).then(res => {
                  //     if (res.data[0].errorMessage) {
                  //         this.setState({ loading: false })
                  //         this.props.setErrorMessage(res.data[0].errorMessage, false)
                  //     } else {
                  //         //comment should be blank added when an offering is getting created
                  //         finalData.comment = "";
                  //         BusApiCall('POST', `${constants.busInternalUrl}/packagedSolutions`, finalData).then(res => {
                  //             if (res.data.packagedSolutionId) {
                  //                 this.setState({
                  //                     loading: false
                  //                 })
                  //                 this.props.router.navigate('/myOfferings')
                  //                 if (action === "IMPORT_TO_CATALOG") {
                  //                     this.props.setErrorMessage(this.props.t('PACKAGED_SOLUTION_IMPORTED_SUCCESSFULLY'), true)
                  //                 } else {
                  //                     this.props.setErrorMessage(this.props.t('PACKAGED_SOLUTION_CREATED_SUCCESSFULLY'), true)
                  //                 }
                  //             }
                  //             else {
                  //                 this.setState({ loading: false })
                  //             }
                  //         })
                  //             .catch(err => {
                  //                 if (err.response && err.response.data && err.response.data.message) {
                  //                     this.props.setErrorMessage(err.response.data.message, false)
                  //                 } else {
                  //                     this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
                  //                 }
                  //                 this.setState({ loading: false, isBlocking: true })
                  //             })
                  //     }
                  // }).catch(err => {
                  //     if (err.response && err.response.data && err.response.data.message) {
                  //         this.props.setErrorMessage(err.response.data.message, false)
                  //     } else {
                  //         this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
                  //     }
                  //     this.setState({ loading: false, isBlocking: true })
                  // })
                },
              );
            }
          },
        );
      }
    }
  };

  applyPromo = (componentNode, event) => {
    let controlValue = event.target.checked;
    if (!controlValue) {
      delete componentNode.promoPrice;
      componentNode.promoApplied = false;
    } else {
      if (componentNode.promoPrice && componentNode.promoPrice.length > 0) {
        componentNode.promoPrice[0].price = componentNode.price;
      } else {
        componentNode.promoPrice = [
          {
            name: componentNode.name,
            featureCode: componentNode.featureCode,
            price: componentNode.price,
          },
        ];
        componentNode.promoApplied = true;
      }
    }
  };

  applyPromoForcefully = (componentNode) => {
    if (componentNode.promoPrice && componentNode.promoPrice.length > 0) {
      componentNode.promoPrice[0].price = componentNode.price;
    } else {
      componentNode.promoPrice = [
        {
          name: componentNode.name,
          featureCode: componentNode.featureCode,
          price: componentNode.price,
        },
      ];
      componentNode.promoApplied = true;
    }
  };

  applySpecialPrice = () => {
    let search = new URLSearchParams(this.props.router.location.search);
    let promoId = search.get("promoId");
    this.setState(
      {
        promoId: promoId,
        loading: true,
      },
      () => {
        let finalData = {
          promoId: promoId,
          components: [...this.state.components],
        };
        console.log("check final data", finalData);
        BusApiCall(
          "POST",
          `${constants.busInternalUrl}/promos/price`,
          finalData,
        )
          .then((res) => {
            this.setState({ loading: false });
            this.props.setErrorMessage(
              this.props.t("SPECIAL_PRICE_APPLIED_SUCCESSFULLY"),
              true,
            );
            this.props.router.navigate("/myOfferings?promoSuccess=true");
          })
          .catch((err) => {
            this.setState({ loading: false });
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
          });
      },
    );
  };

  downloadTemplate = () => {
    this.setState({
      loading: true,
    });
    this.basicDetailsRef.forceNext(false);
    setTimeout(() => {
      let data = {};
      data.addToCatalog = this.state.addToCatalog;
      data.basicDetail = this.state.basicDetail;
      data.components = this.state.components;
      data.basicDetail.productName = data.basicDetail.productName.trim();
      if (data.basicDetail.featureCode) {
        data.basicDetail.featureCode = data.basicDetail.featureCode.trim();
      }
      data.basicDetail.productDescription =
        data.basicDetail.productDescription.trim();
      data.basicDetail.productTerms = this.state.productTerms;
      data.basicDetail.productTermsTemplate = this.state.productTermsTemplate;
      data.basicDetail.localisedProductTerms = this.state.localisedProductTerms;
      data.basicDetail.localisedProductTermsTemplate =
        this.state.localisedProductTermsTemplate;
      for (var i = data.components.length - 1; i >= 0; i--) {
        data.components[i].name = data.components[i].name.trim();
        data.components[i].description = data.components[i].description.trim();
        if (data.components[i].originalProductId) {
          data.components[i].id = data.components[i].originalProductId;
          data.components[i].existing = true;
        }
        //set the depender id as the feature code
        if (data.components[i].relationShips) {
          for (
            var j = 0;
            j < data.components[i].relationShips.dependsOn.length;
            j++
          ) {
            data.components[i].relationShips.dependsOn[j].depender =
              data.components[i].relationShips.dependsOn[j].featureCode;
          }
        }
        if (
          data.components[i].enrichmentConfig &&
          data.components[i].enrichmentConfig.length > 0
        ) {
          var componentEnrichmentConfig = JSON.parse(
            JSON.stringify(data.components[i].enrichmentConfig),
          );
          var tempEnrichmentConfig = {
            purchaseable: "",
            removeable: "",
            rePurchaseable: "",
            visible: "",
          };
          for (var k = 0; k < componentEnrichmentConfig.length; k++) {
            tempEnrichmentConfig.purchaseable +=
              (k > 0 ? "," : "") +
              componentEnrichmentConfig[k].id +
              ":" +
              (componentEnrichmentConfig[k].purchaseable
                ? componentEnrichmentConfig[k].purchaseable
                : false);
            tempEnrichmentConfig.removeable +=
              (k > 0 ? "," : "") +
              componentEnrichmentConfig[k].id +
              ":" +
              (componentEnrichmentConfig[k].removeable
                ? componentEnrichmentConfig[k].removeable
                : false);
            tempEnrichmentConfig.rePurchaseable +=
              (k > 0 ? "," : "") +
              componentEnrichmentConfig[k].id +
              ":" +
              (componentEnrichmentConfig[k].rePurchaseable
                ? componentEnrichmentConfig[k].rePurchaseable
                : false);
            tempEnrichmentConfig.visible +=
              (k > 0 ? "," : "") +
              componentEnrichmentConfig[k].id +
              ":" +
              (componentEnrichmentConfig[k].visible
                ? componentEnrichmentConfig[k].visible
                : false);
          }
          data.components[i].enrichmentConfig = tempEnrichmentConfig;
        } else {
          data.components[i].enrichmentConfig = {};
        }
        if (data.components[i].remove) {
          data.components.splice(i, 1);
        }
      }
      data.selectionType = {};
      for (var key in this.state.selectionType) {
        if (this.state.selectionType.hasOwnProperty(key)) {
          var val = this.state.selectionType[key];
          if (val) {
            data.selectionType[key] = val;
          } else {
            data.selectionType[key] = "";
          }
        }
      }
      data.expiryDate = this.dateValidator(this.state.expiryDate);
      data.releaseDate = this.dateValidator(this.state.releaseDate);
      data.termTenure = this.state.termTenure;
      data.termTenureUOM = this.state.termTenureUOM;
      data.termNoticePeriod = this.state.termNoticePeriod;
      data.termNoticePeriodUOM = this.state.termNoticePeriodUOM;
      data.orderApproval = this.state.orderApproval;
      data.billingTriggerPhase = this.state.billingTriggerPhase;
      data.selectedBucket = this.state.selectedBucket;
      data.billingTriggerProdId = this.state.billingTriggerProdId;
      data.routing = this.state.routing;
      data.preQuals = this.state.preQuals ? this.state.preQuals : [];
      let josnFile =
        "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(data));
      var link = document.createElement("a");
      link.href = "data:" + josnFile;
      link.download = this.state.basicDetail.productName
        ? this.state.basicDetail.productName + ".json"
        : "packaged solution" + ".json";
      this.setState({
        loading: false,
      });
      link.dispatchEvent(new MouseEvent("click"));
      this.setState({
        loading: false,
      });
    }, 1000);
  };

  goToComponent = (row) => {
    let globalIds = []
    const foundItem = this.state.productBucketList.find((item) => item.id === row.componentType);
    const foundGlobalItem = this.state.globalProducts.find((item) => item.id === row.componentType);
    if (foundItem != undefined) {
      this.setState({
        renderAssociatedConst: false,
        leafNodes: [],
        tabValue: foundItem.sequenceNum,
        subTabValue: 0,
        parentTabValue: 1,
      }, () => {
        this.setState({
          bucketSeqNum: foundItem.sequenceNum,
          bucketName: foundItem.name,
          selectedBucketId: foundItem.id
        }, () => {
          this.setCurrentBucketItems();
          this.setState({
            showOfferingSummary: false,
            renderAssociatedConst: true
          })
        })
      })
    }
    else if (foundItem == undefined && foundGlobalItem == undefined && row != undefined) {
      const selectedRowId = this.findCategoryById(this.state.productBucketList, row.componentType);
      if (this.state.productBucketList && row.componentType != undefined) {
        const parent = this.findParent(this.state.productBucketList, row.componentType);
        const leafNodes = parent.subCategories;
        //check if has sub categories
        if (selectedRowId != undefined && parent.subCategories) {
          this.setState({
            renderAssociatedConst: true,
            leafNodes: leafNodes,
            tabValue: selectedRowId.sequenceNum,
            subTabValue: 0,
            parentTabValue: 1,
          }, () => {
            this.setState({
              bucketSeqNum: selectedRowId.sequenceNum,
              bucketName: selectedRowId.name,
              selectedBucketId: selectedRowId.id
            }, () => {
              this.setCurrentBucketItems();
              this.setState({
                showOfferingSummary: false,
                renderAssociatedConst: true
              })
            })
          })
        }
      }
    }
    else if (foundGlobalItem != undefined) {
      this.setState({
        renderAssociatedConst: false,
        leafNodes: [],
        tabValue: foundGlobalItem.sequenceNum,
        subTabValue: 0,
        parentTabValue: 2,
      }, () => {
        this.setState({
          bucketSeqNum: foundGlobalItem.sequenceNum,
          bucketName: foundGlobalItem.name,
          selectedBucketId: foundGlobalItem.id
        }, () => {
          this.setCurrentBucketItems();
          this.setState({
            showOfferingSummary: false,
            renderAssociatedConst: true
          })
        })
      })
    }
  }

  findCategoryById = (categories, idToFind) => {
    for (const cat of categories) {
      if (cat.id === idToFind) {
        return cat; // found match
      }
      if (cat.subCategories && cat.subCategories.length > 0) {
        const result = this.findCategoryById(cat.subCategories, idToFind);
        if (result) return result;
      }
    }
    return null; // not found
  }

  findParent = (categories, targetId) => {
    for (const cat of categories) {
      if (cat.subCategories) {
        for (const sub of cat.subCategories) {
          if (sub.id === targetId) {
            return cat; // found immediate parent
          }
        }
        const result = this.findParent(cat.subCategories, targetId);
        if (result) return result;
      }
    }
    return null;
  }


  offeringSummary = () => {
    let comp = [];
    this.setState({
      loading: true
    })
    this.basicDetailsRef.forceNext(false);
    let data = {};
    data.components = this.state.components;
    for (var i = 0; i < data.components.length; i++) {
      let organisedJson = {}
      organisedJson.name = data.components[i].name
      organisedJson.price = data.components[i].price
      organisedJson.priceTenure = data.components[i].priceTenure
      organisedJson.priceTenureUOM = data.components[i].priceTenureUOM
      organisedJson.priceType = this.props.t(data.components[i].priceType)
      organisedJson.featureCode = data.components[i].featureCode
      organisedJson.minimumPrice = data.components[i].minimumPrice
      organisedJson.description = data.components[i].description
      organisedJson.componentType = data.components[i].componentType
      organisedJson.componentTypeName = data.components[i].componentTypeName
      organisedJson.margin = data.components[i].margin
      organisedJson.minimumPrice = data.components[i].minimumPrice
      organisedJson.chipData = data.components[i].chipData
      comp.push(organisedJson)
    }
    data.expiryDate = this.dateValidator(this.state.expiryDate);
    data.releaseDate = this.dateValidator(this.state.releaseDate)
    this.setState({
      loading: false,
      showOfferingSummary: true,
      totalProductCountInOffering: data.components.length,
      prettyJson: comp
    })
  }

  dateValidator = (date) => {
    if (date === undefined || date === null || date == "") {
      date = "";
    } else {
      date = moment(date).format("yyyy-MM-DD");
    }
    return date;
  };

  changeTableData = (e, row) => {
    this.blockNavigation();
    let controlName = e.target.name;
    let controlValue = e.target.value;
    if (controlName === "price" || controlName === "displaySequence") {
      if (isNaN(controlValue)) {
        return;
      } else if (controlValue < 0) {
        return;
      }
    }
    let components = [...this.state.components];
    let tempIndex = components.findIndex((a) => a.id === row.id);
    if (row.add === false) {
      row.edit = true;
    }
    if (controlName === "applySpecialPrice") {
      this.applyPromo(components[tempIndex], e);
    } else {
      components[tempIndex][controlName] = controlValue;
    }
    if (
      this.state.packageMode == "promo" &&
      (controlName === "price" || controlName === "featureCode")
    ) {
      this.applyPromoForcefully(components[tempIndex]);
    }
    this.setState({
      components,
    });
  };

  changeTableCompleteRowData = (row) => {
    let components = [...this.state.components];
    let tempIndex = components.findIndex(
      (a) => a.featureCode === row.featureCode,
    );
    components[tempIndex] = row;
    components[tempIndex].name = components[tempIndex].name.trim();
    components[tempIndex].description =
      components[tempIndex].description.trim();
    components[tempIndex].edit = true;
    components[tempIndex].relationShips = {
      dependsOn: row.chipData,
    };
    for (var i = 0; i < components.length; i++) {
      if (
        components[i].relationShips &&
        components[i].relationShips.dependsOn &&
        components[i].relationShips.dependsOn.length > 0
      ) {
        for (var j = 0; j < components[i].relationShips.dependsOn.length; j++) {
          if (
            components[i].relationShips.dependsOn[j].depender ===
            row.featureCode
          ) {
            components[i].relationShips.dependsOn[j].dependerName = row.name;
            components[i].edit = true;
            var dependedIndex = components[i].chipData.findIndex(
              (x) => x.depender === row.featureCode,
            );
            if (dependedIndex > -1) {
              components[i].chipData[dependedIndex].dependerName = row.name;
            }
          }
        }
      }
    }
    this.setState(
      {
        components,
      },
      () => {
        this.setCurrentBucketItems();
      },
    );
  };

  sortTableItems = () => {
    let components = [...this.state.components];
    components.sort((a, b) =>
      a && b ? a.displaySequence - b.displaySequence : 0,
    );
    this.setState({
      components,
    });
  };

  changeSelectionType = (e, bucketId) => {
    let selectionType = { ...this.state.selectionType };
    let selectionTypeMinLimit = { ...this.state.selectionTypeMinLimit };
    let selectionTypeMaxLimit = { ...this.state.selectionTypeMaxLimit };

    selectionType[bucketId] = e.target.value;
    if (e.target.value !== "LIMIT") {
      delete selectionTypeMinLimit[bucketId];
      delete selectionTypeMaxLimit[bucketId];
    }
    this.setState({
      selectionType,
      selectionTypeMinLimit,
      selectionTypeMaxLimit,
    });
  };


  expandVariantDetails = (e, row, expandVarinatValue) => {
    let components = [...this.state.components];
    let tempIndex = components.findIndex((a) => a.id === row.id);
    components[tempIndex].expandVariants = expandVarinatValue;
    components[tempIndex].expandEnrichment = false;
    this.setState({ components }, () => {
      this.setCurrentBucketItems();
    });
  };

  expandOtherPrices = (e, row, expandValue) => {
    let components = [...this.state.components];
    let tempIndex = components.findIndex((a) => a.id === row.id);
    components[tempIndex].expandOtherPrices = expandValue;
    // components[tempIndex].expandEnrichment = false;
    this.setState({ components }, () => {
      this.setCurrentBucketItems();
    });
  };

  expandComponentDetails = (e, row, value) => {
    let components = [...this.state.components];
    let tempIndex = components.findIndex((a) => a.id === row.id);
    components[tempIndex].expandComponents = value;
    this.setState({ components });
  };

  changeIsViewable = (e, row) => {
    let components = [...this.state.components];
    // let tempIndex = components.findIndex((a) => a.id === row.id);
    let tempIndex = components.findIndex(
      (a) =>
        a.featureCode === row.featureCode &&
        a.originalProviderId === row.originalProviderId,
    );
    if (row.add === false) {
      row.edit = true;
    }
    components[tempIndex].customerViewable = e;
    this.setState({
      components,
    });
  };

  checkUploadedFile = (input) => {
    let file = null;

    // Case 1: input is a FileList (from <input type="file" />)
    if (input instanceof FileList) {
      file = input[input.length - 1];
    }
    // Case 2: input is an array (from Dropzone or similar)
    else if (Array.isArray(input)) {
      const last = input[input.length - 1];
      file = last instanceof File ? last : last?.file || last?.originFileObj || null;
    }
    // Case 3: input is directly a File object
    else if (input instanceof File) {
      file = input;
    }
    // Nothing valid found
    else {
      this.props.setErrorMessage(this.props.t("INVALID_FILE_TYPE"), false);
      return;
    }

    // Still no valid file
    if (!(file instanceof Blob)) {
      console.error("Not a valid File/Blob:", file);
      this.props.setErrorMessage(this.props.t("INVALID_FILE_TYPE"), false);
      return;
    }

    this.setState({ loading: true });

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const fileContent = event.target.result;
        const jsonData = JSON.parse(fileContent);

        if (!jsonData.basicDetail && !jsonData.components) {
          throw new Error("Invalid JSON structure");
        }

        if (!jsonData.basicDetail?.categoryId) {
          jsonData.basicDetail = { ...jsonData.basicDetail, categoryId: "" };
        }

        this.setState({ renderBasicDetail: false });
        this.importTemplateData(jsonData);
      } catch (error) {
        console.error("File parsing error:", error);
        this.props.setErrorMessage(this.props.t("INVALID_JSON_FILE"), false);
      } finally {
        this.setState({ loading: false });
      }
    };

    reader.onerror = () => {
      console.error("File read error");
      this.setState({ loading: false });
      this.props.setErrorMessage(this.props.t("FILE_READ_ERROR"), false);
    };

    reader.readAsText(file);
  };

  importTemplateData = (template) => {
    const formatPrice = (price) => {
      return parseFloat(price).toFixed(2);
    };

    if (template.basicDetail && template.basicDetail.productName) {
      template.basicDetail.productName =
        template.basicDetail.productName.trim();
    }
    if (template.basicDetail && template.basicDetail.featureCode) {
      template.basicDetail.featureCode =
        template.basicDetail.featureCode.trim();
    }
    if (template.basicDetail && template.basicDetail.productDescription) {
      template.basicDetail.productDescription =
        template.basicDetail.productDescription.trim();
    }
    for (var i = 0; i < template.components.length; i++) {
      if (template.components[i].priceTenureUOM === "MONTH") {
        template.components[i].priceTenureUOM = "TF_mon";
      }

      if (template.components[i].price) {
        template.components[i].price = formatPrice(
          template.components[i].price,
        );
      }
      if (
        template.components[i].otherPrices &&
        Array.isArray(template.components[i].otherPrices)
      ) {
        template.components[i].otherPrices.forEach((priceObj) => {
          if (priceObj.price) {
            priceObj.price = formatPrice(priceObj.price);
          }
          if (priceObj.partnerPrice) {
            priceObj.partnerPrice = formatPrice(priceObj.partnerPrice);
          }
        });
      }

      // set enrichment config
      template.components[i].expandEnrichment = false;
      if (
        template.components[i].enrichmentConfig &&
        Array.isArray(template.components[i].enrichmentConfig)
      ) {
      } else {
        var oldEnrichmentConfig = template.components[i].enrichmentConfig
          ? template.components[i].enrichmentConfig
          : {};
        var tempEnrichmentConfig = [];
        if (
          oldEnrichmentConfig &&
          oldEnrichmentConfig.hasOwnProperty("purchaseable") &&
          oldEnrichmentConfig.purchaseable
        ) {
          var purchaseableList = oldEnrichmentConfig["purchaseable"].split(",");
          var removeableList = oldEnrichmentConfig["removeable"].split(",");
          var rePurchaseableList =
            oldEnrichmentConfig["rePurchaseable"].split(",");
          var visibleList = oldEnrichmentConfig["visible"].split(",");
          // Set purchaseable data
          for (var p = 0; p < purchaseableList.length; p++) {
            if (tempEnrichmentConfig.length > 0) {
              var ind = tempEnrichmentConfig.findIndex(
                (x) => x.id === purchaseableList[p].split(":")[0],
              );
              if (ind > -1) {
                tempEnrichmentConfig[ind].purchaseable = JSON.parse(
                  purchaseableList[p].split(":")[1],
                );
              } else {
                var obj = {
                  id: purchaseableList[p].split(":")[0],
                  purchaseable: JSON.parse(purchaseableList[p].split(":")[1]),
                };
                tempEnrichmentConfig.push(obj);
              }
            } else {
              var obj = {
                id: purchaseableList[p].split(":")[0],
                purchaseable: JSON.parse(purchaseableList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          }
          // Set removeable data
          for (var p = 0; p < removeableList.length; p++) {
            if (tempEnrichmentConfig.length > 0) {
              var ind = tempEnrichmentConfig.findIndex(
                (x) => x.id === removeableList[p].split(":")[0],
              );
              if (ind > -1) {
                tempEnrichmentConfig[ind].removeable = JSON.parse(
                  removeableList[p].split(":")[1],
                );
              } else {
                var obj = {
                  id: removeableList[p].split(":")[0],
                  removeable: JSON.parse(removeableList[p].split(":")[1]),
                };
                tempEnrichmentConfig.push(obj);
              }
            } else {
              var obj = {
                id: removeableList[p].split(":")[0],
                removeable: JSON.parse(removeableList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          }
          // Set rePurchaseable data
          for (var p = 0; p < rePurchaseableList.length; p++) {
            if (tempEnrichmentConfig.length > 0) {
              var ind = tempEnrichmentConfig.findIndex(
                (x) => x.id === rePurchaseableList[p].split(":")[0],
              );
              if (ind > -1) {
                tempEnrichmentConfig[ind].rePurchaseable = JSON.parse(
                  rePurchaseableList[p].split(":")[1],
                );
              } else {
                var obj = {
                  id: rePurchaseableList[p].split(":")[0],
                  rePurchaseable: JSON.parse(
                    rePurchaseableList[p].split(":")[1],
                  ),
                };
                tempEnrichmentConfig.push(obj);
              }
            } else {
              var obj = {
                id: rePurchaseableList[p].split(":")[0],
                rePurchaseable: JSON.parse(rePurchaseableList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          }
          // Set visible data
          for (var p = 0; p < visibleList.length; p++) {
            if (tempEnrichmentConfig.length > 0) {
              var ind = tempEnrichmentConfig.findIndex(
                (x) => x.id === visibleList[p].split(":")[0],
              );
              if (ind > -1) {
                tempEnrichmentConfig[ind].visible = JSON.parse(
                  visibleList[p].split(":")[1],
                );
              } else {
                var obj = {
                  id: visibleList[p].split(":")[0],
                  visible: JSON.parse(visibleList[p].split(":")[1]),
                };
                tempEnrichmentConfig.push(obj);
              }
            } else {
              var obj = {
                id: visibleList[p].split(":")[0],
                visible: JSON.parse(visibleList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          }
        }
        template.components[i].enrichmentConfig = tempEnrichmentConfig;
      }
    }
    if (template.basicDetail.productTerms) {
      this.setState({
        // productTermsState: EditorState.createWithContent(
        //   convertFromRaw(JSON.parse(template.basicDetail.productTerms)),
        // ),
        productTerms: template.basicDetail.productTerms,
        productTermsTemplate: template.basicDetail.productTermsTemplate,
        localisedProductTerms: template.basicDetail.localisedProductTerms,
        localisedProductTermsTemplate:
          template.basicDetail.localisedProductTermsTemplate,
      });
    }
    this.setState(
      {
        basicDetail: template.basicDetail ? { ...template.basicDetail } : {},
        components: template.components ? [...template.components] : [],
        billingTriggerPhase: template.billingTriggerPhase
          ? template.billingTriggerPhase
          : "DEFAULT",
        billingTriggerProdId: template.billingTriggerProdId
          ? template.billingTriggerProdId
          : "",
        orderApproval: template.orderApproval ? template.orderApproval : true,
        selectedBucket: template.selectedBucket ? template.selectedBucket : "",
        selectionType: template.selectionType ? template.selectionType : {},
        preQuals: template.preQuals ? template.preQuals : [],
        expiryDate: this.dateValidator(template.expiryDate),
        releaseDate: this.dateValidator(template.releaseDate),
        termTenure: template.termTenure ? template.termTenure : "",
        termTenureUOM: template.termTenureUOM ? template.termTenureUOM : "",
        termNoticePeriod: template.termNoticePeriod ? template.termNoticePeriod : "",
        termNoticePeriodUOM: template.termNoticePeriodUOM ? template.termNoticePeriodUOM : "",
        routing: template.routing
          ? template.routing
          : {
            name: "",
            description: "",
            routingTasks: [],
          },
        importOffering: true,
      },
      () => {
        this.setState({
          renderBasicDetail: true,
          loading: false,
        });
      },
    );
  };

  onFilesError = (error, file) => {
    console.log("error code " + error.code + ": " + error.message);
  };

  updateMargin = (per) => {
    this.setState({
      topLevelMargin: per,
    });
    // Update packaged solution starting price with margin
    let bdCopy = { ...this.state.basicDetail };
    let price = bdCopy.originalStartingPrice;
    let tempComponents = [...this.state.components];
    let margin = (price / 100) * per;
    // bdCopy.startingPrice = (JSON.parse(price) + JSON.parse(margin)).toFixed(2) + "";
    bdCopy.startingPrice = (
      Math.round(
        (JSON.parse(price) + JSON.parse(margin) + Number.EPSILON) * 100,
      ) / 100
    ).toFixed(2);

    // Update components price with margin
    for (var i = 0; i < tempComponents.length; i++) {
      if (tempComponents[i] && tempComponents[i].originalPrice) {
        let cPrice = tempComponents[i].originalPrice;
        let cMargin = (cPrice / 100) * per;
        // tempComponents[i].price = (JSON.parse(cPrice) + JSON.parse(cMargin)).toFixed(2) + "";
        tempComponents[i].price = (
          Math.round(
            (JSON.parse(cPrice) + JSON.parse(cMargin) + Number.EPSILON) * 100,
          ) / 100
        ).toFixed(2);

        tempComponents[i].partnerPrice = tempComponents[i].originalPrice;
        tempComponents[i].minimumPrice = tempComponents[i].originalMinimumPrice
          ? tempComponents[i].originalMinimumPrice
          : "0";
        tempComponents[i].margin = {
          marginValue: per,
          minimumMarginValue: "0",
          marginType: "PERCENTAGE",
        };

        if (
          tempComponents[i].variants &&
          tempComponents[i].variants.length > 0
        ) {
          for (var v = 0; v < tempComponents[i].variants.length; v++) {
            let vPrice = tempComponents[i].variants[v].originalPrice;
            let vMargin = (vPrice / 100) * per;
            // tempComponents[i].variants[v].price = (JSON.parse(vPrice) + JSON.parse(vMargin)).toFixed(2) + "";
            tempComponents[i].variants[v].price = (
              Math.round(
                (JSON.parse(vPrice) + JSON.parse(vMargin) + Number.EPSILON) *
                100,
              ) / 100
            ).toFixed(2);
            tempComponents[i].variants[v].partnerPrice = vPrice + "";
          }
        }

        if (
          tempComponents[i].otherPrices &&
          tempComponents[i].otherPrices.length > 0
        ) {
          for (var o = 0; o < tempComponents[i].otherPrices.length; o++) {
            let oPrice = tempComponents[i].otherPrices[o].originalPrice;
            let oMargin = (oPrice / 100) * per;
            // tempComponents[i].otherPrices[o].price = (JSON.parse(oPrice) + JSON.parse(oMargin)).toFixed(2) + "";
            tempComponents[i].otherPrices[o].price = (
              Math.round(
                (JSON.parse(oPrice) + JSON.parse(oMargin) + Number.EPSILON) *
                100,
              ) / 100
            ).toFixed(2);
            tempComponents[i].otherPrices[o].partnerPrice = "" + oPrice;
            tempComponents[i].otherPrices[o].minimumPrice = "";
          }
        }
      }
    }

    this.setState({
      basicDetail: bdCopy,
      components: tempComponents,
    });
  };

  updateTrigger = (e) => {
    let inputName = e.target.name;
    let inputValue = e.target.value;
    if (inputName === "orderApproval") {
      this.setState({
        orderApproval: !this.state.orderApproval,
      });
    } else if (inputName === "billingTriggerPhase") {
      this.setState({
        billingTriggerPhase: inputValue,
        selectedBucket: "",
        billingTriggerProdId: "",
      });
    } else {
      this.setState({
        [inputName]: inputValue,
        error: {},
      });
    }
  };

  updateOfferingTerm = (e) => {
    this.props.setErrorMessage("");
    let inputName = e.target.name;
    let inputValue = e.target.value;
    if (inputName === "termTenure" || inputName === "termNoticePeriod") {
      if (inputValue >= 0) {
        // if (inputName === 'termNoticePeriod') {
        //     if (inputValue > this.state.termTenure) {
        //         this.props.setErrorMessage(this.props.t('TERM_NOTICE_PERIOD_GREATER_ERROR'), false)
        //         return;
        //     }
        // }
        // if (inputName === 'termTenure') {
        //     if (inputValue < this.state.termNoticePeriod) {
        //         this.props.setErrorMessage(this.props.t('TERM_NOTICE_PERIOD_LESSER_ERROR'), false)
        //         return;
        //     }
        // }
        this.setState({
          [inputName]: inputValue,
        });
      }
    } else {
      this.setState({
        [inputName]: inputValue,
      });
    }
  };

  addPackageReviewComments = (e) => {
    let inputName = e.target.name;
    let inputValue = e.target.value;
    this.setState({
      [inputName]: inputValue,
    });
  };

  addTermsCond = () => {
    if (this.state.termsText && this.state.termsUrl) {
      let bdCopy = { ...this.state.basicDetail };
      bdCopy.terms = bdCopy.terms ? [...bdCopy.terms] : [];
      bdCopy.terms.push({
        termsText: this.state.termsText,
        termsUrl: this.state.termsUrl,
      });
      this.setState({
        basicDetail: bdCopy,
        termsText: "",
        termsUrl: "",
      });
    }
  };

  changeProductTermsLocale = (e) => {
    var val = e.target.value;
    this.setState({
      productTermsLocale: val,
    });
    var localisedData = [];
    if (
      this.state.localisedProductTerms &&
      this.state.localisedProductTerms.length > 0
    ) {
      localisedData = [...this.state.localisedProductTerms];
    } else {
      localisedData = [];
    }
    var localisedTemplateData = [];
    if (
      this.state.localisedProductTermsTemplate &&
      this.state.localisedProductTermsTemplate.length > 0
    ) {
      localisedTemplateData = [...this.state.localisedProductTermsTemplate];
    } else {
      localisedTemplateData = [];
    }
    if (localisedData && localisedData.length > 0) {
      var index = localisedData.findIndex((x) => x.locale === val);
      var hIndex = localisedTemplateData.findIndex((x) => x.locale === val);
      if (index > -1) {
        this.setState({
          // productTermsState: EditorState.createWithContent(
          //   convertFromRaw(JSON.parse(localisedData[index].text)),
          // ),
          productTerms: localisedData[index].text,
          productTermsTemplate: localisedTemplateData[hIndex].text,
        });
      } else {
        localisedData.push({
          text: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
          locale: val,
        });
        localisedTemplateData.push({
          text: "",
          locale: val,
        });
        this.setState({
          localisedProductTerms: localisedData,
          localisedProductTermsTemplate: localisedTemplateData,
          productTerms:
            '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
          // productTermsState: EditorState.createEmpty(),
          productTermsTemplate: "",
        });
      }
    }
  };
  // onChangeTerms = (state) => {
  //   var rawState = convertToRaw(state.getCurrentContent());
  //   var localisedData = [];
  //   if (
  //     this.state.localisedProductTerms &&
  //     this.state.localisedProductTerms.length > 0
  //   ) {
  //     localisedData = [...this.state.localisedProductTerms];
  //   } else {
  //     localisedData = [];
  //   }
  //   var localisedTemplateData = [];
  //   if (
  //     this.state.localisedProductTermsTemplate &&
  //     this.state.localisedProductTermsTemplate.length > 0
  //   ) {
  //     localisedTemplateData = [...this.state.localisedProductTermsTemplate];
  //   } else {
  //     localisedTemplateData = [];
  //   }

  //   var textObj = {
  //     locale: this.state.productTermsLocale,
  //     text: JSON.stringify(convertToRaw(state.getCurrentContent())),
  //   };
  //   var templateObj = {
  //     locale: this.state.productTermsLocale,
  //     text: draftToHtml(rawState),
  //   };

  //   if (localisedData && localisedData.length > 0) {
  //     var index = localisedData.findIndex(
  //       (x) => x.locale === this.state.productTermsLocale,
  //     );
  //     localisedData[index] = textObj;
  //     var hIndex = localisedTemplateData.findIndex(
  //       (x) => x.locale === this.state.productTermsLocale,
  //     );
  //     localisedTemplateData[hIndex] = templateObj;
  //   } else {
  //     localisedData.push(textObj);
  //     localisedTemplateData.push(templateObj);
  //   }

  //   this.setState({
  //     productTermsState: state,
  //     productTermsTemplate: draftToHtml(rawState),
  //     productTerms: JSON.stringify(convertToRaw(state.getCurrentContent())),
  //     localisedProductTerms: localisedData,
  //     localisedProductTermsTemplate: localisedTemplateData,
  //   });
  //   // store data in editor state:
  //   // this.setState({
  //   //     [e.target.name]: e.target.value
  //   // })
  // };

  onChangeTerms = (jsonString) => {
    // TiptapEditor passes JSON string
    const { productTermsLocale, localisedProductTerms, localisedProductTermsTemplate } = this.state;

    // Parse the JSON string back to raw object
    const rawState = JSON.parse(jsonString);

    // Convert to HTML for template using the converter
    const html = draftRawToHTML(jsonString);

    // Clone localization arrays
    const localisedData = Array.isArray(localisedProductTerms)
      ? [...localisedProductTerms]
      : [];
    const localisedTemplateData = Array.isArray(localisedProductTermsTemplate)
      ? [...localisedProductTermsTemplate]
      : [];

    // Create text + template objects
    const textObj = {
      locale: productTermsLocale,
      text: jsonString,  // Store the JSON string
    };

    const templateObj = {
      locale: productTermsLocale,
      text: html,  // Store the HTML
    };

    // Update or insert for this locale
    const termIndex = localisedData.findIndex(
      (x) => x.locale === productTermsLocale,
    );
    const templateIndex = localisedTemplateData.findIndex(
      (x) => x.locale === productTermsLocale,
    );

    if (termIndex > -1) {
      localisedData[termIndex] = textObj;
    } else {
      localisedData.push(textObj);
    }

    if (templateIndex > -1) {
      localisedTemplateData[templateIndex] = templateObj;
    } else {
      localisedTemplateData.push(templateObj);
    }

    this.setState({
      productTerms: jsonString,  // Don't stringify again - it's already a string
      productTermsTemplate: html,
      localisedProductTerms: localisedData,
      localisedProductTermsTemplate: localisedTemplateData,
    });
  };


  removeTermAndCond = (index) => {
    let bdCopy = { ...this.state.basicDetail };
    bdCopy.terms.splice(index, 1);
    this.setState({
      basicDetail: bdCopy,
    });
  };

  editTermAndCond = (item, index) => {
    let data = item;
    data.index = index;
    this.state.termCondToEdit = data;
    this.setState({
      termsText: item.termsText,
      termsUrl: item.termsUrl,
    });
  };

  updateTermsCond = () => {
    let bdCopy = { ...this.state.basicDetail };
    bdCopy.terms = bdCopy.terms ? [...bdCopy.terms] : [];
    bdCopy.terms[this.state.termCondToEdit.index].termsText =
      this.state.termsText;
    bdCopy.terms[this.state.termCondToEdit.index].termsUrl =
      this.state.termsUrl;
    this.setState({
      basicDetail: bdCopy,
      termsText: "",
      termsUrl: "",
      termCondToEdit: null,
    });
  };

  changeDisplaySequence = (dir, row) => {
    let components = [...this.state.components];
    let index = components.findIndex((a) => a.id === row.id);
    if (dir === "up") {
      if (row.displaySequence > 1) {
        components[index].displaySequence = JSON.stringify(
          JSON.parse(components[index].displaySequence - 1),
        );
        components[index].edit = true;
        for (var i = 0; i < components.length; i++) {
          if (components[i].componentType === row.componentType) {
            if (components[i].id !== row.id && !components[i].remove) {
              if (
                components[i].displaySequence ==
                components[index].displaySequence
              ) {
                components[i].displaySequence = JSON.stringify(
                  JSON.parse(components[i].displaySequence) + 1,
                );
                components[i].edit = true;
              }
            }
          }
        }
      }
    } else {
      if (row.displaySequence < this.state.currentBucketItems.length) {
        components[index].displaySequence = JSON.stringify(
          JSON.parse(components[index].displaySequence) + 1,
        );
        components[index].edit = true;
        for (var i = 0; i < components.length; i++) {
          if (components[i].componentType === row.componentType) {
            if (components[i].id !== row.id && !components[i].remove) {
              if (
                components[i].displaySequence ==
                components[index].displaySequence
              ) {
                components[i].displaySequence = JSON.stringify(
                  JSON.parse(components[i].displaySequence) - 1,
                );
                components[i].edit = true;
              }
            }
          }
        }
      }
    }
    this.setState(
      {
        components,
      },
      () => {
        this.setCurrentBucketItems();
      },
    );
  };

  onChangePackagedSolutionName = (name) => {
    let tempBread = this.state.bread;
    if (this.state.addToCatalog === "true") {
      if (tempBread.length < 2) {
        tempBread.push({ title: name, url: "/updatePackage" });
      } else {
        tempBread[1].title = name;
      }
    } else {
      if (this.state.packageMode === "edit") {
        tempBread[1].title = name;
      } else {
        if (tempBread.length === 1) {
          tempBread.push({
            title: name,
            url: "/createPackage",
          });
        } else {
          tempBread[1].title = name;
        }
      }
    }
    this.setState(
      {
        renderBread: false,
        bread: tempBread,
      },
      () => {
        this.setState({
          renderBread: true,
        });
      },
    );
  };

  // Assembly Instruction Methods
  addInstruction = () => {
    let tempData = { ...this.state.routing };
    let instruction = {
      name: "",
      sequenceNum: tempData.routingTasks.length + 1,
      description: "",
      estimatedCompletionTimeInSeconds: "",
    };
    tempData.routingTasks.push(instruction);
    this.setState({
      routing: tempData,
    });
  };

  onInstructionChange = (e, index) => {
    let tempData = { ...this.state.routing };
    if (e.target.name === "estimatedCompletionTimeInSeconds") {
      var reg = /^\d+$/;
      if (e.target.value === "" || reg.test(e.target.value)) {
        tempData.routingTasks[index][e.target.name] = e.target.value;
      }
    } else {
      tempData.routingTasks[index][e.target.name] = e.target.value;
    }
    this.setState({
      routing: tempData,
    });
  };

  removeInstruction = (index) => {
    let tempData = { ...this.state.routing };
    for (var i = 0; i < tempData.routingTasks.length; i++) {
      if (i > index) {
        tempData.routingTasks[i].sequenceNum =
          tempData.routingTasks[i].sequenceNum - 1;
      }
    }
    tempData.routingTasks.splice(index, 1);
    tempData.routingTasks.sort((a, b) =>
      a && b ? a.sequenceNum - b.sequenceNum : 0,
    );
    this.setState({
      routing: tempData,
    });
  };

  changeInstructionSequence = (dir, index) => {
    let tempData = { ...this.state.routing };
    if (dir === "up") {
      if (tempData.routingTasks[index].sequenceNum > 1) {
        tempData.routingTasks[index - 1].sequenceNum =
          tempData.routingTasks[index - 1].sequenceNum + 1;
        tempData.routingTasks[index].sequenceNum =
          tempData.routingTasks[index].sequenceNum - 1;
      }
    } else {
      tempData.routingTasks[index + 1].sequenceNum =
        tempData.routingTasks[index + 1].sequenceNum - 1;
      tempData.routingTasks[index].sequenceNum =
        tempData.routingTasks[index].sequenceNum + 1;
    }
    tempData.routingTasks.sort((a, b) =>
      a && b ? a.sequenceNum - b.sequenceNum : 0,
    );
    this.setState({
      routing: tempData,
    });
  };

  onChangeRoutingData = (e) => {
    let tempData = { ...this.state.routing };
    tempData[e.target.name] = e.target.value;
    this.setState({
      routing: tempData,
    });
  };

  setLoading = (val) => {
    this.setState({
      loading: val,
    });
  };

  addPreQual = (data) => {
    var preQuals = [...this.state.preQuals];
    preQuals.push(data);
    this.setState({ preQuals });
  };

  deletePreQual = (index) => {
    var preQuals = [...this.state.preQuals];
    preQuals.splice(index, 1);
    this.setState({ preQuals });
  };

  editPreQual = (object, index) => {
    var preQuals = [...this.state.preQuals];
    preQuals[index] = object;
    this.setState({ preQuals });
  };

  // Enrichment code start

  // selectEnrichmentChannel = (selectedItem, parentId) => {
  //     let components = [...this.state.components];
  //     let tempIndex = components.findIndex((a) => a.id === parentId);
  //     components[tempIndex].selectedEnrichmentChannel = selectedItem;
  //     this.setState({ components });
  // }

  // addEnrichmentRow = (parentId) => {
  //     let components = [...this.state.components];
  //     let tempIndex = components.findIndex((a) => a.id === parentId);
  //     if (components[tempIndex].selectedEnrichmentChannel) {
  //         var row = {
  //             id: components[tempIndex].selectedEnrichmentChannel,
  //             purchaseable: false,
  //             removeable: false,
  //             rePurchaseable: false,
  //             visible: false,
  //         }
  //         components[tempIndex].enrichmentConfig.push(row);
  //         components[tempIndex].edit = true;
  //         components[tempIndex].selectedEnrichmentChannel = '';
  //         this.setState({ components });
  //     }
  // }

  addEnrichmentRow = (row, parentId) => {
    let components = [...this.state.components];
    let tempIndex = components.findIndex((a) => a.id === parentId);
    components[tempIndex].enrichmentConfig.push(row);
    if (!components[tempIndex].add) {
      components[tempIndex].edit = true;
    }
    this.setState({ components });
  };

  expandEnrichmentDetails = (e, row, value) => {
    let components = [...this.state.components];
    let tempIndex = components.findIndex((a) => a.id === row.id);
    components[tempIndex].expandEnrichment = value;
    components[tempIndex].expandVariants = false;
    this.setState({ components }, () => {
      this.setCurrentBucketItems();
    });
  };

  changeEnrichmentRow = (e, index, parentId) => {
    let components = [...this.state.components];
    let tempIndex = components.findIndex((a) => a.id === parentId);
    components[tempIndex].enrichmentConfig[index][e.target.name] =
      !components[tempIndex].enrichmentConfig[index][e.target.name];
    if (!components[tempIndex].add) {
      components[tempIndex].edit = true;
    }
    this.setState({ components });
  };

  deleteEnrichment = (index, parentId) => {
    let components = [...this.state.components];
    let tempIndex = components.findIndex((a) => a.id === parentId);
    components[tempIndex].enrichmentConfig.splice(index, 1);
    if (!components[tempIndex].add) {
      components[tempIndex].edit = true;
    }
    this.setState({ components });
  };

  // Enrichment code ends

  switchParentTab = (event, newValue, childTabValue, tabValue1, tabValue2) => {
    if (this.state.parentTabValue === 1 && newValue !== 1) {
      if (!this.validateSelectionTypeLimits()) {
        return;
      }
    }
    if (Object.keys(this.state.unsavedData).length > 0) {
      this.setState({
        tempNewValue: {
          tab: newValue,
          childTab: childTabValue,
          origin: "parentTab",
        },
        openUnsavedChangesModal: true,
      });
    } else {
      let timeOutValue = 0;
      if (
        this.state.parentTabValue === 0 &&
        this.state.packageMode != "promo"
      ) {
        timeOutValue = 600;
        this.basicDetailsRef.forceNext(false);
      }
      setTimeout(() => {
        if (
          this.validatePackagedSolutionData(
            newValue === 0
              ? this.state.parentTabValue !== newValue
                ? false
                : true
              : false,
          )
        ) {
          if (newValue === 1) {
            this.setState(
              {
                renderAssociatedConst: false,
                tabValue: childTabValue ? childTabValue : 0,
                subTabValue: tabValue1 ? tabValue1 : 0,
                subTabValue2: tabValue2 ? tabValue2 : 0,
                activeTabId: childTabValue ? childTabValue : 0,

                leafNodes: [],
              },
              () => { },
            );

            const leafSubcategory = this.getLeafSubcategory(
              this.state.productBucketList[0].subCategories,
            );
            if (leafSubcategory) {
              this.setState(
                {
                  //bucketId: bucket.id,
                  bucketSeqNum: leafSubcategory.sequenceNum,
                  bucketName: leafSubcategory.name,
                  selectedBucketId: leafSubcategory.id,
                },
                () => {
                  this.setCurrentBucketItems();
                  this.setState({
                    renderAssociatedConst: true,
                  });
                },
              );
            } else {
              this.setState(
                {
                  //bucketId: bucket.id,
                  bucketSeqNum:
                    this.state.productBucketList[
                      childTabValue ? childTabValue : 0
                    ].sequenceNum,
                  bucketName:
                    this.state.productBucketList[
                      childTabValue ? childTabValue : 0
                    ].name,
                  selectedBucketId:
                    this.state.productBucketList[
                      childTabValue ? childTabValue : 0
                    ].id,
                },
                () => {
                  this.setCurrentBucketItems();
                  this.setState({
                    renderAssociatedConst: true,
                  });
                },
              );
            }
          }
          if (newValue === 2) {
            if (
              this.state.auxBucketsList &&
              this.state.auxBucketsList.length > 0
            ) {
              this.setState(
                {
                  renderAssociatedConst: false,
                  auxiliaryTabValue: childTabValue ? childTabValue : 0,
                },
                () => { },
              );
              const leafSubcategory = this.getLeafSubcategory(
                this.state.auxBucketsList[0].subCategories,
              );
              if (leafSubcategory) {
                this.setState(
                  {
                    //bucketId: bucket.id,
                    bucketSeqNum: leafSubcategory.sequenceNum,
                    bucketName: leafSubcategory.name,
                    selectedBucketId: leafSubcategory.id,
                  },
                  () => {
                    this.setCurrentBucketItems();
                    this.setState({
                      renderAssociatedConst: true,
                    });
                  },
                );
              } else {
                this.setState(
                  {
                    //bucketId: bucket.id,
                    bucketSeqNum:
                      this.state.auxBucketsList[
                        childTabValue ? childTabValue : 0
                      ].sequenceNum,
                    bucketName:
                      this.state.auxBucketsList[
                        childTabValue ? childTabValue : 0
                      ].name,
                    selectedBucketId:
                      this.state.auxBucketsList[
                        childTabValue ? childTabValue : 0
                      ].id,
                  },
                  () => {
                    this.setCurrentBucketItems();
                    this.setState({
                      renderAssociatedConst: true,
                    });
                  },
                );
              }
            } else {
              this.setState({
                renderAssociatedConst: true,
              });
            }
          }
          if (newValue === 3) {
            var packageBucket = {
              id: "PROD_COMP_PACKAGE",
              name: "Package",
              displayNamePlural: "Package",
              iconName: "local_mall",
              sequenceNum: 9998,
            };
            this.setState(
              {
                renderAssociatedConst: false,
              },
              () => {
                this.setState(
                  {
                    bucketSeqNum: 9998,
                    bucketName: "Package",
                    selectedBucketId: "PROD_COMP_PACKAGE",
                  },
                  () => {
                    this.setCurrentBucketItems();
                    this.setState({
                      renderAssociatedConst: true,
                    });
                  },
                );
              },
            );
          }
          if (newValue === 4) {
            var publishBucket = {
              id: "PROD_COMP_PUBLISH",
              name: "Publish",
              displayNamePlural: "Publish",
              iconName: "publish",
              sequenceNum: 9999,
            };
            this.setState(
              {
                renderAssociatedConst: false,
              },
              () => {
                this.setState(
                  {
                    bucketSeqNum: 9999,
                    bucketName: "Publish",
                    selectedBucketId: "PROD_COMP_PUBLISH",
                  },
                  () => {
                    this.setCurrentBucketItems();
                    this.setState({
                      renderAssociatedConst: true,
                    });
                  },
                );
              },
            );
          }
          this.setState({
            parentTabValue: newValue,
          });
        }
      }, timeOutValue);
    }
  };

  switchAuxTab = (node, index) => {
    this.setState(
      {
        renderAssociatedConst: false,
        auxiliaryTabValue: index,
      },
      () => {
        this.setState(
          {
            //bucketId: bucket.id,
            bucketSeqNum: node.sequenceNum,
            bucketName: node.name,
            selectedBucketId: node.id,
          },
          () => {
            this.setCurrentBucketItems();
            this.setState({
              renderAssociatedConst: true,
            });
          },
        );
      },
    );
  };

  switchAuxilliaryTab = (event, newValue) => {
    if (Object.keys(this.state.unsavedData).length > 0) {
      this.setState({
        tempNewValue: {
          tab: newValue,
          childTab: "",
          origin: "aux",
        },
        openUnsavedChangesModal: true,
      });
    } else {
      this.setState(
        {
          renderAssociatedConst: false,
          auxiliaryTabValue: newValue,
        },
        () => {
          this.setState(
            {
              //bucketId: bucket.id,
              bucketSeqNum: this.state.auxBucketsList[newValue].sequenceNum,
              bucketName: this.state.auxBucketsList[newValue].name,
              selectedBucketId: this.state.auxBucketsList[newValue].id,
            },
            () => {
              this.setCurrentBucketItems();
              this.setState({
                renderAssociatedConst: true,
              });
            },
          );
        },
      );
    }
  };

  switchProductsTab = (event, newValue, tabValue1, tabValue2) => {
    if (!this.validateSelectionTypeLimits()) {
      return;
    }
    if (Object.keys(this.state.unsavedData).length > 0) {
      this.setState({
        tempNewValue: {
          tab: newValue,
          childTab: "",
          origin: "products",
        },
        openUnsavedChangesModal: true,
      });
    } else {
      const hasLeaf =
        this.state.productBucketList[newValue].subCategories &&
        this.state.productBucketList[newValue].subCategories[tabValue1 || 0]
          ?.subCategories?.length > 0;
      if (hasLeaf) {
        const leafNodes =
          this.state.productBucketList[newValue].subCategories[tabValue1 || 0]
            .subCategories;
        this.setLeafNodes(leafNodes, newValue, tabValue1 || 0);
        const leafSubcategory = leafNodes[tabValue2 || 0];
        this.setState(
          {
            renderAssociatedConst: false,
            tabValue: newValue,
            subTabValue: tabValue1 ? tabValue1 : 0,
            subTabValue2: tabValue2 ? tabValue2 : 0,
          },
          () => {
            this.setState(
              {
                //bucketId: bucket.id,
                bucketSeqNum: leafSubcategory.sequenceNum,
                bucketName: leafSubcategory.name,
                selectedBucketId: leafSubcategory.id,
              },
              () => {
                this.setCurrentBucketItems();
                this.setState({
                  renderAssociatedConst: true,
                });
              },
            );
          },
        );
      } else {
        this.setLeafNode(this.state.productBucketList[newValue], newValue);
        this.setState(
          {
            renderAssociatedConst: false,
            tabValue: newValue,
            subTabValue: tabValue1 ? tabValue1 : 0,
            subTabValue2: tabValue2 ? tabValue2 : 0,
          },
          () => {
            this.setState(
              {
                //bucketId: bucket.id,
                bucketSeqNum:
                  this.state.productBucketList[newValue].sequenceNum,
                bucketName: this.state.productBucketList[newValue].name,
                selectedBucketId: this.state.productBucketList[newValue].id,
              },
              () => {
                this.setCurrentBucketItems();
                this.setState({
                  renderAssociatedConst: true,
                });
              },
            );
          },
        );
      }
    }
  };
  switchSubProductsTab = (event, newValue, tabValue2) => {
    if (!this.validateSelectionTypeLimits()) {
      return;
    }
    if (Object.keys(this.state.unsavedData).length > 0) {
      this.setState({
        tempNewValue: {
          tab: newValue,
          childTab: "",
          origin: "products",
        },
        openUnsavedChangesModal: true,
      });
    } else {
      const leafNodes =
        this.state.productBucketList[this.state.tabValue].subCategories[
          newValue
        ].subCategories;
      this.setState({
        leafNodes: leafNodes,
      });
      const leafSubcategory = leafNodes[tabValue2 || 0];
      if (leafSubcategory) {
        this.setState(
          {
            renderAssociatedConst: false,
            subTabValue: newValue,
            subTabValue2: tabValue2 ? tabValue2 : 0,
          },
          () => {
            this.setState(
              {
                bucketSeqNum: leafSubcategory.sequenceNum,
                bucketName: leafSubcategory.name,
                selectedBucketId: leafSubcategory.id,
              },
              () => {
                this.setCurrentBucketItems();
                this.setState({
                  renderAssociatedConst: true,
                });
              },
            );
          },
        );
      } else {
        this.setState(
          {
            renderAssociatedConst: false,
            subTabValue: newValue,
            subTabValue2: tabValue2 ? tabValue2 : 0,
          },
          () => {
            this.setState(
              {
                bucketSeqNum:
                  this.state.productBucketList[this.state.tabValue]
                    .subCategories[newValue].sequenceNum,
                bucketName:
                  this.state.productBucketList[this.state.tabValue]
                    .subCategories[newValue].name,
                selectedBucketId:
                  this.state.productBucketList[this.state.tabValue]
                    .subCategories[newValue].id,
              },
              () => {
                this.setCurrentBucketItems();
                this.setState({
                  renderAssociatedConst: true,
                });
              },
            );
          },
        );
      }
    }
  };
  switchLeafNode = (event, newValue) => {
    if (!this.validateSelectionTypeLimits()) {
      return;
    }
    if (Object.keys(this.state.unsavedData).length > 0) {
      this.setState({
        tempNewValue: {
          tab: newValue,
          childTab: "",
          origin: "products",
        },
        openUnsavedChangesModal: true,
      });
    } else {
      const leafSubcategory = this.state.leafNodes[newValue];
      this.setState(
        {
          renderAssociatedConst: false,
          subTabValue2: newValue,
        },
        () => {
          this.setState(
            {
              bucketSeqNum: leafSubcategory.sequenceNum,
              bucketName: leafSubcategory.name,
              selectedBucketId: leafSubcategory.id,
            },
            () => {
              this.setCurrentBucketItems();
              this.setState({
                renderAssociatedConst: true,
              });
            },
          );
        },
      );
    }
  };
  switchSubProductsTab2 = (event, newValue) => {
    if (!this.validateSelectionTypeLimits()) {
      return;
    }
    if (Object.keys(this.state.unsavedData).length > 0) {
      this.setState({
        tempNewValue: {
          tab: newValue,
          childTab: "",
          origin: "products",
        },
        openUnsavedChangesModal: true,
      });
    } else {
      const leafSubcategory =
        this.state.productBucketList[this.state.tabValue].subCategories[
          this.state.subTabValue
        ].subCategories[newValue];
      if (leafSubcategory) {
        this.setState(
          {
            renderAssociatedConst: false,
            subTabValue2: newValue,
          },
          () => {
            this.setState(
              {
                bucketSeqNum: leafSubcategory.sequenceNum,
                bucketName: leafSubcategory.name,
                selectedBucketId: leafSubcategory.id,
              },
              () => {
                this.setCurrentBucketItems();
                this.setState({
                  renderAssociatedConst: true,
                });
              },
            );
          },
        );
      }
    }
  };

  goBack = () => {
    if (this.state.parentTabValue === 1) {
      if (!this.validateSelectionTypeLimits()) {
        return;
      }
    }
    if (Object.keys(this.state.unsavedData).length > 0) {
      this.setState({
        tempNewValue: {
          tab: "",
          childTab: "",
          origin: "back",
        },
        openUnsavedChangesModal: true,
      });
    } else {
      const {
        subTabValue2,
        leafNodes,
        subTabValue,
        tabValue,
        parentTabValue,
        auxBucketsList,
        auxiliaryTabValue,
        productBucketList,
      } = this.state;
      if (parentTabValue === 4) {
        if (this.state.isPackageBucket) {
          this.switchParentTab("", 3);
        } else if (auxBucketsList.length > 0) {
          this.switchParentTab("", 2);
        } else if (productBucketList.length > 0) {
          this.switchParentTab("", 1);
        } else {
          this.switchParentTab("", 0);
        }
      } else if (parentTabValue === 3) {
        if (auxBucketsList.length > 0) {
          this.switchParentTab("", 2);
        } else if (productBucketList.length > 0) {
          this.switchParentTab("", 1);
        } else {
          this.switchParentTab("", 0);
        }
      } else if (parentTabValue === 2) {
        if (auxiliaryTabValue === 0) {
          if (productBucketList.length > 0) {
            this.switchParentTab("", 1);
          } else {
            this.switchParentTab("", 0);
          }
        } else {
          this.switchAuxTab(
            auxBucketsList[auxiliaryTabValue - 1],
            auxiliaryTabValue - 1,
          );
        }
      } else if (parentTabValue === 1) {
        if (leafNodes && leafNodes.length > 0) {
          if (subTabValue2 > 0) {
            this.switchLeafNode("", subTabValue2 - 1);
          } else if (subTabValue > 0) {
            this.switchSubProductsTab(
              "",
              subTabValue - 1,
              productBucketList[tabValue].subCategories[subTabValue - 1]
                .subCategories.length - 1,
            );
          } else {
            this.switchProductsTab(
              "",
              tabValue - 1,
              productBucketList[tabValue - 1]?.subCategories?.length
                ? productBucketList[tabValue - 1].subCategories.length - 1
                : undefined,
              productBucketList[tabValue - 1]?.subCategories?.[
                productBucketList[tabValue - 1]?.subCategories?.length - 1
              ]?.subCategories?.length
                ? productBucketList[tabValue - 1].subCategories[
                  productBucketList[tabValue - 1].subCategories.length - 1
                ].subCategories.length - 1
                : undefined,
            );
          }
        } else if (tabValue === 0) {
          this.switchParentTab("", 0);
        } else {
          this.switchProductsTab("", tabValue - 1);
        }
      }
    }
  };

  goNext = () => {
    if (this.state.parentTabValue === 1) {
      if (!this.validateSelectionTypeLimits()) {
        return;
      }
    }
    if (Object.keys(this.state.unsavedData).length > 0) {
      this.setState({
        tempNewValue: {
          tab: "",
          childTab: "",
          origin: "next",
        },
        openUnsavedChangesModal: true,
      });
    } else {
      if (this.state.parentTabValue === 1) {
        const { subTabValue2, leafNodes, subTabValue, tabValue } = this.state;

        if (leafNodes && leafNodes.length > 0) {
          if (subTabValue2 < leafNodes.length - 1) {
            this.switchLeafNode("", subTabValue2 + 1);
          } else if (
            subTabValue <
            this.state.productBucketList[tabValue].subCategories.length - 1
          ) {
            this.switchSubProductsTab("", subTabValue + 1);
          } else if (tabValue < this.state.productBucketList.length - 1) {
            this.switchProductsTab("", tabValue + 1);
          } else {
            if (this.state.auxBucketsList.length > 0) {
              this.switchParentTab("", 2);
            } else if (this.state.isPackageBucket) {
              this.switchParentTab("", 3);
            } else {
              this.switchParentTab("", 4);
            }
          }
        } else if (tabValue < this.state.productBucketList.length - 1) {
          this.switchProductsTab("", tabValue + 1);
        } else {
          if (this.state.auxBucketsList.length > 0) {
            this.switchParentTab("", 2);
          } else if (this.state.isPackageBucket) {
            this.switchParentTab("", 3);
          } else {
            this.switchParentTab("", 4);
          }
        }
      } else if (this.state.parentTabValue === 2) {
        if (
          this.state.auxiliaryTabValue <
          this.state.auxBucketsList.length - 1
        ) {
          this.switchAuxTab(
            this.state.auxBucketsList[this.state.auxiliaryTabValue + 1],
            this.state.auxiliaryTabValue + 1,
          );
        } else if (this.state.isPackageBucket) {
          this.switchParentTab("", 3);
        } else {
          this.switchParentTab("", 4);
        }
      } else if (this.state.parentTabValue === 3) {
        this.switchParentTab("", 4);
      } else if (this.state.parentTabValue === 0) {
        if (this.state.steps && this.state.steps.length > 0) {
          this.switchParentTab("", this.state.parentTabValue + 1);
        }
      }
    }
  };

  // set unsaved changes in associated bucket form
  setUnsavedChanges = (data) => {
    this.setState({
      unsavedData: data,
    });
  };

  closeUnsavedChangesDialog = (val) => {
    if (val) {
      this.setState(
        {
          unsavedData: {},
          openUnsavedChangesModal: false,
        },
        () => {
          if (this.state.tempNewValue.origin === "back") {
            this.goBack();
          } else if (this.state.tempNewValue.origin === "next") {
            this.goNext();
          } else if (this.state.tempNewValue.origin === "aux") {
            this.switchAuxilliaryTab("", this.state.tempNewValue.tab);
          } else if (this.state.tempNewValue.origin === "products") {
            this.switchProductsTab("", this.state.tempNewValue.tab);
          } else if (this.state.tempNewValue.origin === "parentTab") {
            this.switchParentTab("", this.state.tempNewValue.tab);
          }
          this.setState({
            tempNewValue: {
              tab: "",
              childTab: "",
              origin: "",
            },
          });
        },
      );
    } else {
      this.setState({
        openUnsavedChangesModal: false,
      });
    }
  };

  changeBomProductsData = (parent, item) => {
    var components = [...this.state.components];
    for (var i = 0; i < components.length; i++) {
      if (components[i].id === parent) {
        components[i].edit = true;
        if (components[i].bom && components[i].bom.length > 0) {
          components[i].bom.forEach(function iter(a) {
            if (a.id === item.id) {
              if (a.customerViewable) {
                a.customerViewable = !a.customerViewable;
              } else {
                a.customerViewable = true;
              }
            }
            Array.isArray(a.bom) && a.bom.forEach(iter);
          });
        }
      }
    }
    this.setState({ components }, () => {
      this.setCurrentBucketItems();
    });
  };

  changeCustomer = () => {
    this.setState({
      showCustomerDialog: true,
      openConfirmCustomer: false,
    });
  };

  selectCustomers = (customer) => {
    var customers = [...this.state.customerData];
    var index = customers.findIndex((x) => x === customer.partyId);
    if (index > -1) {
      customers.splice(index, 1);
    } else {
      customers.push(customer.partyId);
    }

    // customers.push(customer);
    // var tempComponents = [...this.state.components];
    // for (var i = tempComponents.length - 1; i >= 0; i--) {
    //     if (tempComponents[i].customer && tempComponents[i].customer.length > 0) {
    //         if (tempComponents[i].customer.includes(customer.partyId)) { } else {
    //             this.removeItemFromBucket(tempComponents[i]);
    //         }
    //     }
    // }
    this.setState({
      customerData: customers,
      showCustomerDialog: false,
    });
  };

  closeChangeCustomer = () => {
    this.setState({
      showCustomerDialog: false,
    });
  };

  clearCustomerSelection = () => {
    this.setState({
      customerData: [],
    });
  };

  changeCustomerCheck = () => {
    if (
      this.state.components.length > 0 &&
      this.state.customerData.length > 0 &&
      this.state.customerData[0].partyId
    ) {
      this.setState({
        openConfirmCustomer: true,
      });
    } else {
      this.changeCustomer();
    }
  };

  updatePromoMarkdown = (e) => {
    this.setState({
      promoMarkdown: e.target.value,
    });
  };

  applyPromoMarkdown = () => {
    if (Number(this.state.promoMarkdown) >= 0) {
      var promoMarkdown = Number(this.state.promoMarkdown);
      var components = [...this.state.components];
      for (var i = 0; i < components.length; i++) {
        var price = 0;
        if (components[i].promoPriceSource) {
          price = Number(components[i].promoPriceSource);
        } else {
          price = 0;
        }
        var markup = (price * Number(promoMarkdown)) / 100;
        var newPrice = price - markup;
        if (newPrice >= 0) {
          if (components[i].minimumPrice) {
            if (newPrice >= Number(components[i].minimumPrice)) {
              components[i].price =
                "" +
                (Math.round((newPrice + Number.EPSILON) * 100) / 100).toFixed(
                  2,
                );
            } else {
              let minPrice = Number(components[i].minimumPrice);
              components[i].price =
                "" +
                (Math.round((minPrice + Number.EPSILON) * 100) / 100).toFixed(
                  2,
                );
            }
          } else {
            components[i].price =
              "" +
              (Math.round((newPrice + Number.EPSILON) * 100) / 100).toFixed(2);
          }
        } else {
          components[i].price = "0";
        }
        components[i].promoPrice = [
          {
            name: components[i].name,
            featureCode: components[i].featureCode,
            price: components[i].price,
          },
        ];
        components[i].promoMarkdown = this.state.promoMarkdown;
        components[i].promoApplied = true;
        if (components[i].otherPrices && components[i].otherPrices.length > 0) {
          components[i].promoPrice[0].otherPrices = [];
          for (var j = 0; j < components[i].otherPrices.length; j++) {
            var oPrice = 0;
            if (components[i].otherPrices[j].promoPriceSource) {
              oPrice = Number(components[i].otherPrices[j].promoPriceSource);
            } else {
              oPrice = 0;
            }
            var oMarkup = (oPrice * Number(promoMarkdown)) / 100;
            var newOPrice = oPrice - oMarkup;
            if (newOPrice >= 0) {
              if (components[i].otherPrices[j].minimumPrice) {
                if (newOPrice >= components[i].otherPrices[j].minimumPrice) {
                  components[i].otherPrices[j].price =
                    "" +
                    (
                      Math.round((newOPrice + Number.EPSILON) * 100) / 100
                    ).toFixed(2);
                } else {
                  let minPrice = Number(
                    components[i].otherPrices[j].minimumPrice,
                  );
                  components[i].otherPrices[j].price =
                    "" +
                    (
                      Math.round((minPrice + Number.EPSILON) * 100) / 100
                    ).toFixed(2);
                }
              } else {
                components[i].otherPrices[j].price =
                  "" +
                  (
                    Math.round((newOPrice + Number.EPSILON) * 100) / 100
                  ).toFixed(2);
              }
            } else {
              components[i].otherPrices[j].price = "0";
            }
            components[i].promoPrice[0].otherPrices.push({
              price: components[i].otherPrices[j].price,
              priceType: components[i].otherPrices[j].priceType,
            });
          }
        }
        if (components[i].variants && components[i].variants.length > 0) {
          components[i].variants.filter((variant) => {
            var vPrice = 0;
            if (variant.promoPriceSource) {
              vPrice = Number(variant.promoPriceSource);
            } else {
              vPrice = 0;
            }
            var vMarkup = (vPrice * Number(promoMarkdown)) / 100;
            var newVPrice = vPrice - vMarkup;
            if (newVPrice >= 0) {
              if (variant.minimumPrice) {
                if (newVPrice >= Number(variant.minimumPrice)) {
                  variant.price =
                    "" +
                    (
                      Math.round((newVPrice + Number.EPSILON) * 100) / 100
                    ).toFixed(2);
                } else {
                  var vMinPrice = Number(variant.minimumPrice);
                  variant.price =
                    "" +
                    (
                      Math.round((vMinPrice + Number.EPSILON) * 100) / 100
                    ).toFixed(2);
                }
              } else {
                variant.price =
                  "" +
                  (
                    Math.round((newVPrice + Number.EPSILON) * 100) / 100
                  ).toFixed(2);
              }
            } else {
              variant.price = "0";
            }
            variant.promoMarkdown = this.state.promoMarkdown;
            variant.promoApplied = true;
            variant.promoPrice = [
              {
                name: variant.name,
                featureCode: variant.featureCode,
                price: variant.price,
              },
            ];
            if (variant.otherPrices && variant.otherPrices.length > 0) {
              variant.promoPrice[0].otherPrices = [];
              variant.otherPrices.filter((variantOPrice) => {
                var vOPrice = 0;
                if (variantOPrice.promoPriceSource) {
                  vOPrice = Number(variantOPrice.promoPriceSource);
                } else {
                  vOPrice = 0;
                }
                var vMarkup = (vOPrice * Number(promoMarkdown)) / 100;
                var newvOPrice = vOPrice - vMarkup;
                if (newvOPrice >= 0) {
                  if (variantOPrice.minimumPrice) {
                    if (newvOPrice >= Number(variantOPrice.minimumPrice)) {
                      variantOPrice.price =
                        "" +
                        (
                          Math.round((newvOPrice + Number.EPSILON) * 100) / 100
                        ).toFixed(2);
                    } else {
                      var vOMinPrice = Number(variantOPrice.minimumPrice);
                      variantOPrice.price =
                        "" +
                        (
                          Math.round((vOMinPrice + Number.EPSILON) * 100) / 100
                        ).toFixed(2);
                    }
                  } else {
                    variantOPrice.price =
                      "" +
                      (
                        Math.round((newvOPrice + Number.EPSILON) * 100) / 100
                      ).toFixed(2);
                  }
                } else {
                  variantOPrice.price = "0";
                }
                variant.promoPrice[0].otherPrices.push({
                  price: variantOPrice.price,
                  priceType: variantOPrice.priceType,
                });
              });
            }
          });
        }
        if (i === components.length - 1) {
          this.setState(
            {
              components: components,
            },
            () => {
              this.setCurrentBucketItems();
            },
          );
        }
      }
    }
  };

  changeTableDataOtherPrice = (event, row, priceType) => {
    let items = [...this.state.components];
    let tempIndex = items.findIndex((a) => a.id === row.id);
    if (tempIndex > -1) {
      var pTempIndex = items[tempIndex].otherPrices.findIndex(
        (x) => x.priceType === priceType,
      );
      if (pTempIndex > -1) {
        items[tempIndex].promoApplied = true;
        var newPrice = Number(event.target.value);
        if (items[tempIndex].otherPrices[pTempIndex].minimumPrice) {
          if (
            newPrice >=
            Number(items[tempIndex].otherPrices[pTempIndex].minimumPrice)
          ) {
            items[tempIndex].otherPrices[pTempIndex].price =
              "" +
              (Math.round((newPrice + Number.EPSILON) * 100) / 100).toFixed(2);
          } else {
            let minPrice = Number(
              items[tempIndex].otherPrices[pTempIndex].minimumPrice,
            );
            items[tempIndex].otherPrices[pTempIndex].price =
              "" +
              (Math.round((minPrice + Number.EPSILON) * 100) / 100).toFixed(2);
          }
        } else {
          items[tempIndex].otherPrices[pTempIndex].price =
            "" +
            (Math.round((newPrice + Number.EPSILON) * 100) / 100).toFixed(2);
        }
        if (
          items[tempIndex].promoPrice &&
          items[tempIndex].promoPrice.length > 0
        ) {
          if (items[tempIndex].promoPrice[0].otherPrices) {
            if (items[tempIndex].promoPrice[0].otherPrices.length > 0) {
              var tpIndex = items[
                tempIndex
              ].promoPrice[0].otherPrices.findIndex(
                (x) => x.priceType === priceType,
              );
              if (tpIndex > -1) {
                items[tempIndex].promoPrice[0].otherPrices[tpIndex].price =
                  items[tempIndex].otherPrices[pTempIndex].price;
              } else {
                items[tempIndex].promoPrice[0].otherPrices.push({
                  price: items[tempIndex].otherPrices[pTempIndex].price,
                  priceType: items[tempIndex].otherPrices[pTempIndex].priceType,
                });
              }
            } else {
              items[tempIndex].promoPrice[0].otherPrices.push({
                price: items[tempIndex].otherPrices[pTempIndex].price,
                priceType: items[tempIndex].otherPrices[pTempIndex].priceType,
              });
            }
          } else {
            items[tempIndex].promoPrice[0].otherPrices = [];
            items[tempIndex].promoPrice[0].otherPrices.push({
              price: items[tempIndex].otherPrices[pTempIndex].price,
              priceType: items[tempIndex].otherPrices[pTempIndex].priceType,
            });
          }
        } else {
          items[tempIndex].promoPrice = [];
          items[tempIndex].promoPrice.push({
            otherPrices: [],
          });
          items[tempIndex].promoPrice[0].otherPrices.push({
            price: items[tempIndex].otherPrices[pTempIndex].price,
            priceType: items[tempIndex].otherPrices[pTempIndex].priceType,
          });
        }

        this.setState(
          {
            components: items,
          },
          () => {
            this.setCurrentBucketItems();
          },
        );
      }
    }
  };

  changeVariantOtherPrice = (e, row, variant, priceType) => {
    let items = [...this.state.components];
    let tempIndex = items.findIndex((a) => a.id === row.id);
    if (tempIndex > -1) {
      if (items[tempIndex].variants && items[tempIndex].variants.length > 0) {
        let variantIndex = items[tempIndex].variants.findIndex(
          (a) => a.id === variant.id,
        );
        if (variantIndex > -1) {
          var pTempIndex = items[tempIndex].variants[
            variantIndex
          ].otherPrices.findIndex((x) => x.priceType === priceType);
          if (pTempIndex > -1) {
            items[tempIndex].variants[variantIndex].promoApplied = true;

            // items[tempIndex].variants[variantIndex].otherPrices[pTempIndex].price = e.target.value;
            var newPrice = Number(e.target.value);
            if (
              items[tempIndex].variants[variantIndex].otherPrices[pTempIndex]
                .minimumPrice
            ) {
              if (
                newPrice >=
                Number(
                  items[tempIndex].variants[variantIndex].otherPrices[
                    pTempIndex
                  ].minimumPrice,
                )
              ) {
                items[tempIndex].variants[variantIndex].otherPrices[
                  pTempIndex
                ].price =
                  "" +
                  (Math.round((newPrice + Number.EPSILON) * 100) / 100).toFixed(
                    2,
                  );
              } else {
                let minPrice = Number(
                  items[tempIndex].variants[variantIndex].otherPrices[
                    pTempIndex
                  ].minimumPrice,
                );
                items[tempIndex].variants[variantIndex].otherPrices[
                  pTempIndex
                ].price =
                  "" +
                  (Math.round((minPrice + Number.EPSILON) * 100) / 100).toFixed(
                    2,
                  );
              }
            } else {
              items[tempIndex].variants[variantIndex].otherPrices[
                pTempIndex
              ].price =
                "" +
                (Math.round((newPrice + Number.EPSILON) * 100) / 100).toFixed(
                  2,
                );
            }

            if (
              items[tempIndex].variants[variantIndex].promoPrice &&
              items[tempIndex].variants[variantIndex].promoPrice.length > 0
            ) {
              if (
                items[tempIndex].variants[variantIndex].promoPrice[0]
                  .otherPrices
              ) {
                if (
                  items[tempIndex].variants[variantIndex].promoPrice[0]
                    .otherPrices.length > 0
                ) {
                  var tpIndex = items[tempIndex].variants[
                    variantIndex
                  ].promoPrice[0].otherPrices.findIndex(
                    (x) => x.priceType === priceType,
                  );
                  if (tpIndex > -1) {
                    items[tempIndex].variants[
                      variantIndex
                    ].promoPrice[0].otherPrices[tpIndex].price =
                      items[tempIndex].variants[variantIndex].otherPrices[
                        pTempIndex
                      ].price;
                  } else {
                    items[tempIndex].variants[
                      variantIndex
                    ].promoPrice[0].otherPrices.push({
                      price:
                        items[tempIndex].variants[variantIndex].otherPrices[
                          pTempIndex
                        ].price,
                      priceType:
                        items[tempIndex].variants[variantIndex].otherPrices[
                          pTempIndex
                        ].priceType,
                    });
                  }
                } else {
                  items[tempIndex].variants[
                    variantIndex
                  ].promoPrice[0].otherPrices.push({
                    price:
                      items[tempIndex].variants[variantIndex].otherPrices[
                        pTempIndex
                      ].price,
                    priceType:
                      items[tempIndex].variants[variantIndex].otherPrices[
                        pTempIndex
                      ].priceType,
                  });
                }
              } else {
                items[tempIndex].variants[
                  variantIndex
                ].promoPrice[0].otherPrices = [];
                items[tempIndex].variants[
                  variantIndex
                ].promoPrice[0].otherPrices.push({
                  price:
                    items[tempIndex].variants[variantIndex].otherPrices[
                      pTempIndex
                    ].price,
                  priceType:
                    items[tempIndex].variants[variantIndex].otherPrices[
                      pTempIndex
                    ].priceType,
                });
              }
            } else {
              items[tempIndex].variants[variantIndex].promoPrice = [];
              items[tempIndex].variants[variantIndex].promoPrice.push({
                otherPrices: [],
              });
              items[tempIndex].variants[
                variantIndex
              ].promoPrice[0].otherPrices.push({
                price:
                  items[tempIndex].variants[variantIndex].otherPrices[
                    pTempIndex
                  ].price,
                priceType:
                  items[tempIndex].variants[variantIndex].otherPrices[
                    pTempIndex
                  ].priceType,
              });
            }
            this.setState(
              {
                components: items,
              },
              () => {
                this.setCurrentBucketItems();
              },
            );
          }
        }
      }
    }
  };

  setLeafNode = (node, index) => {
    // console.log('Updaing leaf node PACKAGE++++++++++++++++++++++++++', node, index)
    if (!this.validateSelectionTypeLimits()) {
      return;
    }
    this.setState(
      {
        renderAssociatedConst: false,
        leafNodes: [],
        tabValue: index,
        subTabValue: 0,
      },
      () => {
        this.setState(
          {
            //bucketId: bucket.id,
            bucketSeqNum: node.sequenceNum,
            bucketName: node.name,
            selectedBucketId: node.id,
          },
          () => {
            this.setCurrentBucketItems();
            this.setState({
              renderAssociatedConst: true,
            });
          },
        );
      },
    );
  };

  setLeafNodes = (nodes, index, subIndex) => {
    // console.log("Updating leafNodes state:", nodes, index, subIndex);
    if (!this.validateSelectionTypeLimits()) {
      return;
    }
    this.setState(
      {
        leafNodes: nodes,
        subTabValue2: 0,
        tabValue: index,
        subTabValue: subIndex,
      },
      () => {
        const leafSubcategory = this.state.leafNodes[0];
        this.setState(
          {
            bucketSeqNum: leafSubcategory.sequenceNum,
            bucketName: leafSubcategory.name,
            selectedBucketId: leafSubcategory.id,
          },
          () => {
            this.setCurrentBucketItems();
            this.setState({
              renderAssociatedConst: true,
            });
          },
        );
      },
    );
  };

  confirmApprove = () => {
    this.setState({
      loading: true,
    });
    this.getBPMNActions();
    /*
        BusApiCall("GET",`${constants.busV4Url2}/productOfferings/${this.state.editPackagedId}/status`, {}).then((res) => {
            if(res.data && res.data.processApprove)
            {
                this.getBPMNActions();
            }
            else
            {
                this.props.setErrorMessage(this.props.t('Product in the offering, with the ids '+res.data.nonPublishedProductCodes+' needs to be approved before approving the offering.'), false)
                this.setState({
                    loading: false
                })
            }
        });
        */
  };

  changeProductStatus = (allowChangeStatus, action) => {
    let nextAction = "";
    let previousAction = "";
    if (action == "P_RETIRED") {
      nextAction = "Obsolete";
      previousAction = "Offering is Retired";
    } else if (action == "P_OBSOLETE") {
      //nextAction="Offering is Obsolete"
      previousAction = "Offering made Obsolete";
    }

    this.setState({
      loading: true,
    });
    if (allowChangeStatus) {
      let finalData = {
        action: nextAction,
        statusId: action,
        comment: this.state.comment,
        previousAction: previousAction,
      };
      BusApiCall(
        "PUT",
        `${constants.busV4Url2}/${this.state.editPackagedId}/updateStatus`,
        finalData,
      )
        .then((res) => {
          /*
                if(res.data && res.data.isFinalState)
                {
                    this.props.setErrorMessage(this.props.t('FINAL_STATE'), false)
                    this.setState({
                        loading: false
                    })
                }
                else
                {
                    */
          this.props.router.navigate("/myOfferings");
          //}
        })
        .catch((err) => {
          this.setState({
            loading: false,
          });
        });
    } else {
      BusApiCall(
        "GET",
        `${constants.busV4Url2}/productOfferings/${this.state.editPackagedId}/status`,
        {},
      ).then((res) => {
        this.getBPMNActions(action);
      });
    }
  };

  getBPMNActions = (action) => {
    // Get id from URL params
    let bpmnAllowedGroups = [];
    let userRoles = this.props.roles;
    let search = new URLSearchParams(this.props.router.location.search);
    let packageId = search.get("packageId");
    let data = {};
    data = {
      tenantId: this.props.providerId,
    };
    // Get order actions from flowable
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/products/${packageId}/flowable/bpmn/taskForms`,
      data,
    )
      .then((res) => {
        if (res.data.identityLinks) {
          res.data.identityLinks.map((item) =>
            bpmnAllowedGroups.push(item.group),
          );
        }
        const isIncluded = bpmnAllowedGroups.some((value) =>
          userRoles.includes(value),
        );
        if (isIncluded) {
          this.setState({
            formFields: res.data,
            showApprovalTaskForm: true,
            loading: false,
          });
        } else {
          this.props.setErrorMessage(
            this.props.t("RESTRICT_PRODUCT_STATE_CHANGE"),
            false,
          );
          this.setState({
            loading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };

  openDiagramDialog = () => {
    window.open(
      `${window.location.origin}/diagram.html?baseUrl=${constants.busV4Url2}&bpmnProcessInstanceId=${this.state.bpmnProcessInstanceId}&productId=${this.state.editPackagedId}&type=product`,
      "_blank",
    );
  };

  closeActionDialog = (val) => {
    if (val) {
      this.setState({
        loading: true,
      });
      let tenantId = this.props.providerId;

      if (tenantId) {
        val.tenantId = tenantId;
      }

      val.properties.push({
        id: "approvedBy",
        value: this.props.loggedInUserId,
      });
      //validate
      if (val.properties.length > 0 && val.properties[0].value == undefined) {
        this.setState({
          loading: false,
        });
        this.props.setErrorMessage(this.props.t("FILL_TASK_FORM"), false);
      } else if (
        val.properties.length > 1 &&
        val.properties[1].value == undefined
      ) {
        this.setState({
          loading: false,
        });
        this.props.setErrorMessage(this.props.t("FILL_TASK_FORM"), false);
      } else {
        BusApiCall(
          "POST",
          `${constants.busV44UrlPublic}/flowable/bpmn/taskForms`,
          val,
        )
          .then((res) => {
            this.setState(
              {
                showApprovalTaskForm: false,
                loading: false,
              },
              () => {
                this.props.router.navigate("/myOfferings");
              },
            );
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({ loading: false });
          });
      }
    } else {
      this.setState({
        showApprovalTaskForm: false,
      });
    }
  };

  saveAsChange = (event) => {
    let bdCopy = { ...this.state.basicDetail };
    let finalDataForSaveAs = { ...this.state.finalDataForNewVersion };
    if (event.target.name == "productName") {
      bdCopy.productName = event.target.value;
      var index = this.state.basicDetail.localisedName.findIndex(
        (x) => x.locale === "en_US",
      );
      if (index > -1) {
        bdCopy.localisedName[index].text = event.target.value;
      }
    } else if (event.target.name == "featureCode") {
      bdCopy.featureCode = event.target.value;
    }
    this.setState(
      {
        basicDetail: bdCopy,
      },
      () => {
        finalDataForSaveAs.basicDetail = this.state.basicDetail;
        this.setState(
          {
            basicDetail: bdCopy,
            finalDataForNewVersion: finalDataForSaveAs,
          },
          () => { },
        );
      },
    );
  };

  changeAddLimit = (event, bucketId) => {
    let addLimit = { ...this.state.addLimit };
    addLimit[bucketId] = event.target.checked;
    this.setState({ addLimit }, () => {
      //   console.log('addLimit', this.state.addLimit);
    });
  };
  changeSelectionTypeMinLimit = (e, bucketId) => {
    let selectionTypeMinLimit = { ...this.state.selectionTypeMinLimit };
    let value = e.target.value;
    if (value < 0) {
      value = 0;
    }
    selectionTypeMinLimit[bucketId] = value;
    this.setState({
      selectionTypeMinLimit,
    }, () => {
      //   console.log('selectionTypeMinLimit', this.state.selectionTypeMinLimit);
    });
  };
  changeSelectionTypeMaxLimit = (e, bucketId) => {
    let selectionTypeMaxLimit = { ...this.state.selectionTypeMaxLimit };
    let value = e.target.value;
    if (value < 0) {
      value = 0;
    }
    selectionTypeMaxLimit[bucketId] = value;
    this.setState({
      selectionTypeMaxLimit,
    }, () => {
      //   console.log('selectionTypeMaxLimit', this.state.selectionTypeMaxLimit);
    });
  };
  validateSelectionTypeLimits = () => {
    const { selectionType, selectionTypeMinLimit, selectionTypeMaxLimit, selectedBucketId } = this.state;

    // validate the selectionType for the currently selected bucket
    if (selectedBucketId && selectionType[selectedBucketId] === "LIMIT") {
      const minVal = Number(selectionTypeMinLimit[selectedBucketId]);
      const maxVal = Number(selectionTypeMaxLimit[selectedBucketId]);

      if (!selectionTypeMinLimit[selectedBucketId] || !selectionTypeMaxLimit[selectedBucketId]) {
        this.props.setErrorMessage(
          this.props.t("MIN_AND_MAX_REQUIRED_FOR_LIMIT_TYPE"),
          false
        );
        return false;
      }

      // Check if max is less than min
      if (maxVal < minVal) {
        this.props.setErrorMessage(
          this.props.t("MAX_MUST_BE_GREATER_THAN_OR_EQUAL_TO_MIN"),
          false
        );
        return false;
      }
    }

    return true;
  };

  render() {
    const { t, i18n } = this.props;
    const { isMobile, showCategory, showBucketsOnLeft } = this.state;
    // console.log('check isMobile======', isMobile)
    const productCategoryList = (
      <Grid
        item
        style={{ borderRight: "1px solid lightgrey", padding: "1rem" }}
        size={{
          xs: 12,
          md: 3,
        }}
      >
        <TreeView
          data={this.state.productBucketList}
          setLeafNodes={this.setLeafNodes}
          setLeafNode={this.setLeafNode}
          mode="productTab"
          tenantData={this.props.tenantData}
          activeTabId={this.state.tabValue}
          subTabValue={this.state.subTabValue}
        />
      </Grid>
    );
    const auxList = (
      <Grid
        item
        style={{ borderRight: "1px solid lightgrey", padding: "1rem" }}
        size={{
          xs: 12,
          md: 3,
        }}
      >
        <TreeView
          data={this.state.auxBucketsList}
          switchAuxTab={this.switchAuxTab}
          activeTabId={this.state.auxiliaryTabValue}
          tenantData={this.props.tenantData}
          mode="auxTab"
        />
      </Grid>
    );
    const productTable = () => {
      return (
        <Grid item size={{ xs: 12, md: 12 }} style={{ padding: '1rem', display: 'flex', flexDirection: 'column', height: '100%' }}>
          {showBucketsOnLeft && this.state.leafNodes && this.state.leafNodes.length > 0 &&
            <Box className={classes.tabUnderLine}>
              <Tabs
                variant="scrollable"
                scrollButtons="false"
                indicatorColor="primary"
                value={this.state.subTabValue2} // index of the active leaf tab
                onChange={this.switchLeafNode}
                className={classes.createPackageTabs}
              >
                {this.state.leafNodes.map((row, index) => (
                  <Tab key={index} label={row.name} />
                ))}
              </Tabs>
            </Box>
          }
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
            {(this.state.parentTabValue === 1 ||
              this.state.parentTabValue === 2 ||
              this.state.parentTabValue === 3 ||
              this.state.parentTabValue === 4) && this.state.renderAssociatedConst &&
              <>
                {this.state.parentTabValue === 2 ?
                  <>
                  </>
                  :
                  <>
                    <AssociatedBucket
                      globalProducts={this.state.globalProducts}
                      bucketList={this.state.bucketList}
                      packageMode={this.state.packageMode}
                      selectedBucketId={this.state.selectedBucketId}
                      bucketName={this.state.bucketName}
                      components={this.state.components}
                      isLastBucket={this.state.isLastBucket}
                      bucketSeqNum={this.state.bucketSeqNum}
                      providerType={this.props.providerType}
                      addToCatalog={this.state.addToCatalog}
                      tabValue={this.state.tabValue}
                      currentBucketItems={this.state.currentBucketItems}
                      currentBucketItemsCount={this.state.currentBucketItemsCount}
                      providerId={this.props.providerId}
                      error={this.state.error}

                      state={this.state}

                      //pass methods
                      submitPackageJSON={this.submitPackageJSON}
                      expandVariantDetails={this.expandVariantDetails}
                      expandOtherPrices={this.expandOtherPrices}
                      getAssociatedBucketDetails={this.getAssociatedBucket}
                      setAssociatedBucketDetails={this.setAssociatedBucket}
                      removeItemFromBucket={this.removeItemFromBucket}
                      removeDependsOnChip={this.removeDependsOnChip}
                      changeTableData={this.changeTableData}
                      selectionType={this.state.selectionType}
                      changeSelectionType={this.changeSelectionType}
                      selectionTypeMinLimit={this.state.selectionTypeMinLimit}
                      selectionTypeMaxLimit={this.state.selectionTypeMaxLimit}
                      addLimit={this.state.addLimit}
                      changeAddLimit={this.changeAddLimit}
                      changeSelectionTypeMinLimit={this.changeSelectionTypeMinLimit}
                      changeSelectionTypeMaxLimit={this.changeSelectionTypeMaxLimit}
                      sortTableItems={this.sortTableItems}
                      changeIsViewable={this.changeIsViewable}
                      applySpecialPrice={this.applySpecialPrice}
                      downloadTemplate={this.downloadTemplate}
                      setUnsavedChanges={this.setUnsavedChanges}
                      changeDisplaySequence={this.changeDisplaySequence}
                      saveAsChange={this.saveAsChange}

                      changeTableCompleteRowData={this.changeTableCompleteRowData}
                      expandComponentDetails={this.expandComponentDetails}

                      // Publish tab data
                      expiryDate={this.state.expiryDate}
                      releaseDate={this.state.releaseDate}
                      orderApproval={this.state.orderApproval}
                      billingTriggerPhase={this.state.billingTriggerPhase}
                      billingTriggerProdId={this.state.billingTriggerProdId}
                      selectedBucket={this.state.selectedBucket}
                      updateTrigger={this.updateTrigger}

                      // T&C data
                      getPackageBasicDetails={this.getPackageBasicDetails}
                      addTermsCond={this.addTermsCond}
                      onChangeTerms={this.onChangeTerms}
                      removeTermAndCond={this.removeTermAndCond}
                      editTermAndCond={this.editTermAndCond}
                      updateTermsCond={this.updateTermsCond}
                      basicDetail={this.state.basicDetail}
                      termsText={this.state.termsText}
                      termsUrl={this.state.termsUrl}
                      termCondToEdit={this.state.termCondToEdit}

                      // Assembly Instruction data
                      routing={this.state.routing}
                      onInstructionChange={this.onInstructionChange}
                      removeInstruction={this.removeInstruction}
                      changeInstructionSequence={this.changeInstructionSequence}
                      onChangeRoutingData={this.onChangeRoutingData}
                      addInstruction={this.addInstruction}

                      setLoading={this.setLoading}

                      approvedForSale={this.state.approvedForSale}
                      submittedForReview={this.state.submittedForReview}
                      comment={this.state.comment}
                      addPackageReviewComments={this.addPackageReviewComments}

                      // Pre-quals data
                      preQuals={this.state.preQuals}
                      addPreQual={this.addPreQual}
                      deletePreQual={this.deletePreQual}
                      editPreQual={this.editPreQual}

                      categoryList={this.state.categoryList}
                      originalBucketsData={this.state.originalBucketsData}

                      // Enrichment 
                      addEnrichmentRow={this.addEnrichmentRow}
                      changeEnrichmentRow={this.changeEnrichmentRow}
                      deleteEnrichment={this.deleteEnrichment}
                      channelList={this.state.channelList}
                      expandEnrichmentDetails={this.expandEnrichmentDetails}

                      goBack={this.goBack}
                      parentTabValue={this.state.parentTabValue}
                      changeBomProductsData={this.changeBomProductsData}

                      selectedCustomer={this.state.customerData.length > 0 ? this.state.customerData : []}
                      selectCustomers={this.selectCustomers}

                      productTermsState={this.state.productTermsState}
                      productTermsLocale={this.state.productTermsLocale}
                      changeProductTermsLocale={this.changeProductTermsLocale}
                      isAddToCatalog={this.state.isAddToCatalog}
                      getAssociatedBucketDetailsBulk={this.getAssociatedBucketDetailsBulk}

                      termTenure={this.state.termTenure}
                      termTenureUOM={this.state.termTenureUOM}
                      updateOfferingTerm={this.updateOfferingTerm}
                      termNoticePeriod={this.state.termNoticePeriod}
                      termNoticePeriodUOM={this.state.termNoticePeriodUOM}
                      promoMarkdown={this.state.promoMarkdown}
                      updatePromoMarkdown={this.updatePromoMarkdown}
                      applyPromoMarkdown={this.applyPromoMarkdown}

                      changeTableDataOtherPrice={this.changeTableDataOtherPrice}
                      changeVariantOtherPrice={this.changeVariantOtherPrice}

                      status={this.state.status}
                      confirmApprove={this.confirmApprove}
                      productHistoryDetails={this.state.productHistoryDetails}
                      changeProductStatus={this.changeProductStatus}

                      isMobile={isMobile}
                      showCategory={showCategory}
                      toggleShowCategory={this.toggleShowCategory}
                      blockNavigation={this.blockNavigation}
                      offeringSummary={this.offeringSummary}
                      themeColor={this.props.tenantData.color}

                      changeShowOfferingQty={this.changeShowOfferingQty}
                      showOfferingQty={this.state.showOfferingQty}
                    />
                    {this.state.packageMode !== 'promo' &&
                      <Grid container spacing={2} justifyContent="center" style={{ marginTop: '1rem' }}>
                        <Grid item size={{ xs: 12, md: 12 }} className="text-right" style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <div>
                            <Button className='buttonSecondary' onClick={() => this.goBack()}>{t('BACK')}</Button>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'flex-end', float: 'right' }}>
                            {this.props.userPerms.includes("CATALOG_ADMIN") &&
                              <Button onClick={() => this.downloadTemplate()}
                                className={classes.downloadTemplateButton + ' ' + 'buttonSecondary'}>
                                {t('EXPORT_PRODUCT_TEMPLATE')}
                              </Button>
                            }
                            {this.state.packageMode === 'edit' && <Button onClick={() => this.offeringSummary()}
                              className={classes.downloadTemplateButton + ' ' + 'buttonSecondary'}>
                              {t('OFFERING_SUMMARY')}
                            </Button>}
                            {this.state.selectedBucketId !== 'PROD_COMP_PUBLISH' &&
                              <Button onClick={() => this.goNext()}>{t('NEXT')}</Button>
                            }
                          </div>
                        </Grid>
                      </Grid>}
                    {this.state.packageMode === 'promo' && (this.state.bucketList.length > 0) &&
                      <Grid container spacing={2} justifyContent="center" style={{ marginTop: '1rem' }}>
                        <Grid item size={{ xs: 12, md: 12 }} style={{ display: 'flex', justifyContent: 'space-between' }}>
                          {/* <Grid item xs={12}> */}
                          <div>
                            <Button className='buttonSecondary' onClick={() => this.goBack()}>{t('BACK')}</Button>
                          </div>
                          {/* </Grid>
                                          <Grid item xs={6} className="text-right"> */}
                          <div>
                            {this.state.selectedBucketId !== 'PROD_COMP_PACKAGE' &&
                              <Button onClick={() => this.goNext()}>{t('NEXT')}</Button>
                            }
                            {this.state.packageMode === "promo" &&
                              // this.state.selectedBucketId === "PROD_COMP_PACKAGE" && 
                              (
                                <Button
                                  onClick={() => {
                                    this.applySpecialPrice();
                                  }}
                                  style={{ marginLeft: '15px' }}
                                >
                                  {t("APPLY_SPECIAL_PRICE")}
                                </Button>
                              )}
                          </div>
                          {/* </Grid> */}
                        </Grid>
                      </Grid>
                    }
                  </>
                }
              </>}
          </div>
        </Grid>
      )
    }
    const auxTable = () => {
      return (
        <Grid item size={{ xs: 12, md: 12 }} style={{ padding: '1rem' }}>
          {(this.state.parentTabValue === 2 ||
            this.state.parentTabValue === 3 ||
            this.state.parentTabValue === 4) && this.state.renderAssociatedConst &&
            <>
              {this.state.parentTabValue === 2 &&
                <>
                  {this.state.auxBucketsList && this.state.auxBucketsList.length > 0 ?
                    <>
                      <AssociatedBucket
                        globalProducts={this.state.globalProducts}
                        bucketList={this.state.bucketList}
                        packageMode={this.state.packageMode}
                        selectedBucketId={this.state.selectedBucketId}
                        bucketName={this.state.bucketName}
                        components={this.state.components}
                        isLastBucket={this.state.isLastBucket}
                        bucketSeqNum={this.state.bucketSeqNum}
                        providerType={this.props.providerType}
                        addToCatalog={this.state.addToCatalog}
                        tabValue={this.state.tabValue}
                        currentBucketItems={this.state.currentBucketItems}
                        currentBucketItemsCount={this.state.currentBucketItemsCount}
                        providerId={this.props.providerId}
                        error={this.state.error}

                        state={this.state}

                        //pass methods
                        submitPackageJSON={this.submitPackageJSON}
                        expandVariantDetails={this.expandVariantDetails}
                        expandOtherPrices={this.expandOtherPrices}
                        getAssociatedBucketDetails={this.getAssociatedBucket}
                        setAssociatedBucketDetails={this.setAssociatedBucket}
                        removeItemFromBucket={this.removeItemFromBucket}
                        removeDependsOnChip={this.removeDependsOnChip}
                        changeTableData={this.changeTableData}
                        selectionType={this.state.selectionType}
                        changeSelectionType={this.changeSelectionType}
                        selectionTypeMinLimit={this.state.selectionTypeMinLimit}
                        selectionTypeMaxLimit={this.state.selectionTypeMaxLimit}
                        addLimit={this.state.addLimit}
                        changeAddLimit={this.changeAddLimit}
                        changeSelectionTypeMinLimit={this.changeSelectionTypeMinLimit}
                        changeSelectionTypeMaxLimit={this.changeSelectionTypeMaxLimit}
                        sortTableItems={this.sortTableItems}
                        changeIsViewable={this.changeIsViewable}
                        applySpecialPrice={this.applySpecialPrice}
                        downloadTemplate={this.downloadTemplate}
                        setUnsavedChanges={this.setUnsavedChanges}
                        changeDisplaySequence={this.changeDisplaySequence}
                        saveAsChange={this.saveAsChange}

                        changeTableCompleteRowData={this.changeTableCompleteRowData}
                        expandComponentDetails={this.expandComponentDetails}

                        // Publish tab data
                        expiryDate={this.state.expiryDate}
                        releaseDate={this.state.releaseDate}
                        orderApproval={this.state.orderApproval}
                        billingTriggerPhase={this.state.billingTriggerPhase}
                        billingTriggerProdId={this.state.billingTriggerProdId}
                        selectedBucket={this.state.selectedBucket}
                        updateTrigger={this.updateTrigger}

                        // T&C data
                        getPackageBasicDetails={this.getPackageBasicDetails}
                        addTermsCond={this.addTermsCond}
                        onChangeTerms={this.onChangeTerms}
                        removeTermAndCond={this.removeTermAndCond}
                        editTermAndCond={this.editTermAndCond}
                        updateTermsCond={this.updateTermsCond}
                        basicDetail={this.state.basicDetail}
                        termsText={this.state.termsText}
                        termsUrl={this.state.termsUrl}
                        termCondToEdit={this.state.termCondToEdit}

                        // Assembly Instruction data
                        routing={this.state.routing}
                        onInstructionChange={this.onInstructionChange}
                        removeInstruction={this.removeInstruction}
                        changeInstructionSequence={this.changeInstructionSequence}
                        onChangeRoutingData={this.onChangeRoutingData}
                        addInstruction={this.addInstruction}

                        setLoading={this.setLoading}

                        approvedForSale={this.state.approvedForSale}
                        submittedForReview={this.state.submittedForReview}
                        comment={this.state.comment}
                        addPackageReviewComments={this.addPackageReviewComments}

                        // Pre-quals data
                        preQuals={this.state.preQuals}
                        addPreQual={this.addPreQual}
                        deletePreQual={this.deletePreQual}
                        editPreQual={this.editPreQual}

                        categoryList={this.state.categoryList}
                        originalBucketsData={this.state.originalBucketsData}

                        // Enrichment 
                        addEnrichmentRow={this.addEnrichmentRow}
                        changeEnrichmentRow={this.changeEnrichmentRow}
                        deleteEnrichment={this.deleteEnrichment}
                        channelList={this.state.channelList}
                        expandEnrichmentDetails={this.expandEnrichmentDetails}

                        goBack={this.goBack}
                        parentTabValue={this.state.parentTabValue}
                        changeBomProductsData={this.changeBomProductsData}

                        selectedCustomer={this.state.customerData.length > 0 ? this.state.customerData : []}
                        selectCustomers={this.selectCustomers}

                        productTermsState={this.state.productTermsState}
                        productTermsLocale={this.state.productTermsLocale}
                        changeProductTermsLocale={this.changeProductTermsLocale}
                        isAddToCatalog={this.state.isAddToCatalog}
                        getAssociatedBucketDetailsBulk={this.getAssociatedBucketDetailsBulk}

                        termTenure={this.state.termTenure}
                        termTenureUOM={this.state.termTenureUOM}
                        updateOfferingTerm={this.updateOfferingTerm}
                        termNoticePeriod={this.state.termNoticePeriod}
                        termNoticePeriodUOM={this.state.termNoticePeriodUOM}
                        promoMarkdown={this.state.promoMarkdown}
                        updatePromoMarkdown={this.updatePromoMarkdown}
                        applyPromoMarkdown={this.applyPromoMarkdown}

                        changeTableDataOtherPrice={this.changeTableDataOtherPrice}
                        status={this.state.status}
                        confirmApprove={this.confirmApprove}
                        productHistoryDetails={this.state.productHistoryDetails}
                        changeProductStatus={this.changeProductStatus}

                        isMobile={isMobile}
                        showCategory={showCategory}
                        toggleShowCategory={this.toggleShowCategory}
                        blockNavigation={this.blockNavigation}
                        offeringSummary={this.offeringSummary}
                        themeColor={this.props.tenantData.color}

                        changeShowOfferingQty={this.changeShowOfferingQty}
                        showOfferingQty={this.state.showOfferingQty}
                      />
                    </>
                    :
                    <div>
                      <p style={{ lineHeight: '300px', textAlign: 'center', fontSize: '18px' }}>{t('NO_AUX_PRODUCT_CONFIGURED')}</p>
                    </div>
                  }
                  {this.state.packageMode !== 'promo' && <Grid container spacing={2} justifyContent="center" style={{ marginTop: '1rem' }}>
                    <Grid item size={{ xs: 12, md: 12 }} className="text-right" style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div>
                        <Button className='buttonSecondary' onClick={() => this.goBack()}>{t('BACK')}</Button>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'flex-end', float: 'right' }}>
                        {this.props.userPerms.includes("CATALOG_ADMIN") &&
                          <Button onClick={() => this.downloadTemplate()}
                            className={classes.downloadTemplateButton + ' ' + 'buttonSecondary'}>
                            {t('EXPORT_PRODUCT_TEMPLATE')}
                          </Button>
                        }
                        {this.state.selectedBucketId !== 'PROD_COMP_PUBLISH' &&
                          <Button onClick={() => this.goNext()}>{t('NEXT')}</Button>
                        }
                      </div>
                    </Grid>
                  </Grid>}
                  {this.state.packageMode === 'promo' && (this.state.bucketList.length > 0) &&
                    <Grid container spacing={2} justifyContent="center" style={{ marginTop: '1rem' }}>
                      <Grid item size={{ xs: 12, md: 12 }} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        {/* <Grid item xs={12}> */}
                        <div>
                          <Button className='buttonSecondary' onClick={() => this.goBack()}>{t('BACK')}</Button>
                        </div>
                        {/* </Grid>
                                                                          <Grid item xs={6} className="text-right"> */}
                        <div>
                          {this.state.selectedBucketId !== 'PROD_COMP_PACKAGE' &&
                            <Button onClick={() => this.goNext()}>{t('NEXT')}</Button>
                          }
                          {this.state.packageMode === "promo" &&
                            // this.state.selectedBucketId === "PROD_COMP_PACKAGE" && 
                            (
                              <Button
                                onClick={() => {
                                  this.applySpecialPrice();
                                }}
                                style={{ marginLeft: '15px' }}
                              >
                                {t("APPLY_SPECIAL_PRICE")}
                              </Button>
                            )}
                        </div>
                        {/* </Grid> */}
                      </Grid>
                    </Grid>
                  }
                </>
              }
            </>
          }
        </Grid>
      )
    }
    return (
      <div className={"newContentWrapper"}>
        {this.state.renderBread && (
          <div className={"breadcrumbWrapper"}>
            <div className={"breadcrumbContent"}>
              <Grid container>
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <Breadcrumb
                    list={this.state.bread}
                    checkUploadedFile={this.checkUploadedFile}
                    onFilesError={this.onFilesError}
                    displayImportButton={
                      this.state.packageMode === "CREATE" ? true : false
                    }
                  />
                  {this.state.packageMode === "edit" &&
                    this.state.addToCatalog != "true" &&
                    this.state.packagedSolutionStatus &&
                    !this.state.approvedForSale && (
                      <Chip
                        label={
                          this.state.statusDisplayName
                          // this.state.submittedForReview
                          //     ?
                          //     this.props.t('STATUS') && this.props.t('PS_REVIEW')
                          //     :
                          //     !this.state.approvedForSale && !this.state.submittedForReview &&
                          //     this.props.t('STATUS') && this.props.t('PS_DRAFT')
                        }
                        // color="primary"
                        className={
                          this.state.status === "P_PUBLISHED"
                            ? "successChip"
                            : this.state.status === "P_REJECTED"
                              ? "errorChip"
                              : "inProgressChip"
                        }
                        // variant="outlined"
                        style={{ float: "right" }}
                      />
                    )}

                  {this.state.packageMode === "edit" &&
                    this.state.bpmnProcessInstanceId &&
                    this.state.addToCatalog != "true" && (
                      <>
                        <Tooltip title={t("VIEW")}>
                          <IconButton
                            onClick={() => {
                              this.openDiagramDialog();
                            }}
                            className={"orderActionsIcon remove-top-padding"}
                            style={{ float: "right" }}
                          >
                            <DiagramIcon />
                            {/* <label
                              style={{ color: this.props.tenantData.color }}
                            >
                              {t("DIAGRAM")}
                            </label> */}
                          </IconButton>
                        </Tooltip>{" "}
                        &nbsp;
                      </>
                    )}
                  {/* {this.state.packageMode !== 'promo' &&
                                        <h3 style={{ margin: 0, fontWeight: 'normal', float: 'right', lineHeight: '29px', paddingRight: (this.state.customerData.length > 0 && this.state.customerData[0].partyId) ? '50px' : '35px', paddingLeft: '10px', position: 'relative', marginRight: '5px' }}>
                                            {t('SELECTED_CUSTOMER')}:&nbsp;
                                            <>
                                                <span style={{ fontWeight: 'bold', color: this.props.tenantData.color, cursor: 'pointer' }} onClick={() => this.changeCustomerCheck()}>
                                                    {(this.state.customerData.length > 0 && this.state.customerData[0].partyId) ?
                                                        <>{this.state.customerData[0].accountName}</>
                                                        :
                                                        'ALL'
                                                    }
                                                    <Tooltip title={this.props.t('CHANGE')}>
                                                        <EditIcon style={{ position: 'absolute', fontSize: '20px', marginLeft: '5px', marginTop: '3px' }} />
                                                    </Tooltip>
                                                </span>
                                                {(this.state.customerData.length > 0 && this.state.customerData[0].partyId) &&
                                                    <span style={{ cursor: 'pointer', position: 'absolute', right: 0, marginTop: '3px', color: this.props.tenantData.color }}>
                                                        <Tooltip title={this.props.t('CLEAR')}>
                                                            <ClearIcon onClick={() => this.clearCustomerSelection()} />
                                                        </Tooltip>
                                                    </span>
                                                }
                                            </>
                                        </h3>
                                    } */}
                </Grid>
              </Grid>
            </div>
          </div>
        )}
        <main style={{ paddingTop: "0px" }}>
          {this.state.renderView && (
            <div>
              <Grid container spacing={1}>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: this.props.tenantRoles.includes("CHILD_PROVIDER")
                      ? 12
                      : 9,
                  }}
                >
                  <Box display="flex" justifyContent="left" width="100%">
                    {this.state.steps.length > 0 ? (
                      <StepperNew
                        activeStep={this.state.parentTabValue}
                        steps={this.state.steps}
                        onStepSelect={this.switchParentTab}
                        screen={"createPackage"}
                      />
                    ) : null}
                  </Box>
                </Grid>
                {isMobile && (
                  <>
                    {/* {this.state.parentTabValue === 1 && */}
                    <Grid
                      item
                      style={{ alignContent: "center" }}
                      size={{
                        xs: 6,
                      }}
                    >
                      {this.state.parentTabValue === 1 &&
                        this.state.productBucketList[this.state.tabValue]?.name}
                      {this.state.parentTabValue === 1 &&
                        this.state.subTabValue !== null &&
                        this.state.subTabValue !== undefined &&
                        this.state.productBucketList[this.state.tabValue]
                          .subCategories && (
                          <>
                            {" "}
                            {">"}{" "}
                            {
                              this.state.productBucketList[this.state.tabValue]
                                .subCategories[this.state.subTabValue]?.name
                            }
                          </>
                        )}
                      {this.state.parentTabValue === 2 &&
                        this.state.auxBucketsList[this.state.auxiliaryTabValue]
                          ?.name}
                    </Grid>
                    <Grid
                      item
                      style={{ textAlign: "right", marginBottom: "1rem" }}
                      size={{
                        xs: 6,
                      }}
                    >
                      <Button
                        className="buttonSecondary"
                        onClick={() => {
                          this.toggleShowCategory(this.state.parentTabValue);
                        }}
                      >
                        <span
                          style={{
                            marginRight: ".5rem",
                            verticalAlign: "middle",
                          }}
                        >
                          <MenuIcon />
                        </span>
                        {t("SHOW_STEPS_LIST")}
                      </Button>
                    </Grid>
                  </>
                )}
                {/* <Grid item xs={12}>
                                    <Box display="flex" justifyContent="center" width="100%">
                                        <Tabs
                                            value={this.state.parentTabValue}
                                            onChange={this.switchParentTab}
                                            indicatorColor="primary"
                                            // textColor="primary"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            className={classes.createPackageTabs}
                                        >
                                            {this.state.packageMode !== 'promo' &&
                                                <Tab label={t('BASIC_DETAILS')} value={0} />
                                            }
                                            {this.state.productBucketList && this.state.productBucketList.length > 0 &&
                                                <Tab label={t('PRODUCTS')} value={1} />
                                            }
                                            {this.state.auxBucketsList && this.state.auxBucketsList.length > 0 &&
                                                <Tab label={t('AUXILIARY')} value={2} />
                                            }
                                            {this.state.isPackageBucket &&
                                                <Tab label={t('PACKAGE')} value={3} />
                                            }
                                            {this.state.isPublishBucket &&
                                                <Tab label={t('PUBLISH')} value={4} />
                                            }
                                        </Tabs>
                                    </Box>
                                </Grid> */}
              </Grid>
              {/* <Box paddingTop={3} />  Space added */}
              <div
                style={{
                  borderRadius: "8px",
                  border: "1px solid lightgrey",
                  background: "white",
                  marginBottom: "40px",
                }}
              >
                {/*Basic Details Start*/}
                {this.state.parentTabValue === 0 &&
                  this.state.renderBasicDetail && (
                    <BasicDetails
                      name="PackageDetails"
                      onRef={(ref) => (this.basicDetailsRef = ref)}
                      packageMode={this.state.packageMode}
                      // Get packaged solution basic details
                      getPackageBasicDetails={this.getPackageBasicDetails}
                      basicDetail={this.state.basicDetail}
                      images={this.state.images}
                      mainTabValue={this.state.tabValue}
                      parentTabValue={this.state.parentTabValue}
                      providerId={this.props.providerId}
                      providerType={this.props.providerType}
                      downloadTemplate={this.downloadTemplate}
                      addToCatalog={this.state.addToCatalog}
                      margin={this.state.topLevelMargin}
                      updateMargin={this.updateMargin}
                      onChangePackagedSolutionName={
                        this.onChangePackagedSolutionName
                      }
                      psTemplate={this.state.psTemplate}
                      showCustomAttributes={this.state.showCustomAttributes}
                      isMobile={isMobile}
                      showCategory={showCategory}
                      toggleShowCategory={this.toggleShowCategory}
                      disableInputFields={this.state.readOnly}
                      blockNavigation={this.blockNavigation}
                      offeringSummary={this.offeringSummary}
                      themeColor={this.props.tenantData.color}
                    />
                  )}
                {/* <div></div> */}

                {this.state.parentTabValue === 1 && (
                  <>
                    <div>
                      <Grid container spacing={0}>
                        {!isMobile ? (
                          !showBucketsOnLeft ? (
                            <Grid
                              container
                              spacing={1}
                              style={{
                                marginTop: "1rem",
                                justifyContent: "center",
                              }}
                            >
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                }}
                              >
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  width="100%"
                                >
                                  <Tabs
                                    value={this.state.tabValue}
                                    onChange={this.switchProductsTab}
                                    // indicatorColor="primary"
                                    // textColor="primary"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    ref={this.tabsWrapper}
                                    className={classes.createPackageTabs}
                                  >
                                    {/* get the tabs for the buckets */}
                                    {this.state.displayBuckets &&
                                      this.state.productBucketList
                                        // .sort((a, b) => (a && b ? a.sequenceNum - b.sequenceNum : 0))
                                        .map((bucket, index) => (
                                          <Tab
                                            key={index}
                                            label={bucket.name}
                                          />
                                        ))}
                                  </Tabs>
                                </Box>
                              </Grid>
                              {this.state.productBucketList[
                                this.state.tabValue
                              ] &&
                                this.state.productBucketList[
                                  this.state.tabValue
                                ].subCategories && (
                                  <Grid
                                    item
                                    size={{
                                      xs: 12,
                                    }}
                                  >
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      width="100%"
                                    >
                                      <Tabs
                                        // textColor="primary"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        // indicatorColor="primary"
                                        value={this.state.subTabValue}
                                        onChange={this.switchSubProductsTab}
                                        className={
                                          classes.createPackageComponentTabs +
                                          " " +
                                          classes.createPackageTabs
                                        }
                                      >
                                        {this.state.productBucketList[
                                          this.state.tabValue
                                        ].subCategories &&
                                          this.state.productBucketList[
                                            this.state.tabValue
                                          ].subCategories.length > 0
                                          ? this.state.productBucketList[
                                            this.state.tabValue
                                          ].subCategories.map(
                                            (row, index) => (
                                              <Tab
                                                key={index}
                                                label={row.name}
                                              />
                                            ),
                                          )
                                          : null}
                                      </Tabs>
                                    </Box>
                                  </Grid>
                                )}
                              {this.state.productBucketList[
                                this.state.tabValue
                              ] &&
                                this.state.productBucketList[
                                  this.state.tabValue
                                ].subCategories &&
                                this.state.productBucketList[
                                  this.state.tabValue
                                ].subCategories[this.state.subTabValue]
                                  .subCategories && (
                                  <Grid
                                    item
                                    size={{
                                      xs: 12,
                                    }}
                                  >
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      width="100%"
                                    >
                                      <Tabs
                                        // textColor="primary"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        // indicatorColor="primary"
                                        value={this.state.subTabValue2}
                                        onChange={this.switchSubProductsTab2}
                                        className={
                                          classes.createPackageComponentTabs +
                                          " " +
                                          classes.createPackageTabs
                                        }
                                      >
                                        {this.state.productBucketList[
                                          this.state.tabValue
                                        ].subCategories &&
                                          this.state.productBucketList[
                                            this.state.tabValue
                                          ].subCategories.length > 0
                                          ? this.state.productBucketList[
                                            this.state.tabValue
                                          ].subCategories[
                                            this.state.subTabValue
                                          ].subCategories &&
                                            this.state.productBucketList[
                                              this.state.tabValue
                                            ].subCategories[
                                              this.state.subTabValue
                                            ].subCategories.length > 0
                                            ? this.state.productBucketList[
                                              this.state.tabValue
                                            ].subCategories[
                                              this.state.subTabValue
                                            ].subCategories.map(
                                              (row, index) => (
                                                <Tab
                                                  key={index}
                                                  label={row.name}
                                                />
                                              ),
                                            )
                                            : null
                                          : null}
                                      </Tabs>
                                    </Box>
                                  </Grid>
                                )}
                              <Box
                                className={classes.tabUnderLine}
                                style={{
                                  display: "flex",
                                  marginTop: "2rem",
                                  justifyContent: "center",
                                  width: "100%",
                                }}
                              ></Box>
                              {productTable()}
                            </Grid>
                          ) : (
                            <Split
                              sizes={[20, 80]} // Initial sizes in percentages
                              minSize={[200, 400]} // Minimum sizes in pixels
                              expandToMin={false}
                              gutterSize={10}
                              gutterAlign="center"
                              snapOffset={30}
                              dragInterval={1}
                              direction="horizontal"
                              cursor="col-resize"
                              className='split'
                            >
                              {/* left */}
                              <div style={{ overflow: 'auto', borderRight: '1px solid lightgrey' }}>
                                <Grid item size={{ xs: 12, md: 12 }} style={{ padding: '1rem' }}>
                                  <TreeView
                                    data={this.state.productBucketList}
                                    setLeafNodes={this.setLeafNodes}
                                    setLeafNode={this.setLeafNode}
                                    mode="productTab"
                                    tenantData={this.props.tenantData}
                                    activeTabId={this.state.tabValue}
                                    subTabValue={this.state.subTabValue}
                                  />
                                </Grid>
                              </div>
                              {/* right */}
                              <div style={{ overflow: 'auto' }}>
                                {productTable()}
                              </div>
                            </Split>
                          )
                        ) : (
                          isMobile &&
                          showCategory && (
                            <Drawer
                              anchor="left"
                              // variant='permanant'
                              open={showCategory}
                              onClose={() => {
                                this.toggleShowCategory();
                              }}
                              // classes={{ paper: classes.drawerPaper }}
                              PaperProps={{
                                style: {
                                  width: "100%",
                                  maxWidth: "100vw",
                                },
                              }}
                            >
                              <div>
                                <div>
                                  <IconButton
                                    onClick={() => {
                                      this.toggleShowCategory();
                                    }}
                                  >
                                    <ChevronLeft />
                                  </IconButton>
                                </div>
                                <Card
                                  variant="outlined"
                                  className={"roundedCorners"}
                                >
                                  {productCategoryList}
                                </Card>
                              </div>
                            </Drawer>
                          )
                        )}
                        {(isMobile && !showCategory) && productTable()}
                      </Grid>
                    </div>
                  </>
                )}
                {/*Bucket Start*/}
                {this.state.parentTabValue === 2 &&
                  this.state.auxBucketsList &&
                  this.state.auxBucketsList.length > 0 && (
                    <>
                      <div>
                        <Grid container spacing={0}>
                          {!isMobile ? (
                            !showBucketsOnLeft ? (
                              <Grid
                                container
                                spacing={1}
                                style={{ marginTop: "1rem" }}
                              >
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    width="100%"
                                  >
                                    <Tabs
                                      value={this.state.auxiliaryTabValue}
                                      onChange={this.switchAuxilliaryTab}
                                      // indicatorColor="primary"
                                      // textColor="primary"
                                      variant="scrollable"
                                      // scrollButtons="auto"
                                      className={classes.createPackageTabs}
                                    >
                                      {this.state.auxBucketsList
                                        .sort((a, b) =>
                                          a && b
                                            ? a.sequenceNum - b.sequenceNum
                                            : 0,
                                        )
                                        .map((bucket, index) => (
                                          <Tab
                                            key={index}
                                            label={bucket.name}
                                            icon={
                                              bucket.iconName ? (
                                                <img
                                                  onError={DefaultProductIcon}
                                                  src={
                                                    constants.imageUrl +
                                                    bucket.iconName
                                                  }
                                                  style={{
                                                    maxWidth: "100px",
                                                    height: "25px",
                                                  }}
                                                />
                                              ) : (
                                                <img
                                                  src={""}
                                                  onError={DefaultProductIcon}
                                                  style={{
                                                    maxWidth: "100px",
                                                    height: "25px",
                                                  }}
                                                />
                                              )
                                            }
                                          />
                                        ))}
                                    </Tabs>
                                  </Box>
                                </Grid>
                                <Box
                                  className={classes.tabUnderLine}
                                  style={{
                                    display: "flex",
                                    marginTop: "2rem",
                                    marginBottom: "1rem",
                                    justifyContent: "center",
                                    width: "100%",
                                  }}
                                ></Box>
                                {productTable()}
                              </Grid>
                            ) : (
                              <Split
                                sizes={[20, 80]} // Initial sizes in percentages
                                minSize={[200, 400]} // Minimum sizes in pixels
                                expandToMin={false}
                                gutterSize={10}
                                gutterAlign="center"
                                snapOffset={30}
                                dragInterval={1}
                                direction="horizontal"
                                cursor="col-resize"
                                className="split"
                              >
                                {/* left */}
                                <div
                                  style={{
                                    overflow: "auto",
                                    borderRight: "1px solid lightgrey",
                                  }}
                                >
                                  <Grid
                                    item
                                    size={{ xs: 12, md: 12 }}
                                    style={{ padding: "1rem" }}
                                  >
                                    <TreeView
                                      data={this.state.auxBucketsList}
                                      switchAuxTab={this.switchAuxTab}
                                      activeTabId={this.state.auxiliaryTabValue}
                                      tenantData={this.props.tenantData}
                                      mode="auxTab"
                                    />
                                  </Grid>
                                </div>
                                {/* right */}
                                <div style={{ overflow: 'auto' }}>
                                  {productTable()}
                                </div>
                              </Split>
                            )
                          ) : (
                            isMobile &&
                            showCategory && (
                              <Drawer
                                anchor="left"
                                // variant='permanant'
                                open={showCategory}
                                onClose={() => {
                                  this.toggleShowCategory();
                                }}
                                // classes={{ paper: classes.drawerPaper }}
                                PaperProps={{
                                  style: {
                                    width: "100%",
                                    maxWidth: "100vw",
                                  },
                                }}
                              >
                                <div>
                                  <div>
                                    <IconButton
                                      onClick={() => {
                                        this.toggleShowCategory();
                                      }}
                                    >
                                      <ChevronLeft />
                                    </IconButton>
                                  </div>
                                  <Card
                                    variant="outlined"
                                    className={"roundedCorners"}
                                  >
                                    {auxList}
                                  </Card>
                                </div>
                              </Drawer>
                            )
                          )}
                          {(isMobile && !showCategory) && productTable()}
                        </Grid>
                      </div>
                    </>
                  )}

                {
                  // (
                  //     (this.state.packageMode === 'edit')
                  //     ||
                  //     (this.state.packageMode === 'promo')
                  //     ||
                  //     (this.state.packageMode === 'CREATE')
                  // ) &&
                  (this.state.parentTabValue === 3 ||
                    this.state.parentTabValue === 4) &&
                  this.state.renderAssociatedConst && (
                    <>
                      {this.state.parentTabValue === 2 ? (
                        <>
                          {this.state.auxBucketsList &&
                            this.state.auxBucketsList.length > 0 ? (
                            <>
                              <AssociatedBucket
                                productTerms={this.state.productTerms}
                                globalProducts={this.state.globalProducts}
                                bucketList={this.state.bucketList}
                                packageMode={this.state.packageMode}
                                selectedBucketId={this.state.selectedBucketId}
                                bucketName={this.state.bucketName}
                                components={this.state.components}
                                isLastBucket={this.state.isLastBucket}
                                bucketSeqNum={this.state.bucketSeqNum}
                                providerType={this.props.providerType}
                                addToCatalog={this.state.addToCatalog}
                                tabValue={this.state.tabValue}
                                currentBucketItems={
                                  this.state.currentBucketItems
                                }
                                currentBucketItemsCount={
                                  this.state.currentBucketItemsCount
                                }
                                providerId={this.props.providerId}
                                error={this.state.error}
                                state={this.state}
                                //pass methods
                                submitPackageJSON={this.submitPackageJSON}
                                expandVariantDetails={
                                  this.expandVariantDetails
                                }
                                expandOtherPrices={this.expandOtherPrices}
                                getAssociatedBucketDetails={
                                  this.getAssociatedBucket
                                }
                                setAssociatedBucketDetails={
                                  this.setAssociatedBucket
                                }
                                removeItemFromBucket={
                                  this.removeItemFromBucket
                                }
                                removeDependsOnChip={this.removeDependsOnChip}
                                changeTableData={this.changeTableData}
                                selectionType={this.state.selectionType}
                                changeSelectionType={this.changeSelectionType}
                                selectionTypeMinLimit={this.state.selectionTypeMinLimit}
                                selectionTypeMaxLimit={this.state.selectionTypeMaxLimit}
                                addLimit={this.state.addLimit}
                                changeAddLimit={this.changeAddLimit}
                                changeSelectionTypeMinLimit={this.changeSelectionTypeMinLimit}
                                changeSelectionTypeMaxLimit={this.changeSelectionTypeMaxLimit}
                                sortTableItems={this.sortTableItems}
                                changeIsViewable={this.changeIsViewable}
                                applySpecialPrice={this.applySpecialPrice}
                                downloadTemplate={this.downloadTemplate}
                                setUnsavedChanges={this.setUnsavedChanges}
                                changeDisplaySequence={
                                  this.changeDisplaySequence
                                }
                                saveAsChange={this.saveAsChange}
                                changeTableCompleteRowData={
                                  this.changeTableCompleteRowData
                                }
                                expandComponentDetails={
                                  this.expandComponentDetails
                                }
                                // Publish tab data
                                expiryDate={this.state.expiryDate}
                                releaseDate={this.state.releaseDate}
                                orderApproval={this.state.orderApproval}
                                billingTriggerPhase={
                                  this.state.billingTriggerPhase
                                }
                                billingTriggerProdId={
                                  this.state.billingTriggerProdId
                                }
                                selectedBucket={this.state.selectedBucket}
                                updateTrigger={this.updateTrigger}
                                // T&C data
                                getPackageBasicDetails={
                                  this.getPackageBasicDetails
                                }
                                addTermsCond={this.addTermsCond}
                                onChangeTerms={this.onChangeTerms}
                                removeTermAndCond={this.removeTermAndCond}
                                editTermAndCond={this.editTermAndCond}
                                updateTermsCond={this.updateTermsCond}
                                basicDetail={this.state.basicDetail}
                                termsText={this.state.termsText}
                                termsUrl={this.state.termsUrl}
                                termCondToEdit={this.state.termCondToEdit}
                                // Assembly Instruction data
                                routing={this.state.routing}
                                onInstructionChange={this.onInstructionChange}
                                removeInstruction={this.removeInstruction}
                                changeInstructionSequence={
                                  this.changeInstructionSequence
                                }
                                onChangeRoutingData={this.onChangeRoutingData}
                                addInstruction={this.addInstruction}
                                setLoading={this.setLoading}
                                approvedForSale={this.state.approvedForSale}
                                submittedForReview={
                                  this.state.submittedForReview
                                }
                                comment={this.state.comment}
                                addPackageReviewComments={
                                  this.addPackageReviewComments
                                }
                                // Pre-quals data
                                preQuals={this.state.preQuals}
                                addPreQual={this.addPreQual}
                                deletePreQual={this.deletePreQual}
                                editPreQual={this.editPreQual}
                                categoryList={this.state.categoryList}
                                originalBucketsData={
                                  this.state.originalBucketsData
                                }
                                // Enrichment
                                addEnrichmentRow={this.addEnrichmentRow}
                                changeEnrichmentRow={this.changeEnrichmentRow}
                                deleteEnrichment={this.deleteEnrichment}
                                channelList={this.state.channelList}
                                expandEnrichmentDetails={
                                  this.expandEnrichmentDetails
                                }
                                goBack={this.goBack}
                                parentTabValue={this.state.parentTabValue}
                                changeBomProductsData={
                                  this.changeBomProductsData
                                }
                                selectedCustomer={
                                  this.state.customerData.length > 0
                                    ? this.state.customerData
                                    : []
                                }
                                selectCustomers={this.selectCustomers}
                                productTermsState={
                                  this.state.productTermsState
                                }
                                productTermsLocale={
                                  this.state.productTermsLocale
                                }
                                changeProductTermsLocale={
                                  this.changeProductTermsLocale
                                }
                                isAddToCatalog={this.state.isAddToCatalog}
                                getAssociatedBucketDetailsBulk={
                                  this.getAssociatedBucketDetailsBulk
                                }
                                termTenure={this.state.termTenure}
                                termTenureUOM={this.state.termTenureUOM}
                                updateOfferingTerm={this.updateOfferingTerm}
                                termNoticePeriod={this.state.termNoticePeriod}
                                termNoticePeriodUOM={
                                  this.state.termNoticePeriodUOM
                                }
                                promoMarkdown={this.state.promoMarkdown}
                                updatePromoMarkdown={this.updatePromoMarkdown}
                                applyPromoMarkdown={this.applyPromoMarkdown}
                                changeTableDataOtherPrice={
                                  this.changeTableDataOtherPrice
                                }
                                status={this.state.status}
                                confirmApprove={this.confirmApprove}
                                productHistoryDetails={
                                  this.state.productHistoryDetails
                                }
                                changeProductStatus={this.changeProductStatus}
                                isMobile={isMobile}
                                showCategory={showCategory}
                                toggleShowCategory={this.toggleShowCategory}
                                blockNavigation={this.blockNavigation}
                                offeringSummary={this.offeringSummary}
                                themeColor={this.props.tenantData.color}

                                changeShowOfferingQty={this.changeShowOfferingQty}
                                showOfferingQty={this.state.showOfferingQty}
                              />
                            </>
                          ) : (
                            <div>
                              <p
                                style={{
                                  lineHeight: "300px",
                                  textAlign: "center",
                                  fontSize: "18px",
                                }}
                              >
                                {t("NO_AUX_PRODUCT_CONFIGURED")}
                              </p>
                            </div>
                          )}
                        </>
                      ) : (
                        <div
                          style={{
                            padding:
                              this.state.parentTabValue === 4
                                ? "0rem"
                                : "1rem",
                          }}
                        >
                          <AssociatedBucket
                            productTerms={this.state.productTerms}
                            globalProducts={this.state.globalProducts}
                            bucketList={this.state.bucketList}
                            packageMode={this.state.packageMode}
                            selectedBucketId={this.state.selectedBucketId}
                            bucketName={this.state.bucketName}
                            components={this.state.components}
                            isLastBucket={this.state.isLastBucket}
                            bucketSeqNum={this.state.bucketSeqNum}
                            providerType={this.props.providerType}
                            addToCatalog={this.state.addToCatalog}
                            tabValue={this.state.tabValue}
                            currentBucketItems={this.state.currentBucketItems}
                            currentBucketItemsCount={
                              this.state.currentBucketItemsCount
                            }
                            providerId={this.props.providerId}
                            error={this.state.error}
                            state={this.state}
                            //pass methods
                            submitPackageJSON={this.submitPackageJSON}
                            expandVariantDetails={this.expandVariantDetails}
                            expandOtherPrices={this.expandOtherPrices}
                            getAssociatedBucketDetails={
                              this.getAssociatedBucket
                            }
                            setAssociatedBucketDetails={
                              this.setAssociatedBucket
                            }
                            removeItemFromBucket={this.removeItemFromBucket}
                            removeDependsOnChip={this.removeDependsOnChip}
                            changeTableData={this.changeTableData}
                            selectionType={this.state.selectionType}
                            changeSelectionType={this.changeSelectionType}
                            selectionTypeMinLimit={this.state.selectionTypeMinLimit}
                            selectionTypeMaxLimit={this.state.selectionTypeMaxLimit}
                            addLimit={this.state.addLimit}
                            changeAddLimit={this.changeAddLimit}
                            changeSelectionTypeMinLimit={this.changeSelectionTypeMinLimit}
                            changeSelectionTypeMaxLimit={this.changeSelectionTypeMaxLimit}
                            sortTableItems={this.sortTableItems}
                            changeIsViewable={this.changeIsViewable}
                            applySpecialPrice={this.applySpecialPrice}
                            downloadTemplate={this.downloadTemplate}
                            setUnsavedChanges={this.setUnsavedChanges}
                            changeDisplaySequence={this.changeDisplaySequence}
                            saveAsChange={this.saveAsChange}
                            changeTableCompleteRowData={
                              this.changeTableCompleteRowData
                            }
                            expandComponentDetails={
                              this.expandComponentDetails
                            }
                            // Publish tab data
                            expiryDate={this.state.expiryDate}
                            releaseDate={this.state.releaseDate}
                            orderApproval={this.state.orderApproval}
                            billingTriggerPhase={
                              this.state.billingTriggerPhase
                            }
                            billingTriggerProdId={
                              this.state.billingTriggerProdId
                            }
                            selectedBucket={this.state.selectedBucket}
                            updateTrigger={this.updateTrigger}
                            // T&C data
                            getPackageBasicDetails={
                              this.getPackageBasicDetails
                            }
                            addTermsCond={this.addTermsCond}
                            onChangeTerms={this.onChangeTerms}
                            removeTermAndCond={this.removeTermAndCond}
                            editTermAndCond={this.editTermAndCond}
                            updateTermsCond={this.updateTermsCond}
                            basicDetail={this.state.basicDetail}
                            termsText={this.state.termsText}
                            termsUrl={this.state.termsUrl}
                            termCondToEdit={this.state.termCondToEdit}
                            // Assembly Instruction data
                            routing={this.state.routing}
                            onInstructionChange={this.onInstructionChange}
                            removeInstruction={this.removeInstruction}
                            changeInstructionSequence={
                              this.changeInstructionSequence
                            }
                            onChangeRoutingData={this.onChangeRoutingData}
                            addInstruction={this.addInstruction}
                            setLoading={this.setLoading}
                            approvedForSale={this.state.approvedForSale}
                            submittedForReview={this.state.submittedForReview}
                            comment={this.state.comment}
                            addPackageReviewComments={
                              this.addPackageReviewComments
                            }
                            // Pre-quals data
                            preQuals={this.state.preQuals}
                            addPreQual={this.addPreQual}
                            deletePreQual={this.deletePreQual}
                            editPreQual={this.editPreQual}
                            categoryList={this.state.categoryList}
                            originalBucketsData={
                              this.state.originalBucketsData
                            }
                            // Enrichment
                            addEnrichmentRow={this.addEnrichmentRow}
                            changeEnrichmentRow={this.changeEnrichmentRow}
                            deleteEnrichment={this.deleteEnrichment}
                            channelList={this.state.channelList}
                            expandEnrichmentDetails={
                              this.expandEnrichmentDetails
                            }
                            goBack={this.goBack}
                            parentTabValue={this.state.parentTabValue}
                            changeBomProductsData={this.changeBomProductsData}
                            selectedCustomer={
                              this.state.customerData.length > 0
                                ? this.state.customerData
                                : []
                            }
                            selectCustomers={this.selectCustomers}
                            productTermsState={this.state.productTermsState}
                            productTermsLocale={this.state.productTermsLocale}
                            changeProductTermsLocale={
                              this.changeProductTermsLocale
                            }
                            isAddToCatalog={this.state.isAddToCatalog}
                            getAssociatedBucketDetailsBulk={
                              this.getAssociatedBucketDetailsBulk
                            }
                            termTenure={this.state.termTenure}
                            termTenureUOM={this.state.termTenureUOM}
                            updateOfferingTerm={this.updateOfferingTerm}
                            termNoticePeriod={this.state.termNoticePeriod}
                            termNoticePeriodUOM={
                              this.state.termNoticePeriodUOM
                            }
                            promoMarkdown={this.state.promoMarkdown}
                            updatePromoMarkdown={this.updatePromoMarkdown}
                            applyPromoMarkdown={this.applyPromoMarkdown}
                            changeTableDataOtherPrice={
                              this.changeTableDataOtherPrice
                            }
                            status={this.state.status}
                            confirmApprove={this.confirmApprove}
                            productHistoryDetails={
                              this.state.productHistoryDetails
                            }
                            changeProductStatus={this.changeProductStatus}
                            isMobile={isMobile}
                            showCategory={showCategory}
                            toggleShowCategory={this.toggleShowCategory}
                            blockNavigation={this.blockNavigation}
                            offeringSummary={this.offeringSummary}
                            showBucketsOnLeft={this.state.showBucketsOnLeft}
                            themeColor={this.props.tenantData.color}

                            changeShowOfferingQty={this.changeShowOfferingQty}
                            showOfferingQty={this.state.showOfferingQty}
                          />
                        </div>
                      )}
                      {this.state.selectedBucketId !== "PROD_COMP_PUBLISH" &&
                        this.state.packageMode !== "promo" && (
                          <Grid
                            container
                            spacing={2}
                            justifyContent="center"
                            style={{ padding: "1rem" }}
                          >
                            <Grid
                              item
                              className="text-right"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              size={{
                                xs: 12,
                              }}
                            >
                              <div>
                                <Button
                                  className="buttonSecondary"
                                  onClick={() => this.goBack()}
                                >
                                  {t("BACK")}
                                </Button>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  float: "right",
                                }}
                              >
                                {this.props.userPerms.includes(
                                  "CATALOG_ADMIN",
                                ) && (
                                    <Button
                                      onClick={() => this.downloadTemplate()}
                                      className={
                                        classes.downloadTemplateButton +
                                        " " +
                                        "buttonSecondary"
                                      }
                                    >
                                      {t("EXPORT_PRODUCT_TEMPLATE")}
                                    </Button>
                                  )}
                                {this.state.selectedBucketId !==
                                  "PROD_COMP_PUBLISH" && (
                                    <Button onClick={() => this.goNext()}>
                                      {t("NEXT")}
                                    </Button>
                                  )}
                              </div>
                            </Grid>
                          </Grid>
                        )}
                      {this.state.packageMode === "promo" &&
                        this.state.bucketList.length > 0 && (
                          <Grid
                            container
                            spacing={2}
                            justifyContent="center"
                            style={{ padding: "1rem" }}
                          >
                            <Grid
                              item
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              size={{
                                xs: 12,
                              }}
                            >
                              {/* <Grid item xs={12}> */}
                              <div>
                                <Button
                                  className="buttonSecondary"
                                  onClick={() => this.goBack()}
                                >
                                  {t("BACK")}
                                </Button>
                              </div>
                              {/* </Grid>
                                                    <Grid item xs={6} className="text-right"> */}
                              <div>
                                {this.state.selectedBucketId !==
                                  "PROD_COMP_PACKAGE" && (
                                    <Button onClick={() => this.goNext()}>
                                      {t("NEXT")}
                                    </Button>
                                  )}
                                {this.state.packageMode === "promo" && (
                                  // this.state.selectedBucketId === "PROD_COMP_PACKAGE" &&
                                  <Button
                                    onClick={() => {
                                      this.applySpecialPrice();
                                    }}
                                    style={{ marginLeft: "15px" }}
                                  >
                                    {t("APPLY_SPECIAL_PRICE")}
                                  </Button>
                                )}
                              </div>
                              {/* </Grid> */}
                            </Grid>
                          </Grid>
                        )}
                    </>
                  )
                }

                {/* <Grid item xs={0} md={3}></Grid> */}
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 9,
                  }}
                >
                  {/* {this.state.packageMode !== 'promo' && this.state.parentTabValue > 0 && (this.state.bucketList.length > 0 && this.state.bucketList[this.state.bucketList.length - 1].id !== this.state.selectedBucketId) &&
                                <Grid container spacing={2} justifyContent="center" style={{ marginTop: '1rem' }}>
                                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Grid item xs={1}>
                                            <Button className='buttonSecondary' onClick={() => this.goBack()}>{t('BACK')}</Button>
                                        </Grid>
                                        <Grid item xs={4} className="text-right">
                                            {this.props.userPerms.includes("CATALOG_ADMIN") &&
                                                <Button onClick={() => this.downloadTemplate()}
                                                    className={classes.downloadTemplateButton + ' ' + 'buttonSecondary'}>
                                                    {t('EXPORT_PRODUCT_TEMPLATE')}
                                                </Button>
                                            }
                                            {this.state.selectedBucketId !== 'PROD_COMP_PUBLISH' &&
                                                <Button onClick={() => this.goNext()}>{t('NEXT')}</Button>
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            } */}
                  {/* {this.state.packageMode === 'promo' && (this.state.bucketList.length > 0) &&
                                        <Grid container spacing={2} justifyContent="center" style={{ marginTop: '1rem' }}>
                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Grid item xs={6}>
                                                    <Button className='buttonSecondary' onClick={() => this.goBack()}>{t('BACK')}</Button>
                                                </Grid>
                                                <Grid item xs={6} className="text-right">
                                                    {this.state.selectedBucketId !== 'PROD_COMP_PACKAGE' &&
                                                        <Button onClick={() => this.goNext()}>{t('NEXT')}</Button>
                                                    }
                                                    {this.state.packageMode === "promo" &&
                                                        // this.state.selectedBucketId === "PROD_COMP_PACKAGE" && 
                                                        (
                                                            <Button
                                                                onClick={() => {
                                                                    this.applySpecialPrice();
                                                                }}
                                                                style={{ marginLeft: '15px' }}
                                                            >
                                                                {t("APPLY_SPECIAL_PRICE")}
                                                            </Button>
                                                        )}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    } */}
                </Grid>
              </div>
            </div>
          )}

          {this.state.showOfferingSummary &&
            <Dialog disableScrollLock={true} maxWidth={'lg'} PaperComponent={this.draggableDialogPaper} fullWidth={true} open={this.state.showOfferingSummary} aria-labelledby="delete-dialog-title">
              <DialogTitle id="draggableDialogPaper" style={{ cursor: 'move' }}>
                <div style={{ display: 'flex' }}>
                  <span style={{ display: 'inline-flex', width: '100%' }}>
                    List of Components Offered with : {this.state.basicDetail.productName}
                  </span>
                  <Tooltip title={t('CLOSE')}>
                    <IconButton onTouchStart={event => this.setState({ showOfferingSummary: false })} onClick={event => this.setState({ showOfferingSummary: false })} aria-label="close">
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText>
                  <OfferingComponents
                    page={this.state.page}
                    perPage={this.state.perPage}
                    goToComponent={this.goToComponent}
                    prettyJson={this.state.prettyJson}
                    productBucketList={this.state.productBucketList}
                    totalProductCountInOffering={this.state.totalProductCountInOffering}
                  />
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={event => this.setState({ showOfferingSummary: false })} color="primary">{t('CLOSE')}</Button>
              </DialogActions>
            </Dialog>
          }

          {/* {this.state.showCustomerDialog &&
                        <Dialog disableScrollLock={true} maxWidth={'sm'} fullWidth={true} PaperComponent={this.draggableDialogPaper} open={this.state.showCustomerDialog} aria-labelledby="import-dialog-title">
                            <DialogTitle id="draggableDialogPaper" style={{ cursor: 'move' }}>
                                <div style={{ display: 'flex' }}>
                                    <span style={{ display: 'inline-flex', width: '95%' }}>
                                        {(this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" || this.props.loggedInUserType === "ECOMMERCE_ADMIN") ?
                                            t('SELECT_SHIPPING_ADDRESS')

                                            :
                                            t('SELECT_CUSTOMER')
                                        }
                                    </span>
                                    <Tooltip title={t('CLOSE')}>
                                        <IconButton onClick={event => this.closeChangeCustomer(false)} aria-label="close">
                                            <CloseIcon />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </DialogTitle>
                            <DialogContent dividers style={{ height: '500px' }}>
                                <ManageCustomersHierarchy
                                    screen="createOffering"
                                    subScreen="productsFilter"
                                    selectCustomers={this.selectCustomers}
                                    customerData={this.state.customerData}
                                />
                            </DialogContent>
                        </Dialog>
                    } */}

          {/* confirm change customer */}
          {/* {this.state.openConfirmCustomer &&
                        <Dialog disableScrollLock={true} maxWidth={'sm'} PaperComponent={this.draggableDialogPaper} fullWidth={true} open={this.state.openConfirmCustomer} aria-labelledby="delete-dialog-title">
                            <DialogTitle id="draggableDialogPaper" style={{ cursor: 'move' }}>
                                {t('CHANGE_CUSTOMER')}
                            </DialogTitle>
                            <DialogContent dividers>
                                <DialogContentText>{t('CHANGE_OFFERING_CUSTOMER_MESSAGE')}</DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={event => this.setState({ openConfirmCustomer: false })} color="primary">{t('NO')}</Button>
                                <Button onClick={event => this.changeCustomer()} color="primary">{t('YES')}</Button>
                            </DialogActions>
                        </Dialog>
                    } */}

          <>
            {this.state.formFields &&
              this.state.formFields.fields &&
              this.state.formFields.fields.length > 0 &&
              this.state.showApprovalTaskForm && (
                <OrderActionDialog
                  data={this.state.formFields}
                  open={this.state.showApprovalTaskForm}
                  close={this.closeActionDialog}
                />
              )}
          </>

          {/* Unsaved changes warning modal */}
          <UnsavedChangesWarning
            open={this.state.openUnsavedChangesModal}
            close={this.closeUnsavedChangesDialog}
          ></UnsavedChangesWarning>

          <Loader loading={this.state.loading} />
          <Prompt
            when={this.state.isBlocking} // Show the prompt only if `isBlocking` is true
            message={this.state.warningMessage}
          />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    roles: state.auth.roles,
    userPerms: state.auth.userPerms,
    providerId: state.auth.tenantId,
    userPerms: state.auth.userPerms,
    providerType: state.auth.providerType,
    providerName: state.auth.providerName,
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
    tenantRoles: state.auth.tenantRoles,
    loggedInUserId: state.auth.loggedInUserId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(CreatePackage)));

// export default CreatePackage
